export const DirectionsRendererData = {
  "result": {
    "geocoded_waypoints": [
      {
        "geocoder_status": "OK",
        "place_id": "ChIJmTA53gE-b0cRyjtiFWmfoxQ",
        "types": [
          "route"
        ]
      },
      {
        "geocoder_status": "OK",
        "place_id": "ChIJ5_bP3nM4b0cR3HABtmi1obw",
        "types": [
          "premise"
        ]
      },
      {
        "geocoder_status": "OK",
        "place_id": "ChIJFaNRaWdPb0cR1_EfirEQEwU",
        "types": [
          "premise"
        ]
      }
    ],
    "routes": [
      {
        "bounds": {
          "south": 46.50316,
          "west": 16.11736,
          "north": 46.697880000000005,
          "east": 16.27853
        },
        "copyrights": "Map data ©2024 Google",
        "legs": [
          {
            "distance": {
              "text": "32.2 km",
              "value": 32172
            },
            "duration": {
              "text": "37 mins",
              "value": 2240
            },
            "end_address": "Nunska Graba 17, 9240 Ljutomer, Slovenia",
            "end_location": {
              "lat": 46.5031611,
              "lng": 16.2286604
            },
            "start_address": "Brezovci, 9201 Puconci, Slovenia",
            "start_location": {
              "lat": 46.6972578,
              "lng": 16.1173631
            },
            "steps": [
              {
                "distance": {
                  "text": "0.4 km",
                  "value": 433
                },
                "duration": {
                  "text": "1 min",
                  "value": 57
                },
                "end_location": {
                  "lat": 46.6978775,
                  "lng": 16.1229543
                },
                "polyline": {
                  "points": "{p_|Go|jaB?E?EAKKgASkBGs@?CIy@YuCIcAAO?M@KK_BMeGIuD"
                },
                "start_location": {
                  "lat": 46.6972578,
                  "lng": 16.1173631
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "{p_|Go|jaB?E?EAKKgASkBGs@?CIy@YuCIcAAO?M@KK_BMeGIuD",
                "path": [
                  {
                    "lat": 46.69726000000001,
                    "lng": 16.11736
                  },
                  {
                    "lat": 46.69726000000001,
                    "lng": 16.11739
                  },
                  {
                    "lat": 46.69726000000001,
                    "lng": 16.117420000000003
                  },
                  {
                    "lat": 46.69727,
                    "lng": 16.11748
                  },
                  {
                    "lat": 46.69733,
                    "lng": 16.11784
                  },
                  {
                    "lat": 46.697430000000004,
                    "lng": 16.118380000000002
                  },
                  {
                    "lat": 46.69747,
                    "lng": 16.118640000000003
                  },
                  {
                    "lat": 46.69747,
                    "lng": 16.118660000000002
                  },
                  {
                    "lat": 46.697520000000004,
                    "lng": 16.11895
                  },
                  {
                    "lat": 46.69765,
                    "lng": 16.1197
                  },
                  {
                    "lat": 46.697700000000005,
                    "lng": 16.120040000000003
                  },
                  {
                    "lat": 46.69771,
                    "lng": 16.12012
                  },
                  {
                    "lat": 46.69771,
                    "lng": 16.12019
                  },
                  {
                    "lat": 46.697700000000005,
                    "lng": 16.120250000000002
                  },
                  {
                    "lat": 46.69776,
                    "lng": 16.120730000000002
                  },
                  {
                    "lat": 46.69783,
                    "lng": 16.122040000000002
                  },
                  {
                    "lat": 46.697880000000005,
                    "lng": 16.122950000000003
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.69726000000001,
                    "lng": 16.11736
                  },
                  {
                    "lat": 46.69726000000001,
                    "lng": 16.11739
                  },
                  {
                    "lat": 46.69726000000001,
                    "lng": 16.117420000000003
                  },
                  {
                    "lat": 46.69727,
                    "lng": 16.11748
                  },
                  {
                    "lat": 46.69733,
                    "lng": 16.11784
                  },
                  {
                    "lat": 46.697430000000004,
                    "lng": 16.118380000000002
                  },
                  {
                    "lat": 46.69747,
                    "lng": 16.118640000000003
                  },
                  {
                    "lat": 46.69747,
                    "lng": 16.118660000000002
                  },
                  {
                    "lat": 46.697520000000004,
                    "lng": 16.11895
                  },
                  {
                    "lat": 46.69765,
                    "lng": 16.1197
                  },
                  {
                    "lat": 46.697700000000005,
                    "lng": 16.120040000000003
                  },
                  {
                    "lat": 46.69771,
                    "lng": 16.12012
                  },
                  {
                    "lat": 46.69771,
                    "lng": 16.12019
                  },
                  {
                    "lat": 46.697700000000005,
                    "lng": 16.120250000000002
                  },
                  {
                    "lat": 46.69776,
                    "lng": 16.120730000000002
                  },
                  {
                    "lat": 46.69783,
                    "lng": 16.122040000000002
                  },
                  {
                    "lat": 46.697880000000005,
                    "lng": 16.122950000000003
                  }
                ],
                "instructions": "Head <b>east</b> on <b>Predanovci</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.6972578,
                  "lng": 16.1173631
                },
                "end_point": {
                  "lat": 46.6978775,
                  "lng": 16.1229543
                }
              },
              {
                "distance": {
                  "text": "2.3 km",
                  "value": 2263
                },
                "duration": {
                  "text": "3 mins",
                  "value": 168
                },
                "end_location": {
                  "lat": 46.6827391,
                  "lng": 16.1380646
                },
                "maneuver": "turn-right",
                "polyline": {
                  "points": "wt_|Gm_laBb@CZGVIj@U^Gn@MREDANEBALENIjAu@xA}@DEzAcAXQfAy@h@a@FEDCLGDAFCLCHCJAJCHAd@Ct@E`BGj@CTAPAt@Gf@EVCLCh@IXE`@KTGPETGLEl@S`@O\\KPEZI\\GTA|@GpBS~@KZENEJCFA@AJELG\\U~CaCrDwCdAy@VU`@]\\_@X]T]Va@d@{@hA}Bb@cAh@sAx@cCfA_DVs@Rm@Nk@DWDWHk@@GDa@Bi@Dm@FwAH}AJyBNqCFmAJsB@M@UBm@@O@I@EBMBMBK"
                },
                "start_location": {
                  "lat": 46.6978775,
                  "lng": 16.1229543
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "wt_|Gm_laBb@CZGVIj@U^Gn@MREDANEBALENIjAu@xA}@DEzAcAXQfAy@h@a@FEDCLGDAFCLCHCJAJCHAd@Ct@E`BGj@CTAPAt@Gf@EVCLCh@IXE`@KTGPETGLEl@S`@O\\KPEZI\\GTA|@GpBS~@KZENEJCFA@AJELG\\U~CaCrDwCdAy@VU`@]\\_@X]T]Va@d@{@hA}Bb@cAh@sAx@cCfA_DVs@Rm@Nk@DWDWHk@@GDa@Bi@Dm@FwAH}AJyBNqCFmAJsB@M@UBm@@O@I@EBMBMBK",
                "path": [
                  {
                    "lat": 46.697880000000005,
                    "lng": 16.122950000000003
                  },
                  {
                    "lat": 46.697700000000005,
                    "lng": 16.122970000000002
                  },
                  {
                    "lat": 46.69756,
                    "lng": 16.12301
                  },
                  {
                    "lat": 46.69744,
                    "lng": 16.123060000000002
                  },
                  {
                    "lat": 46.69722,
                    "lng": 16.123170000000002
                  },
                  {
                    "lat": 46.69706,
                    "lng": 16.12321
                  },
                  {
                    "lat": 46.69682,
                    "lng": 16.12328
                  },
                  {
                    "lat": 46.696720000000006,
                    "lng": 16.12331
                  },
                  {
                    "lat": 46.696690000000004,
                    "lng": 16.12332
                  },
                  {
                    "lat": 46.69661000000001,
                    "lng": 16.123350000000002
                  },
                  {
                    "lat": 46.69659,
                    "lng": 16.12336
                  },
                  {
                    "lat": 46.69652000000001,
                    "lng": 16.12339
                  },
                  {
                    "lat": 46.69644,
                    "lng": 16.123440000000002
                  },
                  {
                    "lat": 46.69606,
                    "lng": 16.123710000000003
                  },
                  {
                    "lat": 46.69561,
                    "lng": 16.12402
                  },
                  {
                    "lat": 46.69558000000001,
                    "lng": 16.12405
                  },
                  {
                    "lat": 46.69512,
                    "lng": 16.124390000000002
                  },
                  {
                    "lat": 46.694990000000004,
                    "lng": 16.124480000000002
                  },
                  {
                    "lat": 46.694630000000004,
                    "lng": 16.12477
                  },
                  {
                    "lat": 46.69442,
                    "lng": 16.124940000000002
                  },
                  {
                    "lat": 46.69438,
                    "lng": 16.12497
                  },
                  {
                    "lat": 46.69435000000001,
                    "lng": 16.12499
                  },
                  {
                    "lat": 46.694280000000006,
                    "lng": 16.125030000000002
                  },
                  {
                    "lat": 46.694250000000004,
                    "lng": 16.125040000000002
                  },
                  {
                    "lat": 46.694210000000005,
                    "lng": 16.12506
                  },
                  {
                    "lat": 46.694140000000004,
                    "lng": 16.12508
                  },
                  {
                    "lat": 46.69409,
                    "lng": 16.1251
                  },
                  {
                    "lat": 46.694030000000005,
                    "lng": 16.125110000000003
                  },
                  {
                    "lat": 46.69397000000001,
                    "lng": 16.125130000000002
                  },
                  {
                    "lat": 46.693920000000006,
                    "lng": 16.125140000000002
                  },
                  {
                    "lat": 46.69373,
                    "lng": 16.12516
                  },
                  {
                    "lat": 46.69346,
                    "lng": 16.12519
                  },
                  {
                    "lat": 46.69297,
                    "lng": 16.125230000000002
                  },
                  {
                    "lat": 46.692750000000004,
                    "lng": 16.12525
                  },
                  {
                    "lat": 46.692640000000004,
                    "lng": 16.12526
                  },
                  {
                    "lat": 46.692550000000004,
                    "lng": 16.12527
                  },
                  {
                    "lat": 46.692280000000004,
                    "lng": 16.125310000000002
                  },
                  {
                    "lat": 46.692080000000004,
                    "lng": 16.12534
                  },
                  {
                    "lat": 46.69196,
                    "lng": 16.12536
                  },
                  {
                    "lat": 46.69189,
                    "lng": 16.12538
                  },
                  {
                    "lat": 46.691680000000005,
                    "lng": 16.12543
                  },
                  {
                    "lat": 46.69155000000001,
                    "lng": 16.12546
                  },
                  {
                    "lat": 46.69138,
                    "lng": 16.12552
                  },
                  {
                    "lat": 46.69127,
                    "lng": 16.12556
                  },
                  {
                    "lat": 46.69118,
                    "lng": 16.125590000000003
                  },
                  {
                    "lat": 46.69107,
                    "lng": 16.12563
                  },
                  {
                    "lat": 46.691,
                    "lng": 16.12566
                  },
                  {
                    "lat": 46.69077,
                    "lng": 16.12576
                  },
                  {
                    "lat": 46.6906,
                    "lng": 16.12584
                  },
                  {
                    "lat": 46.690450000000006,
                    "lng": 16.1259
                  },
                  {
                    "lat": 46.690360000000005,
                    "lng": 16.12593
                  },
                  {
                    "lat": 46.690220000000004,
                    "lng": 16.125980000000002
                  },
                  {
                    "lat": 46.690070000000006,
                    "lng": 16.12602
                  },
                  {
                    "lat": 46.689960000000006,
                    "lng": 16.12603
                  },
                  {
                    "lat": 46.68965,
                    "lng": 16.126070000000002
                  },
                  {
                    "lat": 46.689080000000004,
                    "lng": 16.126170000000002
                  },
                  {
                    "lat": 46.68876,
                    "lng": 16.12623
                  },
                  {
                    "lat": 46.68862000000001,
                    "lng": 16.126260000000002
                  },
                  {
                    "lat": 46.68854,
                    "lng": 16.12629
                  },
                  {
                    "lat": 46.688480000000006,
                    "lng": 16.12631
                  },
                  {
                    "lat": 46.68844000000001,
                    "lng": 16.12632
                  },
                  {
                    "lat": 46.688430000000004,
                    "lng": 16.126330000000003
                  },
                  {
                    "lat": 46.688370000000006,
                    "lng": 16.126360000000002
                  },
                  {
                    "lat": 46.688300000000005,
                    "lng": 16.1264
                  },
                  {
                    "lat": 46.68815000000001,
                    "lng": 16.12651
                  },
                  {
                    "lat": 46.68735,
                    "lng": 16.12716
                  },
                  {
                    "lat": 46.68645,
                    "lng": 16.12792
                  },
                  {
                    "lat": 46.6861,
                    "lng": 16.128210000000003
                  },
                  {
                    "lat": 46.68598,
                    "lng": 16.128320000000002
                  },
                  {
                    "lat": 46.685810000000004,
                    "lng": 16.12847
                  },
                  {
                    "lat": 46.685660000000006,
                    "lng": 16.12863
                  },
                  {
                    "lat": 46.68553000000001,
                    "lng": 16.128780000000003
                  },
                  {
                    "lat": 46.68542,
                    "lng": 16.12893
                  },
                  {
                    "lat": 46.685300000000005,
                    "lng": 16.1291
                  },
                  {
                    "lat": 46.68511,
                    "lng": 16.1294
                  },
                  {
                    "lat": 46.684740000000005,
                    "lng": 16.13003
                  },
                  {
                    "lat": 46.684560000000005,
                    "lng": 16.130370000000003
                  },
                  {
                    "lat": 46.68435,
                    "lng": 16.13079
                  },
                  {
                    "lat": 46.68406,
                    "lng": 16.13145
                  },
                  {
                    "lat": 46.6837,
                    "lng": 16.132250000000003
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.13251
                  },
                  {
                    "lat": 46.68348,
                    "lng": 16.132740000000002
                  },
                  {
                    "lat": 46.683400000000006,
                    "lng": 16.13296
                  },
                  {
                    "lat": 46.683370000000004,
                    "lng": 16.13308
                  },
                  {
                    "lat": 46.68334,
                    "lng": 16.133200000000002
                  },
                  {
                    "lat": 46.68329000000001,
                    "lng": 16.13342
                  },
                  {
                    "lat": 46.68328,
                    "lng": 16.133460000000003
                  },
                  {
                    "lat": 46.68325,
                    "lng": 16.13363
                  },
                  {
                    "lat": 46.68323,
                    "lng": 16.133840000000003
                  },
                  {
                    "lat": 46.68320000000001,
                    "lng": 16.13407
                  },
                  {
                    "lat": 46.68316,
                    "lng": 16.134510000000002
                  },
                  {
                    "lat": 46.683110000000006,
                    "lng": 16.134980000000002
                  },
                  {
                    "lat": 46.68305,
                    "lng": 16.13559
                  },
                  {
                    "lat": 46.682970000000005,
                    "lng": 16.13632
                  },
                  {
                    "lat": 46.682930000000006,
                    "lng": 16.13671
                  },
                  {
                    "lat": 46.68287,
                    "lng": 16.13729
                  },
                  {
                    "lat": 46.682860000000005,
                    "lng": 16.13736
                  },
                  {
                    "lat": 46.68285,
                    "lng": 16.13747
                  },
                  {
                    "lat": 46.68283,
                    "lng": 16.137700000000002
                  },
                  {
                    "lat": 46.68282000000001,
                    "lng": 16.137780000000003
                  },
                  {
                    "lat": 46.68281,
                    "lng": 16.13783
                  },
                  {
                    "lat": 46.6828,
                    "lng": 16.13786
                  },
                  {
                    "lat": 46.68278,
                    "lng": 16.13793
                  },
                  {
                    "lat": 46.68276,
                    "lng": 16.138
                  },
                  {
                    "lat": 46.68274,
                    "lng": 16.138060000000003
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.697880000000005,
                    "lng": 16.122950000000003
                  },
                  {
                    "lat": 46.697700000000005,
                    "lng": 16.122970000000002
                  },
                  {
                    "lat": 46.69756,
                    "lng": 16.12301
                  },
                  {
                    "lat": 46.69744,
                    "lng": 16.123060000000002
                  },
                  {
                    "lat": 46.69722,
                    "lng": 16.123170000000002
                  },
                  {
                    "lat": 46.69706,
                    "lng": 16.12321
                  },
                  {
                    "lat": 46.69682,
                    "lng": 16.12328
                  },
                  {
                    "lat": 46.696720000000006,
                    "lng": 16.12331
                  },
                  {
                    "lat": 46.696690000000004,
                    "lng": 16.12332
                  },
                  {
                    "lat": 46.69661000000001,
                    "lng": 16.123350000000002
                  },
                  {
                    "lat": 46.69659,
                    "lng": 16.12336
                  },
                  {
                    "lat": 46.69652000000001,
                    "lng": 16.12339
                  },
                  {
                    "lat": 46.69644,
                    "lng": 16.123440000000002
                  },
                  {
                    "lat": 46.69606,
                    "lng": 16.123710000000003
                  },
                  {
                    "lat": 46.69561,
                    "lng": 16.12402
                  },
                  {
                    "lat": 46.69558000000001,
                    "lng": 16.12405
                  },
                  {
                    "lat": 46.69512,
                    "lng": 16.124390000000002
                  },
                  {
                    "lat": 46.694990000000004,
                    "lng": 16.124480000000002
                  },
                  {
                    "lat": 46.694630000000004,
                    "lng": 16.12477
                  },
                  {
                    "lat": 46.69442,
                    "lng": 16.124940000000002
                  },
                  {
                    "lat": 46.69438,
                    "lng": 16.12497
                  },
                  {
                    "lat": 46.69435000000001,
                    "lng": 16.12499
                  },
                  {
                    "lat": 46.694280000000006,
                    "lng": 16.125030000000002
                  },
                  {
                    "lat": 46.694250000000004,
                    "lng": 16.125040000000002
                  },
                  {
                    "lat": 46.694210000000005,
                    "lng": 16.12506
                  },
                  {
                    "lat": 46.694140000000004,
                    "lng": 16.12508
                  },
                  {
                    "lat": 46.69409,
                    "lng": 16.1251
                  },
                  {
                    "lat": 46.694030000000005,
                    "lng": 16.125110000000003
                  },
                  {
                    "lat": 46.69397000000001,
                    "lng": 16.125130000000002
                  },
                  {
                    "lat": 46.693920000000006,
                    "lng": 16.125140000000002
                  },
                  {
                    "lat": 46.69373,
                    "lng": 16.12516
                  },
                  {
                    "lat": 46.69346,
                    "lng": 16.12519
                  },
                  {
                    "lat": 46.69297,
                    "lng": 16.125230000000002
                  },
                  {
                    "lat": 46.692750000000004,
                    "lng": 16.12525
                  },
                  {
                    "lat": 46.692640000000004,
                    "lng": 16.12526
                  },
                  {
                    "lat": 46.692550000000004,
                    "lng": 16.12527
                  },
                  {
                    "lat": 46.692280000000004,
                    "lng": 16.125310000000002
                  },
                  {
                    "lat": 46.692080000000004,
                    "lng": 16.12534
                  },
                  {
                    "lat": 46.69196,
                    "lng": 16.12536
                  },
                  {
                    "lat": 46.69189,
                    "lng": 16.12538
                  },
                  {
                    "lat": 46.691680000000005,
                    "lng": 16.12543
                  },
                  {
                    "lat": 46.69155000000001,
                    "lng": 16.12546
                  },
                  {
                    "lat": 46.69138,
                    "lng": 16.12552
                  },
                  {
                    "lat": 46.69127,
                    "lng": 16.12556
                  },
                  {
                    "lat": 46.69118,
                    "lng": 16.125590000000003
                  },
                  {
                    "lat": 46.69107,
                    "lng": 16.12563
                  },
                  {
                    "lat": 46.691,
                    "lng": 16.12566
                  },
                  {
                    "lat": 46.69077,
                    "lng": 16.12576
                  },
                  {
                    "lat": 46.6906,
                    "lng": 16.12584
                  },
                  {
                    "lat": 46.690450000000006,
                    "lng": 16.1259
                  },
                  {
                    "lat": 46.690360000000005,
                    "lng": 16.12593
                  },
                  {
                    "lat": 46.690220000000004,
                    "lng": 16.125980000000002
                  },
                  {
                    "lat": 46.690070000000006,
                    "lng": 16.12602
                  },
                  {
                    "lat": 46.689960000000006,
                    "lng": 16.12603
                  },
                  {
                    "lat": 46.68965,
                    "lng": 16.126070000000002
                  },
                  {
                    "lat": 46.689080000000004,
                    "lng": 16.126170000000002
                  },
                  {
                    "lat": 46.68876,
                    "lng": 16.12623
                  },
                  {
                    "lat": 46.68862000000001,
                    "lng": 16.126260000000002
                  },
                  {
                    "lat": 46.68854,
                    "lng": 16.12629
                  },
                  {
                    "lat": 46.688480000000006,
                    "lng": 16.12631
                  },
                  {
                    "lat": 46.68844000000001,
                    "lng": 16.12632
                  },
                  {
                    "lat": 46.688430000000004,
                    "lng": 16.126330000000003
                  },
                  {
                    "lat": 46.688370000000006,
                    "lng": 16.126360000000002
                  },
                  {
                    "lat": 46.688300000000005,
                    "lng": 16.1264
                  },
                  {
                    "lat": 46.68815000000001,
                    "lng": 16.12651
                  },
                  {
                    "lat": 46.68735,
                    "lng": 16.12716
                  },
                  {
                    "lat": 46.68645,
                    "lng": 16.12792
                  },
                  {
                    "lat": 46.6861,
                    "lng": 16.128210000000003
                  },
                  {
                    "lat": 46.68598,
                    "lng": 16.128320000000002
                  },
                  {
                    "lat": 46.685810000000004,
                    "lng": 16.12847
                  },
                  {
                    "lat": 46.685660000000006,
                    "lng": 16.12863
                  },
                  {
                    "lat": 46.68553000000001,
                    "lng": 16.128780000000003
                  },
                  {
                    "lat": 46.68542,
                    "lng": 16.12893
                  },
                  {
                    "lat": 46.685300000000005,
                    "lng": 16.1291
                  },
                  {
                    "lat": 46.68511,
                    "lng": 16.1294
                  },
                  {
                    "lat": 46.684740000000005,
                    "lng": 16.13003
                  },
                  {
                    "lat": 46.684560000000005,
                    "lng": 16.130370000000003
                  },
                  {
                    "lat": 46.68435,
                    "lng": 16.13079
                  },
                  {
                    "lat": 46.68406,
                    "lng": 16.13145
                  },
                  {
                    "lat": 46.6837,
                    "lng": 16.132250000000003
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.13251
                  },
                  {
                    "lat": 46.68348,
                    "lng": 16.132740000000002
                  },
                  {
                    "lat": 46.683400000000006,
                    "lng": 16.13296
                  },
                  {
                    "lat": 46.683370000000004,
                    "lng": 16.13308
                  },
                  {
                    "lat": 46.68334,
                    "lng": 16.133200000000002
                  },
                  {
                    "lat": 46.68329000000001,
                    "lng": 16.13342
                  },
                  {
                    "lat": 46.68328,
                    "lng": 16.133460000000003
                  },
                  {
                    "lat": 46.68325,
                    "lng": 16.13363
                  },
                  {
                    "lat": 46.68323,
                    "lng": 16.133840000000003
                  },
                  {
                    "lat": 46.68320000000001,
                    "lng": 16.13407
                  },
                  {
                    "lat": 46.68316,
                    "lng": 16.134510000000002
                  },
                  {
                    "lat": 46.683110000000006,
                    "lng": 16.134980000000002
                  },
                  {
                    "lat": 46.68305,
                    "lng": 16.13559
                  },
                  {
                    "lat": 46.682970000000005,
                    "lng": 16.13632
                  },
                  {
                    "lat": 46.682930000000006,
                    "lng": 16.13671
                  },
                  {
                    "lat": 46.68287,
                    "lng": 16.13729
                  },
                  {
                    "lat": 46.682860000000005,
                    "lng": 16.13736
                  },
                  {
                    "lat": 46.68285,
                    "lng": 16.13747
                  },
                  {
                    "lat": 46.68283,
                    "lng": 16.137700000000002
                  },
                  {
                    "lat": 46.68282000000001,
                    "lng": 16.137780000000003
                  },
                  {
                    "lat": 46.68281,
                    "lng": 16.13783
                  },
                  {
                    "lat": 46.6828,
                    "lng": 16.13786
                  },
                  {
                    "lat": 46.68278,
                    "lng": 16.13793
                  },
                  {
                    "lat": 46.68276,
                    "lng": 16.138
                  },
                  {
                    "lat": 46.68274,
                    "lng": 16.138060000000003
                  }
                ],
                "instructions": "Turn <b>right</b> to stay on <b>Predanovci</b>",
                "start_point": {
                  "lat": 46.6978775,
                  "lng": 16.1229543
                },
                "end_point": {
                  "lat": 46.6827391,
                  "lng": 16.1380646
                }
              },
              {
                "distance": {
                  "text": "50 m",
                  "value": 50
                },
                "duration": {
                  "text": "1 min",
                  "value": 6
                },
                "end_location": {
                  "lat": 46.6830416,
                  "lng": 16.1383292
                },
                "maneuver": "roundabout-right",
                "polyline": {
                  "points": "cv|{G{}naB?A@?@A?A@??A?A?A@?A?@??A?A?AAA?A?A?AA??AA??AA??AA?A?A?A@a@GGEECCE"
                },
                "start_location": {
                  "lat": 46.6827391,
                  "lng": 16.1380646
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "cv|{G{}naB?A@?@A?A@??A?A?A@?A?@??A?A?AAA?A?A?AA??AA??AA??AA?A?A?A@a@GGEECCE",
                "path": [
                  {
                    "lat": 46.68274,
                    "lng": 16.138060000000003
                  },
                  {
                    "lat": 46.68274,
                    "lng": 16.138070000000003
                  },
                  {
                    "lat": 46.68273000000001,
                    "lng": 16.138070000000003
                  },
                  {
                    "lat": 46.68272,
                    "lng": 16.138080000000002
                  },
                  {
                    "lat": 46.68272,
                    "lng": 16.138090000000002
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.138090000000002
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.1381
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.13811
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.13812
                  },
                  {
                    "lat": 46.682700000000004,
                    "lng": 16.13812
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.13812
                  },
                  {
                    "lat": 46.682700000000004,
                    "lng": 16.13812
                  },
                  {
                    "lat": 46.682700000000004,
                    "lng": 16.13813
                  },
                  {
                    "lat": 46.682700000000004,
                    "lng": 16.13814
                  },
                  {
                    "lat": 46.682700000000004,
                    "lng": 16.13815
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.138160000000003
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.138170000000002
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.138180000000002
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.13819
                  },
                  {
                    "lat": 46.68272,
                    "lng": 16.13819
                  },
                  {
                    "lat": 46.68272,
                    "lng": 16.1382
                  },
                  {
                    "lat": 46.68273000000001,
                    "lng": 16.1382
                  },
                  {
                    "lat": 46.68273000000001,
                    "lng": 16.13821
                  },
                  {
                    "lat": 46.68274,
                    "lng": 16.13821
                  },
                  {
                    "lat": 46.68274,
                    "lng": 16.13822
                  },
                  {
                    "lat": 46.682750000000006,
                    "lng": 16.13822
                  },
                  {
                    "lat": 46.68276,
                    "lng": 16.13822
                  },
                  {
                    "lat": 46.682770000000005,
                    "lng": 16.13822
                  },
                  {
                    "lat": 46.68278,
                    "lng": 16.13821
                  },
                  {
                    "lat": 46.682950000000005,
                    "lng": 16.138250000000003
                  },
                  {
                    "lat": 46.682990000000004,
                    "lng": 16.13828
                  },
                  {
                    "lat": 46.683020000000006,
                    "lng": 16.1383
                  },
                  {
                    "lat": 46.683040000000005,
                    "lng": 16.13833
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.68274,
                    "lng": 16.138060000000003
                  },
                  {
                    "lat": 46.68274,
                    "lng": 16.138070000000003
                  },
                  {
                    "lat": 46.68273000000001,
                    "lng": 16.138070000000003
                  },
                  {
                    "lat": 46.68272,
                    "lng": 16.138080000000002
                  },
                  {
                    "lat": 46.68272,
                    "lng": 16.138090000000002
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.138090000000002
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.1381
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.13811
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.13812
                  },
                  {
                    "lat": 46.682700000000004,
                    "lng": 16.13812
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.13812
                  },
                  {
                    "lat": 46.682700000000004,
                    "lng": 16.13812
                  },
                  {
                    "lat": 46.682700000000004,
                    "lng": 16.13813
                  },
                  {
                    "lat": 46.682700000000004,
                    "lng": 16.13814
                  },
                  {
                    "lat": 46.682700000000004,
                    "lng": 16.13815
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.138160000000003
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.138170000000002
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.138180000000002
                  },
                  {
                    "lat": 46.68271000000001,
                    "lng": 16.13819
                  },
                  {
                    "lat": 46.68272,
                    "lng": 16.13819
                  },
                  {
                    "lat": 46.68272,
                    "lng": 16.1382
                  },
                  {
                    "lat": 46.68273000000001,
                    "lng": 16.1382
                  },
                  {
                    "lat": 46.68273000000001,
                    "lng": 16.13821
                  },
                  {
                    "lat": 46.68274,
                    "lng": 16.13821
                  },
                  {
                    "lat": 46.68274,
                    "lng": 16.13822
                  },
                  {
                    "lat": 46.682750000000006,
                    "lng": 16.13822
                  },
                  {
                    "lat": 46.68276,
                    "lng": 16.13822
                  },
                  {
                    "lat": 46.682770000000005,
                    "lng": 16.13822
                  },
                  {
                    "lat": 46.68278,
                    "lng": 16.13821
                  },
                  {
                    "lat": 46.682950000000005,
                    "lng": 16.138250000000003
                  },
                  {
                    "lat": 46.682990000000004,
                    "lng": 16.13828
                  },
                  {
                    "lat": 46.683020000000006,
                    "lng": 16.1383
                  },
                  {
                    "lat": 46.683040000000005,
                    "lng": 16.13833
                  }
                ],
                "instructions": "At the roundabout, take the <b>2nd</b> exit onto <b>Polana</b>",
                "start_point": {
                  "lat": 46.6827391,
                  "lng": 16.1380646
                },
                "end_point": {
                  "lat": 46.6830416,
                  "lng": 16.1383292
                }
              },
              {
                "distance": {
                  "text": "1.2 km",
                  "value": 1170
                },
                "duration": {
                  "text": "1 min",
                  "value": 70
                },
                "end_location": {
                  "lat": 46.6844461,
                  "lng": 16.1532758
                },
                "maneuver": "turn-right",
                "polyline": {
                  "points": "_x|{Gq_oaBKa@IYEOEMAKAKAKAWCgBCg@Ei@Ky@QoAK}@Ea@C[ASAS?Y?_@?[?g@@eB@y@?g@As@Co@G}@Eu@Es@AYAW?O?]?[@[Dk@Di@B_@Bg@B]@_@@g@?w@@cB?_@@qE?OA]Ac@E_@Iw@E_@AU?U?UAU?S?KAYAOCQa@_CY_B?AKo@Mm@a@yBIa@CGAG?CAC?EA{@"
                },
                "start_location": {
                  "lat": 46.6830416,
                  "lng": 16.1383292
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "_x|{Gq_oaBKa@IYEOEMAKAKAKAWCgBCg@Ei@Ky@QoAK}@Ea@C[ASAS?Y?_@?[?g@@eB@y@?g@As@Co@G}@Eu@Es@AYAW?O?]?[@[Dk@Di@B_@Bg@B]@_@@g@?w@@cB?_@@qE?OA]Ac@E_@Iw@E_@AU?U?UAU?S?KAYAOCQa@_CY_B?AKo@Mm@a@yBIa@CGAG?CAC?EA{@",
                "path": [
                  {
                    "lat": 46.683040000000005,
                    "lng": 16.13833
                  },
                  {
                    "lat": 46.6831,
                    "lng": 16.1385
                  },
                  {
                    "lat": 46.683150000000005,
                    "lng": 16.138630000000003
                  },
                  {
                    "lat": 46.68318000000001,
                    "lng": 16.13871
                  },
                  {
                    "lat": 46.68321,
                    "lng": 16.13878
                  },
                  {
                    "lat": 46.683220000000006,
                    "lng": 16.138840000000002
                  },
                  {
                    "lat": 46.68323,
                    "lng": 16.1389
                  },
                  {
                    "lat": 46.683240000000005,
                    "lng": 16.13896
                  },
                  {
                    "lat": 46.68325,
                    "lng": 16.13908
                  },
                  {
                    "lat": 46.68327000000001,
                    "lng": 16.1396
                  },
                  {
                    "lat": 46.68329000000001,
                    "lng": 16.1398
                  },
                  {
                    "lat": 46.68332,
                    "lng": 16.14001
                  },
                  {
                    "lat": 46.68338000000001,
                    "lng": 16.1403
                  },
                  {
                    "lat": 46.68347000000001,
                    "lng": 16.140700000000002
                  },
                  {
                    "lat": 46.683530000000005,
                    "lng": 16.14101
                  },
                  {
                    "lat": 46.68356000000001,
                    "lng": 16.141180000000002
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.14132
                  },
                  {
                    "lat": 46.68359,
                    "lng": 16.14142
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.14152
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.141650000000002
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.14181
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.14195
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.14215
                  },
                  {
                    "lat": 46.68359,
                    "lng": 16.142660000000003
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.142950000000003
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.143150000000002
                  },
                  {
                    "lat": 46.68359,
                    "lng": 16.143410000000003
                  },
                  {
                    "lat": 46.68361,
                    "lng": 16.14365
                  },
                  {
                    "lat": 46.68365000000001,
                    "lng": 16.14396
                  },
                  {
                    "lat": 46.68368,
                    "lng": 16.14423
                  },
                  {
                    "lat": 46.683710000000005,
                    "lng": 16.14449
                  },
                  {
                    "lat": 46.68372,
                    "lng": 16.14462
                  },
                  {
                    "lat": 46.683730000000004,
                    "lng": 16.144740000000002
                  },
                  {
                    "lat": 46.683730000000004,
                    "lng": 16.144820000000003
                  },
                  {
                    "lat": 46.683730000000004,
                    "lng": 16.14497
                  },
                  {
                    "lat": 46.683730000000004,
                    "lng": 16.145110000000003
                  },
                  {
                    "lat": 46.68372,
                    "lng": 16.14525
                  },
                  {
                    "lat": 46.683690000000006,
                    "lng": 16.145470000000003
                  },
                  {
                    "lat": 46.68366,
                    "lng": 16.145680000000002
                  },
                  {
                    "lat": 46.683640000000004,
                    "lng": 16.14584
                  },
                  {
                    "lat": 46.683620000000005,
                    "lng": 16.146040000000003
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.14619
                  },
                  {
                    "lat": 46.68359,
                    "lng": 16.14635
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.14655
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.14683
                  },
                  {
                    "lat": 46.68357,
                    "lng": 16.14733
                  },
                  {
                    "lat": 46.68357,
                    "lng": 16.14749
                  },
                  {
                    "lat": 46.68356000000001,
                    "lng": 16.14854
                  },
                  {
                    "lat": 46.68356000000001,
                    "lng": 16.14862
                  },
                  {
                    "lat": 46.68357,
                    "lng": 16.148770000000003
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.148950000000003
                  },
                  {
                    "lat": 46.68361,
                    "lng": 16.14911
                  },
                  {
                    "lat": 46.68366,
                    "lng": 16.14939
                  },
                  {
                    "lat": 46.683690000000006,
                    "lng": 16.14955
                  },
                  {
                    "lat": 46.6837,
                    "lng": 16.14966
                  },
                  {
                    "lat": 46.6837,
                    "lng": 16.14977
                  },
                  {
                    "lat": 46.6837,
                    "lng": 16.14988
                  },
                  {
                    "lat": 46.683710000000005,
                    "lng": 16.149990000000003
                  },
                  {
                    "lat": 46.683710000000005,
                    "lng": 16.150090000000002
                  },
                  {
                    "lat": 46.683710000000005,
                    "lng": 16.15015
                  },
                  {
                    "lat": 46.68372,
                    "lng": 16.150280000000002
                  },
                  {
                    "lat": 46.683730000000004,
                    "lng": 16.150360000000003
                  },
                  {
                    "lat": 46.68375,
                    "lng": 16.150450000000003
                  },
                  {
                    "lat": 46.68392,
                    "lng": 16.15109
                  },
                  {
                    "lat": 46.684050000000006,
                    "lng": 16.151570000000003
                  },
                  {
                    "lat": 46.684050000000006,
                    "lng": 16.151580000000003
                  },
                  {
                    "lat": 46.684110000000004,
                    "lng": 16.15182
                  },
                  {
                    "lat": 46.684180000000005,
                    "lng": 16.152050000000003
                  },
                  {
                    "lat": 46.68435,
                    "lng": 16.15266
                  },
                  {
                    "lat": 46.684400000000004,
                    "lng": 16.15283
                  },
                  {
                    "lat": 46.68442,
                    "lng": 16.15287
                  },
                  {
                    "lat": 46.684430000000006,
                    "lng": 16.152910000000002
                  },
                  {
                    "lat": 46.684430000000006,
                    "lng": 16.15293
                  },
                  {
                    "lat": 46.68444,
                    "lng": 16.15295
                  },
                  {
                    "lat": 46.68444,
                    "lng": 16.152980000000003
                  },
                  {
                    "lat": 46.684450000000005,
                    "lng": 16.153280000000002
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.683040000000005,
                    "lng": 16.13833
                  },
                  {
                    "lat": 46.6831,
                    "lng": 16.1385
                  },
                  {
                    "lat": 46.683150000000005,
                    "lng": 16.138630000000003
                  },
                  {
                    "lat": 46.68318000000001,
                    "lng": 16.13871
                  },
                  {
                    "lat": 46.68321,
                    "lng": 16.13878
                  },
                  {
                    "lat": 46.683220000000006,
                    "lng": 16.138840000000002
                  },
                  {
                    "lat": 46.68323,
                    "lng": 16.1389
                  },
                  {
                    "lat": 46.683240000000005,
                    "lng": 16.13896
                  },
                  {
                    "lat": 46.68325,
                    "lng": 16.13908
                  },
                  {
                    "lat": 46.68327000000001,
                    "lng": 16.1396
                  },
                  {
                    "lat": 46.68329000000001,
                    "lng": 16.1398
                  },
                  {
                    "lat": 46.68332,
                    "lng": 16.14001
                  },
                  {
                    "lat": 46.68338000000001,
                    "lng": 16.1403
                  },
                  {
                    "lat": 46.68347000000001,
                    "lng": 16.140700000000002
                  },
                  {
                    "lat": 46.683530000000005,
                    "lng": 16.14101
                  },
                  {
                    "lat": 46.68356000000001,
                    "lng": 16.141180000000002
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.14132
                  },
                  {
                    "lat": 46.68359,
                    "lng": 16.14142
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.14152
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.141650000000002
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.14181
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.14195
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.14215
                  },
                  {
                    "lat": 46.68359,
                    "lng": 16.142660000000003
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.142950000000003
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.143150000000002
                  },
                  {
                    "lat": 46.68359,
                    "lng": 16.143410000000003
                  },
                  {
                    "lat": 46.68361,
                    "lng": 16.14365
                  },
                  {
                    "lat": 46.68365000000001,
                    "lng": 16.14396
                  },
                  {
                    "lat": 46.68368,
                    "lng": 16.14423
                  },
                  {
                    "lat": 46.683710000000005,
                    "lng": 16.14449
                  },
                  {
                    "lat": 46.68372,
                    "lng": 16.14462
                  },
                  {
                    "lat": 46.683730000000004,
                    "lng": 16.144740000000002
                  },
                  {
                    "lat": 46.683730000000004,
                    "lng": 16.144820000000003
                  },
                  {
                    "lat": 46.683730000000004,
                    "lng": 16.14497
                  },
                  {
                    "lat": 46.683730000000004,
                    "lng": 16.145110000000003
                  },
                  {
                    "lat": 46.68372,
                    "lng": 16.14525
                  },
                  {
                    "lat": 46.683690000000006,
                    "lng": 16.145470000000003
                  },
                  {
                    "lat": 46.68366,
                    "lng": 16.145680000000002
                  },
                  {
                    "lat": 46.683640000000004,
                    "lng": 16.14584
                  },
                  {
                    "lat": 46.683620000000005,
                    "lng": 16.146040000000003
                  },
                  {
                    "lat": 46.683600000000006,
                    "lng": 16.14619
                  },
                  {
                    "lat": 46.68359,
                    "lng": 16.14635
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.14655
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.14683
                  },
                  {
                    "lat": 46.68357,
                    "lng": 16.14733
                  },
                  {
                    "lat": 46.68357,
                    "lng": 16.14749
                  },
                  {
                    "lat": 46.68356000000001,
                    "lng": 16.14854
                  },
                  {
                    "lat": 46.68356000000001,
                    "lng": 16.14862
                  },
                  {
                    "lat": 46.68357,
                    "lng": 16.148770000000003
                  },
                  {
                    "lat": 46.683580000000006,
                    "lng": 16.148950000000003
                  },
                  {
                    "lat": 46.68361,
                    "lng": 16.14911
                  },
                  {
                    "lat": 46.68366,
                    "lng": 16.14939
                  },
                  {
                    "lat": 46.683690000000006,
                    "lng": 16.14955
                  },
                  {
                    "lat": 46.6837,
                    "lng": 16.14966
                  },
                  {
                    "lat": 46.6837,
                    "lng": 16.14977
                  },
                  {
                    "lat": 46.6837,
                    "lng": 16.14988
                  },
                  {
                    "lat": 46.683710000000005,
                    "lng": 16.149990000000003
                  },
                  {
                    "lat": 46.683710000000005,
                    "lng": 16.150090000000002
                  },
                  {
                    "lat": 46.683710000000005,
                    "lng": 16.15015
                  },
                  {
                    "lat": 46.68372,
                    "lng": 16.150280000000002
                  },
                  {
                    "lat": 46.683730000000004,
                    "lng": 16.150360000000003
                  },
                  {
                    "lat": 46.68375,
                    "lng": 16.150450000000003
                  },
                  {
                    "lat": 46.68392,
                    "lng": 16.15109
                  },
                  {
                    "lat": 46.684050000000006,
                    "lng": 16.151570000000003
                  },
                  {
                    "lat": 46.684050000000006,
                    "lng": 16.151580000000003
                  },
                  {
                    "lat": 46.684110000000004,
                    "lng": 16.15182
                  },
                  {
                    "lat": 46.684180000000005,
                    "lng": 16.152050000000003
                  },
                  {
                    "lat": 46.68435,
                    "lng": 16.15266
                  },
                  {
                    "lat": 46.684400000000004,
                    "lng": 16.15283
                  },
                  {
                    "lat": 46.68442,
                    "lng": 16.15287
                  },
                  {
                    "lat": 46.684430000000006,
                    "lng": 16.152910000000002
                  },
                  {
                    "lat": 46.684430000000006,
                    "lng": 16.15293
                  },
                  {
                    "lat": 46.68444,
                    "lng": 16.15295
                  },
                  {
                    "lat": 46.68444,
                    "lng": 16.152980000000003
                  },
                  {
                    "lat": 46.684450000000005,
                    "lng": 16.153280000000002
                  }
                ],
                "instructions": "Turn <b>right</b>",
                "start_point": {
                  "lat": 46.6830416,
                  "lng": 16.1383292
                },
                "end_point": {
                  "lat": 46.6844461,
                  "lng": 16.1532758
                }
              },
              {
                "distance": {
                  "text": "2.2 km",
                  "value": 2170
                },
                "duration": {
                  "text": "3 mins",
                  "value": 173
                },
                "end_location": {
                  "lat": 46.67273429999999,
                  "lng": 16.1673376
                },
                "polyline": {
                  "points": "y`}{G_}qaB?wC?aDAs@?wHAcF?kCAqE?s@?}B?k@AgB?qCA_DJc@HOLMRKRIb@Qt@Y^QLCJCNCNA\\CVERFv@V\\LdB`@hARZBV?NA\\GrAa@`@ITAX?XBz@Nl@JVBZ?l@In@KPAV?L?z@Pd@JF@N@D@d@?h@Cl@El@ChAEd@At@Ox@k@ZWdAiAFEz@y@b@a@^[h@k@f@m@p@kAj@cAp@oA\\i@\\e@b@g@rAiB"
                },
                "start_location": {
                  "lat": 46.6844461,
                  "lng": 16.1532758
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "y`}{G_}qaB?wC?aDAs@?wHAcF?kCAqE?s@?}B?k@AgB?qCA_DJc@HOLMRKRIb@Qt@Y^QLCJCNCNA\\CVERFv@V\\LdB`@hARZBV?NA\\GrAa@`@ITAX?XBz@Nl@JVBZ?l@In@KPAV?L?z@Pd@JF@N@D@d@?h@Cl@El@ChAEd@At@Ox@k@ZWdAiAFEz@y@b@a@^[h@k@f@m@p@kAj@cAp@oA\\i@\\e@b@g@rAiB",
                "path": [
                  {
                    "lat": 46.684450000000005,
                    "lng": 16.153280000000002
                  },
                  {
                    "lat": 46.684450000000005,
                    "lng": 16.154040000000002
                  },
                  {
                    "lat": 46.684450000000005,
                    "lng": 16.15485
                  },
                  {
                    "lat": 46.68446,
                    "lng": 16.15511
                  },
                  {
                    "lat": 46.68446,
                    "lng": 16.156670000000002
                  },
                  {
                    "lat": 46.684470000000005,
                    "lng": 16.15781
                  },
                  {
                    "lat": 46.684470000000005,
                    "lng": 16.15851
                  },
                  {
                    "lat": 46.68448,
                    "lng": 16.159560000000003
                  },
                  {
                    "lat": 46.68448,
                    "lng": 16.15982
                  },
                  {
                    "lat": 46.68448,
                    "lng": 16.16045
                  },
                  {
                    "lat": 46.68448,
                    "lng": 16.16067
                  },
                  {
                    "lat": 46.684490000000004,
                    "lng": 16.16119
                  },
                  {
                    "lat": 46.684490000000004,
                    "lng": 16.161920000000002
                  },
                  {
                    "lat": 46.68450000000001,
                    "lng": 16.16272
                  },
                  {
                    "lat": 46.68444,
                    "lng": 16.1629
                  },
                  {
                    "lat": 46.68439,
                    "lng": 16.16298
                  },
                  {
                    "lat": 46.68432000000001,
                    "lng": 16.163050000000002
                  },
                  {
                    "lat": 46.68422,
                    "lng": 16.16311
                  },
                  {
                    "lat": 46.68412000000001,
                    "lng": 16.16316
                  },
                  {
                    "lat": 46.68394000000001,
                    "lng": 16.16325
                  },
                  {
                    "lat": 46.683670000000006,
                    "lng": 16.16338
                  },
                  {
                    "lat": 46.683510000000005,
                    "lng": 16.16347
                  },
                  {
                    "lat": 46.683440000000004,
                    "lng": 16.163490000000003
                  },
                  {
                    "lat": 46.68338000000001,
                    "lng": 16.163510000000002
                  },
                  {
                    "lat": 46.6833,
                    "lng": 16.16353
                  },
                  {
                    "lat": 46.683220000000006,
                    "lng": 16.16354
                  },
                  {
                    "lat": 46.68307,
                    "lng": 16.16356
                  },
                  {
                    "lat": 46.682950000000005,
                    "lng": 16.163590000000003
                  },
                  {
                    "lat": 46.68285,
                    "lng": 16.16355
                  },
                  {
                    "lat": 46.682570000000005,
                    "lng": 16.16343
                  },
                  {
                    "lat": 46.68242,
                    "lng": 16.16336
                  },
                  {
                    "lat": 46.68191,
                    "lng": 16.16319
                  },
                  {
                    "lat": 46.681540000000005,
                    "lng": 16.16309
                  },
                  {
                    "lat": 46.681400000000004,
                    "lng": 16.16307
                  },
                  {
                    "lat": 46.68128,
                    "lng": 16.16307
                  },
                  {
                    "lat": 46.681200000000004,
                    "lng": 16.16308
                  },
                  {
                    "lat": 46.681050000000006,
                    "lng": 16.163120000000003
                  },
                  {
                    "lat": 46.68063,
                    "lng": 16.16329
                  },
                  {
                    "lat": 46.680460000000004,
                    "lng": 16.16334
                  },
                  {
                    "lat": 46.680350000000004,
                    "lng": 16.16335
                  },
                  {
                    "lat": 46.680220000000006,
                    "lng": 16.16335
                  },
                  {
                    "lat": 46.68009000000001,
                    "lng": 16.163330000000002
                  },
                  {
                    "lat": 46.679790000000004,
                    "lng": 16.16325
                  },
                  {
                    "lat": 46.67956,
                    "lng": 16.16319
                  },
                  {
                    "lat": 46.67944000000001,
                    "lng": 16.16317
                  },
                  {
                    "lat": 46.679300000000005,
                    "lng": 16.16317
                  },
                  {
                    "lat": 46.67907,
                    "lng": 16.163220000000003
                  },
                  {
                    "lat": 46.678830000000005,
                    "lng": 16.16328
                  },
                  {
                    "lat": 46.678740000000005,
                    "lng": 16.16329
                  },
                  {
                    "lat": 46.67862,
                    "lng": 16.16329
                  },
                  {
                    "lat": 46.67855,
                    "lng": 16.16329
                  },
                  {
                    "lat": 46.678250000000006,
                    "lng": 16.1632
                  },
                  {
                    "lat": 46.67806,
                    "lng": 16.163140000000002
                  },
                  {
                    "lat": 46.678020000000004,
                    "lng": 16.163130000000002
                  },
                  {
                    "lat": 46.67794000000001,
                    "lng": 16.163120000000003
                  },
                  {
                    "lat": 46.677910000000004,
                    "lng": 16.16311
                  },
                  {
                    "lat": 46.67772,
                    "lng": 16.16311
                  },
                  {
                    "lat": 46.677510000000005,
                    "lng": 16.163130000000002
                  },
                  {
                    "lat": 46.67728,
                    "lng": 16.16316
                  },
                  {
                    "lat": 46.67705,
                    "lng": 16.16318
                  },
                  {
                    "lat": 46.676680000000005,
                    "lng": 16.163210000000003
                  },
                  {
                    "lat": 46.67649,
                    "lng": 16.163220000000003
                  },
                  {
                    "lat": 46.67622,
                    "lng": 16.1633
                  },
                  {
                    "lat": 46.67593,
                    "lng": 16.163520000000002
                  },
                  {
                    "lat": 46.675790000000006,
                    "lng": 16.16364
                  },
                  {
                    "lat": 46.67544,
                    "lng": 16.16401
                  },
                  {
                    "lat": 46.6754,
                    "lng": 16.16404
                  },
                  {
                    "lat": 46.6751,
                    "lng": 16.16433
                  },
                  {
                    "lat": 46.67492000000001,
                    "lng": 16.1645
                  },
                  {
                    "lat": 46.674760000000006,
                    "lng": 16.164640000000002
                  },
                  {
                    "lat": 46.67455,
                    "lng": 16.16486
                  },
                  {
                    "lat": 46.674350000000004,
                    "lng": 16.165090000000003
                  },
                  {
                    "lat": 46.6741,
                    "lng": 16.165470000000003
                  },
                  {
                    "lat": 46.673880000000004,
                    "lng": 16.16581
                  },
                  {
                    "lat": 46.67363,
                    "lng": 16.166210000000003
                  },
                  {
                    "lat": 46.673480000000005,
                    "lng": 16.166420000000002
                  },
                  {
                    "lat": 46.67333000000001,
                    "lng": 16.166610000000002
                  },
                  {
                    "lat": 46.67315000000001,
                    "lng": 16.16681
                  },
                  {
                    "lat": 46.67273,
                    "lng": 16.167340000000003
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.684450000000005,
                    "lng": 16.153280000000002
                  },
                  {
                    "lat": 46.684450000000005,
                    "lng": 16.154040000000002
                  },
                  {
                    "lat": 46.684450000000005,
                    "lng": 16.15485
                  },
                  {
                    "lat": 46.68446,
                    "lng": 16.15511
                  },
                  {
                    "lat": 46.68446,
                    "lng": 16.156670000000002
                  },
                  {
                    "lat": 46.684470000000005,
                    "lng": 16.15781
                  },
                  {
                    "lat": 46.684470000000005,
                    "lng": 16.15851
                  },
                  {
                    "lat": 46.68448,
                    "lng": 16.159560000000003
                  },
                  {
                    "lat": 46.68448,
                    "lng": 16.15982
                  },
                  {
                    "lat": 46.68448,
                    "lng": 16.16045
                  },
                  {
                    "lat": 46.68448,
                    "lng": 16.16067
                  },
                  {
                    "lat": 46.684490000000004,
                    "lng": 16.16119
                  },
                  {
                    "lat": 46.684490000000004,
                    "lng": 16.161920000000002
                  },
                  {
                    "lat": 46.68450000000001,
                    "lng": 16.16272
                  },
                  {
                    "lat": 46.68444,
                    "lng": 16.1629
                  },
                  {
                    "lat": 46.68439,
                    "lng": 16.16298
                  },
                  {
                    "lat": 46.68432000000001,
                    "lng": 16.163050000000002
                  },
                  {
                    "lat": 46.68422,
                    "lng": 16.16311
                  },
                  {
                    "lat": 46.68412000000001,
                    "lng": 16.16316
                  },
                  {
                    "lat": 46.68394000000001,
                    "lng": 16.16325
                  },
                  {
                    "lat": 46.683670000000006,
                    "lng": 16.16338
                  },
                  {
                    "lat": 46.683510000000005,
                    "lng": 16.16347
                  },
                  {
                    "lat": 46.683440000000004,
                    "lng": 16.163490000000003
                  },
                  {
                    "lat": 46.68338000000001,
                    "lng": 16.163510000000002
                  },
                  {
                    "lat": 46.6833,
                    "lng": 16.16353
                  },
                  {
                    "lat": 46.683220000000006,
                    "lng": 16.16354
                  },
                  {
                    "lat": 46.68307,
                    "lng": 16.16356
                  },
                  {
                    "lat": 46.682950000000005,
                    "lng": 16.163590000000003
                  },
                  {
                    "lat": 46.68285,
                    "lng": 16.16355
                  },
                  {
                    "lat": 46.682570000000005,
                    "lng": 16.16343
                  },
                  {
                    "lat": 46.68242,
                    "lng": 16.16336
                  },
                  {
                    "lat": 46.68191,
                    "lng": 16.16319
                  },
                  {
                    "lat": 46.681540000000005,
                    "lng": 16.16309
                  },
                  {
                    "lat": 46.681400000000004,
                    "lng": 16.16307
                  },
                  {
                    "lat": 46.68128,
                    "lng": 16.16307
                  },
                  {
                    "lat": 46.681200000000004,
                    "lng": 16.16308
                  },
                  {
                    "lat": 46.681050000000006,
                    "lng": 16.163120000000003
                  },
                  {
                    "lat": 46.68063,
                    "lng": 16.16329
                  },
                  {
                    "lat": 46.680460000000004,
                    "lng": 16.16334
                  },
                  {
                    "lat": 46.680350000000004,
                    "lng": 16.16335
                  },
                  {
                    "lat": 46.680220000000006,
                    "lng": 16.16335
                  },
                  {
                    "lat": 46.68009000000001,
                    "lng": 16.163330000000002
                  },
                  {
                    "lat": 46.679790000000004,
                    "lng": 16.16325
                  },
                  {
                    "lat": 46.67956,
                    "lng": 16.16319
                  },
                  {
                    "lat": 46.67944000000001,
                    "lng": 16.16317
                  },
                  {
                    "lat": 46.679300000000005,
                    "lng": 16.16317
                  },
                  {
                    "lat": 46.67907,
                    "lng": 16.163220000000003
                  },
                  {
                    "lat": 46.678830000000005,
                    "lng": 16.16328
                  },
                  {
                    "lat": 46.678740000000005,
                    "lng": 16.16329
                  },
                  {
                    "lat": 46.67862,
                    "lng": 16.16329
                  },
                  {
                    "lat": 46.67855,
                    "lng": 16.16329
                  },
                  {
                    "lat": 46.678250000000006,
                    "lng": 16.1632
                  },
                  {
                    "lat": 46.67806,
                    "lng": 16.163140000000002
                  },
                  {
                    "lat": 46.678020000000004,
                    "lng": 16.163130000000002
                  },
                  {
                    "lat": 46.67794000000001,
                    "lng": 16.163120000000003
                  },
                  {
                    "lat": 46.677910000000004,
                    "lng": 16.16311
                  },
                  {
                    "lat": 46.67772,
                    "lng": 16.16311
                  },
                  {
                    "lat": 46.677510000000005,
                    "lng": 16.163130000000002
                  },
                  {
                    "lat": 46.67728,
                    "lng": 16.16316
                  },
                  {
                    "lat": 46.67705,
                    "lng": 16.16318
                  },
                  {
                    "lat": 46.676680000000005,
                    "lng": 16.163210000000003
                  },
                  {
                    "lat": 46.67649,
                    "lng": 16.163220000000003
                  },
                  {
                    "lat": 46.67622,
                    "lng": 16.1633
                  },
                  {
                    "lat": 46.67593,
                    "lng": 16.163520000000002
                  },
                  {
                    "lat": 46.675790000000006,
                    "lng": 16.16364
                  },
                  {
                    "lat": 46.67544,
                    "lng": 16.16401
                  },
                  {
                    "lat": 46.6754,
                    "lng": 16.16404
                  },
                  {
                    "lat": 46.6751,
                    "lng": 16.16433
                  },
                  {
                    "lat": 46.67492000000001,
                    "lng": 16.1645
                  },
                  {
                    "lat": 46.674760000000006,
                    "lng": 16.164640000000002
                  },
                  {
                    "lat": 46.67455,
                    "lng": 16.16486
                  },
                  {
                    "lat": 46.674350000000004,
                    "lng": 16.165090000000003
                  },
                  {
                    "lat": 46.6741,
                    "lng": 16.165470000000003
                  },
                  {
                    "lat": 46.673880000000004,
                    "lng": 16.16581
                  },
                  {
                    "lat": 46.67363,
                    "lng": 16.166210000000003
                  },
                  {
                    "lat": 46.673480000000005,
                    "lng": 16.166420000000002
                  },
                  {
                    "lat": 46.67333000000001,
                    "lng": 16.166610000000002
                  },
                  {
                    "lat": 46.67315000000001,
                    "lng": 16.16681
                  },
                  {
                    "lat": 46.67273,
                    "lng": 16.167340000000003
                  }
                ],
                "instructions": "Continue onto <b>Markišavci</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.6844461,
                  "lng": 16.1532758
                },
                "end_point": {
                  "lat": 46.67273429999999,
                  "lng": 16.1673376
                }
              },
              {
                "distance": {
                  "text": "0.9 km",
                  "value": 944
                },
                "duration": {
                  "text": "1 min",
                  "value": 79
                },
                "end_location": {
                  "lat": 46.66722040000001,
                  "lng": 16.1766399
                },
                "polyline": {
                  "points": "qwz{G{ttaB@C`@i@l@o@t@s@d@e@Za@LULWr@mBh@sA\\q@P_@f@gAz@gBt@eBh@{An@cBv@{Ad@cAj@eAn@eAj@kAn@sA^u@p@qARg@FMFKJMz@cCPi@"
                },
                "start_location": {
                  "lat": 46.67273429999999,
                  "lng": 16.1673376
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "qwz{G{ttaB@C`@i@l@o@t@s@d@e@Za@LULWr@mBh@sA\\q@P_@f@gAz@gBt@eBh@{An@cBv@{Ad@cAj@eAn@eAj@kAn@sA^u@p@qARg@FMFKJMz@cCPi@",
                "path": [
                  {
                    "lat": 46.67273,
                    "lng": 16.167340000000003
                  },
                  {
                    "lat": 46.672720000000005,
                    "lng": 16.167360000000002
                  },
                  {
                    "lat": 46.67255,
                    "lng": 16.16757
                  },
                  {
                    "lat": 46.672320000000006,
                    "lng": 16.167810000000003
                  },
                  {
                    "lat": 46.672050000000006,
                    "lng": 16.16807
                  },
                  {
                    "lat": 46.67186,
                    "lng": 16.16826
                  },
                  {
                    "lat": 46.67172,
                    "lng": 16.16843
                  },
                  {
                    "lat": 46.67165000000001,
                    "lng": 16.16854
                  },
                  {
                    "lat": 46.671580000000006,
                    "lng": 16.168660000000003
                  },
                  {
                    "lat": 46.67132,
                    "lng": 16.16921
                  },
                  {
                    "lat": 46.671110000000006,
                    "lng": 16.16963
                  },
                  {
                    "lat": 46.67096,
                    "lng": 16.169880000000003
                  },
                  {
                    "lat": 46.67087,
                    "lng": 16.17004
                  },
                  {
                    "lat": 46.67067,
                    "lng": 16.1704
                  },
                  {
                    "lat": 46.670370000000005,
                    "lng": 16.170920000000002
                  },
                  {
                    "lat": 46.670100000000005,
                    "lng": 16.17143
                  },
                  {
                    "lat": 46.66989,
                    "lng": 16.17189
                  },
                  {
                    "lat": 46.669650000000004,
                    "lng": 16.17239
                  },
                  {
                    "lat": 46.66937,
                    "lng": 16.17285
                  },
                  {
                    "lat": 46.669180000000004,
                    "lng": 16.17319
                  },
                  {
                    "lat": 46.668960000000006,
                    "lng": 16.173540000000003
                  },
                  {
                    "lat": 46.66872,
                    "lng": 16.17389
                  },
                  {
                    "lat": 46.6685,
                    "lng": 16.17427
                  },
                  {
                    "lat": 46.668260000000004,
                    "lng": 16.174690000000002
                  },
                  {
                    "lat": 46.6681,
                    "lng": 16.174960000000002
                  },
                  {
                    "lat": 46.66785,
                    "lng": 16.17537
                  },
                  {
                    "lat": 46.667750000000005,
                    "lng": 16.17557
                  },
                  {
                    "lat": 46.66771000000001,
                    "lng": 16.17564
                  },
                  {
                    "lat": 46.66767,
                    "lng": 16.175700000000003
                  },
                  {
                    "lat": 46.66761,
                    "lng": 16.17577
                  },
                  {
                    "lat": 46.66731,
                    "lng": 16.17643
                  },
                  {
                    "lat": 46.66722,
                    "lng": 16.176640000000003
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.67273,
                    "lng": 16.167340000000003
                  },
                  {
                    "lat": 46.672720000000005,
                    "lng": 16.167360000000002
                  },
                  {
                    "lat": 46.67255,
                    "lng": 16.16757
                  },
                  {
                    "lat": 46.672320000000006,
                    "lng": 16.167810000000003
                  },
                  {
                    "lat": 46.672050000000006,
                    "lng": 16.16807
                  },
                  {
                    "lat": 46.67186,
                    "lng": 16.16826
                  },
                  {
                    "lat": 46.67172,
                    "lng": 16.16843
                  },
                  {
                    "lat": 46.67165000000001,
                    "lng": 16.16854
                  },
                  {
                    "lat": 46.671580000000006,
                    "lng": 16.168660000000003
                  },
                  {
                    "lat": 46.67132,
                    "lng": 16.16921
                  },
                  {
                    "lat": 46.671110000000006,
                    "lng": 16.16963
                  },
                  {
                    "lat": 46.67096,
                    "lng": 16.169880000000003
                  },
                  {
                    "lat": 46.67087,
                    "lng": 16.17004
                  },
                  {
                    "lat": 46.67067,
                    "lng": 16.1704
                  },
                  {
                    "lat": 46.670370000000005,
                    "lng": 16.170920000000002
                  },
                  {
                    "lat": 46.670100000000005,
                    "lng": 16.17143
                  },
                  {
                    "lat": 46.66989,
                    "lng": 16.17189
                  },
                  {
                    "lat": 46.669650000000004,
                    "lng": 16.17239
                  },
                  {
                    "lat": 46.66937,
                    "lng": 16.17285
                  },
                  {
                    "lat": 46.669180000000004,
                    "lng": 16.17319
                  },
                  {
                    "lat": 46.668960000000006,
                    "lng": 16.173540000000003
                  },
                  {
                    "lat": 46.66872,
                    "lng": 16.17389
                  },
                  {
                    "lat": 46.6685,
                    "lng": 16.17427
                  },
                  {
                    "lat": 46.668260000000004,
                    "lng": 16.174690000000002
                  },
                  {
                    "lat": 46.6681,
                    "lng": 16.174960000000002
                  },
                  {
                    "lat": 46.66785,
                    "lng": 16.17537
                  },
                  {
                    "lat": 46.667750000000005,
                    "lng": 16.17557
                  },
                  {
                    "lat": 46.66771000000001,
                    "lng": 16.17564
                  },
                  {
                    "lat": 46.66767,
                    "lng": 16.175700000000003
                  },
                  {
                    "lat": 46.66761,
                    "lng": 16.17577
                  },
                  {
                    "lat": 46.66731,
                    "lng": 16.17643
                  },
                  {
                    "lat": 46.66722,
                    "lng": 16.176640000000003
                  }
                ],
                "instructions": "Continue onto <b>Markišavska ulica</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.67273429999999,
                  "lng": 16.1673376
                },
                "end_point": {
                  "lat": 46.66722040000001,
                  "lng": 16.1766399
                }
              },
              {
                "distance": {
                  "text": "0.2 km",
                  "value": 241
                },
                "duration": {
                  "text": "1 min",
                  "value": 30
                },
                "end_location": {
                  "lat": 46.6655464,
                  "lng": 16.1748107
                },
                "maneuver": "roundabout-right",
                "polyline": {
                  "points": "cuy{G_ovaBBAB?BCBCdAhADFFFRPd@^\\`@l@h@^^NNNVJRJXFVBP"
                },
                "start_location": {
                  "lat": 46.66722040000001,
                  "lng": 16.1766399
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "cuy{G_ovaBBAB?BCBCdAhADFFFRPd@^\\`@l@h@^^NNNVJRJXFVBP",
                "path": [
                  {
                    "lat": 46.66722,
                    "lng": 16.176640000000003
                  },
                  {
                    "lat": 46.6672,
                    "lng": 16.176650000000002
                  },
                  {
                    "lat": 46.66718,
                    "lng": 16.176650000000002
                  },
                  {
                    "lat": 46.66716,
                    "lng": 16.17667
                  },
                  {
                    "lat": 46.66714,
                    "lng": 16.17669
                  },
                  {
                    "lat": 46.666790000000006,
                    "lng": 16.17632
                  },
                  {
                    "lat": 46.666760000000004,
                    "lng": 16.176280000000002
                  },
                  {
                    "lat": 46.666720000000005,
                    "lng": 16.17624
                  },
                  {
                    "lat": 46.66662,
                    "lng": 16.17615
                  },
                  {
                    "lat": 46.666430000000005,
                    "lng": 16.175990000000002
                  },
                  {
                    "lat": 46.66628,
                    "lng": 16.17582
                  },
                  {
                    "lat": 46.666050000000006,
                    "lng": 16.175610000000002
                  },
                  {
                    "lat": 46.665890000000005,
                    "lng": 16.17545
                  },
                  {
                    "lat": 46.66581,
                    "lng": 16.17537
                  },
                  {
                    "lat": 46.66573,
                    "lng": 16.175250000000002
                  },
                  {
                    "lat": 46.665670000000006,
                    "lng": 16.175150000000002
                  },
                  {
                    "lat": 46.66561,
                    "lng": 16.17502
                  },
                  {
                    "lat": 46.66557,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66555,
                    "lng": 16.17481
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.66722,
                    "lng": 16.176640000000003
                  },
                  {
                    "lat": 46.6672,
                    "lng": 16.176650000000002
                  },
                  {
                    "lat": 46.66718,
                    "lng": 16.176650000000002
                  },
                  {
                    "lat": 46.66716,
                    "lng": 16.17667
                  },
                  {
                    "lat": 46.66714,
                    "lng": 16.17669
                  },
                  {
                    "lat": 46.666790000000006,
                    "lng": 16.17632
                  },
                  {
                    "lat": 46.666760000000004,
                    "lng": 16.176280000000002
                  },
                  {
                    "lat": 46.666720000000005,
                    "lng": 16.17624
                  },
                  {
                    "lat": 46.66662,
                    "lng": 16.17615
                  },
                  {
                    "lat": 46.666430000000005,
                    "lng": 16.175990000000002
                  },
                  {
                    "lat": 46.66628,
                    "lng": 16.17582
                  },
                  {
                    "lat": 46.666050000000006,
                    "lng": 16.175610000000002
                  },
                  {
                    "lat": 46.665890000000005,
                    "lng": 16.17545
                  },
                  {
                    "lat": 46.66581,
                    "lng": 16.17537
                  },
                  {
                    "lat": 46.66573,
                    "lng": 16.175250000000002
                  },
                  {
                    "lat": 46.665670000000006,
                    "lng": 16.175150000000002
                  },
                  {
                    "lat": 46.66561,
                    "lng": 16.17502
                  },
                  {
                    "lat": 46.66557,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66555,
                    "lng": 16.17481
                  }
                ],
                "instructions": "At the roundabout, take the <b>1st</b> exit onto <b>Lendavska ulica</b> heading to <b>Center</b>/<wbr/><b>Lendava</b>/<wbr/><b>Maribor</b>",
                "start_point": {
                  "lat": 46.66722040000001,
                  "lng": 16.1766399
                },
                "end_point": {
                  "lat": 46.6655464,
                  "lng": 16.1748107
                }
              },
              {
                "distance": {
                  "text": "1.0 km",
                  "value": 1038
                },
                "duration": {
                  "text": "2 mins",
                  "value": 90
                },
                "end_location": {
                  "lat": 46.6568128,
                  "lng": 16.1719352
                },
                "maneuver": "roundabout-right",
                "polyline": {
                  "points": "ujy{GqcvaBAFCF?FAJ@B?B?@@B?@@B?@@@@@?@@@@@?@@?@@@@F@D?DADABCBEBGBITMFC`@M`AS@?r@IB?D?B?H?F?H@z@Tz@ZNDh@PNDNDPFPDXHnA^pRxFNDzC|@tF|ARLNDJDVH"
                },
                "start_location": {
                  "lat": 46.6655464,
                  "lng": 16.1748107
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "ujy{GqcvaBAFCF?FAJ@B?B?@@B?@@B?@@@@@?@@@@@?@@?@@@@F@D?DADABCBEBGBITMFC`@M`AS@?r@IB?D?B?H?F?H@z@Tz@ZNDh@PNDNDPFPDXHnA^pRxFNDzC|@tF|ARLNDJDVH",
                "path": [
                  {
                    "lat": 46.66555,
                    "lng": 16.17481
                  },
                  {
                    "lat": 46.665560000000006,
                    "lng": 16.174770000000002
                  },
                  {
                    "lat": 46.665580000000006,
                    "lng": 16.17473
                  },
                  {
                    "lat": 46.665580000000006,
                    "lng": 16.174690000000002
                  },
                  {
                    "lat": 46.66559,
                    "lng": 16.17463
                  },
                  {
                    "lat": 46.665580000000006,
                    "lng": 16.17461
                  },
                  {
                    "lat": 46.665580000000006,
                    "lng": 16.174590000000002
                  },
                  {
                    "lat": 46.665580000000006,
                    "lng": 16.174580000000002
                  },
                  {
                    "lat": 46.66557,
                    "lng": 16.17456
                  },
                  {
                    "lat": 46.66557,
                    "lng": 16.17455
                  },
                  {
                    "lat": 46.665560000000006,
                    "lng": 16.17453
                  },
                  {
                    "lat": 46.665560000000006,
                    "lng": 16.17452
                  },
                  {
                    "lat": 46.66555,
                    "lng": 16.17451
                  },
                  {
                    "lat": 46.66554000000001,
                    "lng": 16.174500000000002
                  },
                  {
                    "lat": 46.66554000000001,
                    "lng": 16.174490000000002
                  },
                  {
                    "lat": 46.665530000000004,
                    "lng": 16.174480000000003
                  },
                  {
                    "lat": 46.66552,
                    "lng": 16.174470000000003
                  },
                  {
                    "lat": 46.66552,
                    "lng": 16.17446
                  },
                  {
                    "lat": 46.665510000000005,
                    "lng": 16.17446
                  },
                  {
                    "lat": 46.6655,
                    "lng": 16.17445
                  },
                  {
                    "lat": 46.665490000000005,
                    "lng": 16.17444
                  },
                  {
                    "lat": 46.66545000000001,
                    "lng": 16.17443
                  },
                  {
                    "lat": 46.665420000000005,
                    "lng": 16.17443
                  },
                  {
                    "lat": 46.66539,
                    "lng": 16.17444
                  },
                  {
                    "lat": 46.66536000000001,
                    "lng": 16.17445
                  },
                  {
                    "lat": 46.66534,
                    "lng": 16.174470000000003
                  },
                  {
                    "lat": 46.66532,
                    "lng": 16.174500000000002
                  },
                  {
                    "lat": 46.6653,
                    "lng": 16.17454
                  },
                  {
                    "lat": 46.66528,
                    "lng": 16.174590000000002
                  },
                  {
                    "lat": 46.66517,
                    "lng": 16.174660000000003
                  },
                  {
                    "lat": 46.665130000000005,
                    "lng": 16.174680000000002
                  },
                  {
                    "lat": 46.66496,
                    "lng": 16.174750000000003
                  },
                  {
                    "lat": 46.66463,
                    "lng": 16.174850000000003
                  },
                  {
                    "lat": 46.664620000000006,
                    "lng": 16.174850000000003
                  },
                  {
                    "lat": 46.66436,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66434,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66431,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66429,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66424000000001,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.6642,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66415000000001,
                    "lng": 16.17489
                  },
                  {
                    "lat": 46.663850000000004,
                    "lng": 16.174780000000002
                  },
                  {
                    "lat": 46.66355,
                    "lng": 16.17464
                  },
                  {
                    "lat": 46.663470000000004,
                    "lng": 16.17461
                  },
                  {
                    "lat": 46.66326,
                    "lng": 16.17452
                  },
                  {
                    "lat": 46.663180000000004,
                    "lng": 16.174490000000002
                  },
                  {
                    "lat": 46.66310000000001,
                    "lng": 16.17446
                  },
                  {
                    "lat": 46.66301000000001,
                    "lng": 16.17442
                  },
                  {
                    "lat": 46.66292000000001,
                    "lng": 16.174390000000002
                  },
                  {
                    "lat": 46.66279,
                    "lng": 16.17434
                  },
                  {
                    "lat": 46.66239,
                    "lng": 16.17418
                  },
                  {
                    "lat": 46.65926,
                    "lng": 16.17293
                  },
                  {
                    "lat": 46.659180000000006,
                    "lng": 16.172900000000002
                  },
                  {
                    "lat": 46.6584,
                    "lng": 16.17259
                  },
                  {
                    "lat": 46.65717,
                    "lng": 16.17212
                  },
                  {
                    "lat": 46.657070000000004,
                    "lng": 16.172050000000002
                  },
                  {
                    "lat": 46.65699,
                    "lng": 16.17202
                  },
                  {
                    "lat": 46.65693,
                    "lng": 16.17199
                  },
                  {
                    "lat": 46.65681000000001,
                    "lng": 16.171940000000003
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.66555,
                    "lng": 16.17481
                  },
                  {
                    "lat": 46.665560000000006,
                    "lng": 16.174770000000002
                  },
                  {
                    "lat": 46.665580000000006,
                    "lng": 16.17473
                  },
                  {
                    "lat": 46.665580000000006,
                    "lng": 16.174690000000002
                  },
                  {
                    "lat": 46.66559,
                    "lng": 16.17463
                  },
                  {
                    "lat": 46.665580000000006,
                    "lng": 16.17461
                  },
                  {
                    "lat": 46.665580000000006,
                    "lng": 16.174590000000002
                  },
                  {
                    "lat": 46.665580000000006,
                    "lng": 16.174580000000002
                  },
                  {
                    "lat": 46.66557,
                    "lng": 16.17456
                  },
                  {
                    "lat": 46.66557,
                    "lng": 16.17455
                  },
                  {
                    "lat": 46.665560000000006,
                    "lng": 16.17453
                  },
                  {
                    "lat": 46.665560000000006,
                    "lng": 16.17452
                  },
                  {
                    "lat": 46.66555,
                    "lng": 16.17451
                  },
                  {
                    "lat": 46.66554000000001,
                    "lng": 16.174500000000002
                  },
                  {
                    "lat": 46.66554000000001,
                    "lng": 16.174490000000002
                  },
                  {
                    "lat": 46.665530000000004,
                    "lng": 16.174480000000003
                  },
                  {
                    "lat": 46.66552,
                    "lng": 16.174470000000003
                  },
                  {
                    "lat": 46.66552,
                    "lng": 16.17446
                  },
                  {
                    "lat": 46.665510000000005,
                    "lng": 16.17446
                  },
                  {
                    "lat": 46.6655,
                    "lng": 16.17445
                  },
                  {
                    "lat": 46.665490000000005,
                    "lng": 16.17444
                  },
                  {
                    "lat": 46.66545000000001,
                    "lng": 16.17443
                  },
                  {
                    "lat": 46.665420000000005,
                    "lng": 16.17443
                  },
                  {
                    "lat": 46.66539,
                    "lng": 16.17444
                  },
                  {
                    "lat": 46.66536000000001,
                    "lng": 16.17445
                  },
                  {
                    "lat": 46.66534,
                    "lng": 16.174470000000003
                  },
                  {
                    "lat": 46.66532,
                    "lng": 16.174500000000002
                  },
                  {
                    "lat": 46.6653,
                    "lng": 16.17454
                  },
                  {
                    "lat": 46.66528,
                    "lng": 16.174590000000002
                  },
                  {
                    "lat": 46.66517,
                    "lng": 16.174660000000003
                  },
                  {
                    "lat": 46.665130000000005,
                    "lng": 16.174680000000002
                  },
                  {
                    "lat": 46.66496,
                    "lng": 16.174750000000003
                  },
                  {
                    "lat": 46.66463,
                    "lng": 16.174850000000003
                  },
                  {
                    "lat": 46.664620000000006,
                    "lng": 16.174850000000003
                  },
                  {
                    "lat": 46.66436,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66434,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66431,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66429,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66424000000001,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.6642,
                    "lng": 16.1749
                  },
                  {
                    "lat": 46.66415000000001,
                    "lng": 16.17489
                  },
                  {
                    "lat": 46.663850000000004,
                    "lng": 16.174780000000002
                  },
                  {
                    "lat": 46.66355,
                    "lng": 16.17464
                  },
                  {
                    "lat": 46.663470000000004,
                    "lng": 16.17461
                  },
                  {
                    "lat": 46.66326,
                    "lng": 16.17452
                  },
                  {
                    "lat": 46.663180000000004,
                    "lng": 16.174490000000002
                  },
                  {
                    "lat": 46.66310000000001,
                    "lng": 16.17446
                  },
                  {
                    "lat": 46.66301000000001,
                    "lng": 16.17442
                  },
                  {
                    "lat": 46.66292000000001,
                    "lng": 16.174390000000002
                  },
                  {
                    "lat": 46.66279,
                    "lng": 16.17434
                  },
                  {
                    "lat": 46.66239,
                    "lng": 16.17418
                  },
                  {
                    "lat": 46.65926,
                    "lng": 16.17293
                  },
                  {
                    "lat": 46.659180000000006,
                    "lng": 16.172900000000002
                  },
                  {
                    "lat": 46.6584,
                    "lng": 16.17259
                  },
                  {
                    "lat": 46.65717,
                    "lng": 16.17212
                  },
                  {
                    "lat": 46.657070000000004,
                    "lng": 16.172050000000002
                  },
                  {
                    "lat": 46.65699,
                    "lng": 16.17202
                  },
                  {
                    "lat": 46.65693,
                    "lng": 16.17199
                  },
                  {
                    "lat": 46.65681000000001,
                    "lng": 16.171940000000003
                  }
                ],
                "instructions": "At the roundabout, take the <b>3rd</b> exit onto <b>Industrijska ulica</b> heading to <b>Maribor</b>/<wbr/><b>Lendava</b>/<wbr/><b>G. Radgona</b>",
                "start_point": {
                  "lat": 46.6655464,
                  "lng": 16.1748107
                },
                "end_point": {
                  "lat": 46.6568128,
                  "lng": 16.1719352
                }
              },
              {
                "distance": {
                  "text": "0.6 km",
                  "value": 562
                },
                "duration": {
                  "text": "1 min",
                  "value": 50
                },
                "end_location": {
                  "lat": 46.6562221,
                  "lng": 16.1786955
                },
                "maneuver": "roundabout-right",
                "polyline": {
                  "points": "atw{GsquaB?B?@?@@@?@?@@@?@@@?@@??@@@@@@@@?@@@?@?@?@?@?@A@?@A@?@A@A?A@A@??A@A?A@A?C?A@A?A?C?A?A?A?A?A?C?A?AAA?A?AAA?CDyAAGF{BGyACoB?k@CuA?_C?w@?cABu@?UBQ?ADm@?A@C@I?Cb@wEH}@JiA"
                },
                "start_location": {
                  "lat": 46.6568128,
                  "lng": 16.1719352
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "atw{GsquaB?B?@?@@@?@?@@@?@@@?@@??@@@@@@@@?@@@?@?@?@?@?@A@?@A@?@A@A?A@A@??A@A?A@A?C?A@A?A?C?A?A?A?A?A?C?A?AAA?A?AAA?CDyAAGF{BGyACoB?k@CuA?_C?w@?cABu@?UBQ?ADm@?A@C@I?Cb@wEH}@JiA",
                "path": [
                  {
                    "lat": 46.65681000000001,
                    "lng": 16.171940000000003
                  },
                  {
                    "lat": 46.65681000000001,
                    "lng": 16.17192
                  },
                  {
                    "lat": 46.65681000000001,
                    "lng": 16.17191
                  },
                  {
                    "lat": 46.65681000000001,
                    "lng": 16.1719
                  },
                  {
                    "lat": 46.656800000000004,
                    "lng": 16.17189
                  },
                  {
                    "lat": 46.656800000000004,
                    "lng": 16.17188
                  },
                  {
                    "lat": 46.656800000000004,
                    "lng": 16.171870000000002
                  },
                  {
                    "lat": 46.65679,
                    "lng": 16.171860000000002
                  },
                  {
                    "lat": 46.65679,
                    "lng": 16.171850000000003
                  },
                  {
                    "lat": 46.656780000000005,
                    "lng": 16.17184
                  },
                  {
                    "lat": 46.656780000000005,
                    "lng": 16.17183
                  },
                  {
                    "lat": 46.65677,
                    "lng": 16.17183
                  },
                  {
                    "lat": 46.65677,
                    "lng": 16.17182
                  },
                  {
                    "lat": 46.656760000000006,
                    "lng": 16.17181
                  },
                  {
                    "lat": 46.65675,
                    "lng": 16.1718
                  },
                  {
                    "lat": 46.656740000000006,
                    "lng": 16.17179
                  },
                  {
                    "lat": 46.65673,
                    "lng": 16.17179
                  },
                  {
                    "lat": 46.65672000000001,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.656710000000004,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.6567,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.656690000000005,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.65668,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.656670000000005,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.65666,
                    "lng": 16.17179
                  },
                  {
                    "lat": 46.656650000000006,
                    "lng": 16.17179
                  },
                  {
                    "lat": 46.65664,
                    "lng": 16.1718
                  },
                  {
                    "lat": 46.65663000000001,
                    "lng": 16.1718
                  },
                  {
                    "lat": 46.656620000000004,
                    "lng": 16.17181
                  },
                  {
                    "lat": 46.65661,
                    "lng": 16.17182
                  },
                  {
                    "lat": 46.65661,
                    "lng": 16.17183
                  },
                  {
                    "lat": 46.656600000000005,
                    "lng": 16.17184
                  },
                  {
                    "lat": 46.65659,
                    "lng": 16.17184
                  },
                  {
                    "lat": 46.65659,
                    "lng": 16.171850000000003
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.171860000000002
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.171870000000002
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.17188
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.1719
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.17191
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17192
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17193
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.171950000000002
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.171960000000002
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17197
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17198
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17199
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.172
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17202
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.172030000000003
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.172040000000003
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.172050000000002
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.172060000000002
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.17207
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.17208
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.1721
                  },
                  {
                    "lat": 46.65655,
                    "lng": 16.17255
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17259
                  },
                  {
                    "lat": 46.65652,
                    "lng": 16.17321
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17366
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.174220000000002
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.17444
                  },
                  {
                    "lat": 46.656600000000005,
                    "lng": 16.174870000000002
                  },
                  {
                    "lat": 46.656600000000005,
                    "lng": 16.175510000000003
                  },
                  {
                    "lat": 46.656600000000005,
                    "lng": 16.175790000000003
                  },
                  {
                    "lat": 46.656600000000005,
                    "lng": 16.17613
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.1764
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.17651
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.1766
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17661
                  },
                  {
                    "lat": 46.656530000000004,
                    "lng": 16.176840000000002
                  },
                  {
                    "lat": 46.656530000000004,
                    "lng": 16.17685
                  },
                  {
                    "lat": 46.65652,
                    "lng": 16.17687
                  },
                  {
                    "lat": 46.656510000000004,
                    "lng": 16.176920000000003
                  },
                  {
                    "lat": 46.656510000000004,
                    "lng": 16.176940000000002
                  },
                  {
                    "lat": 46.656330000000004,
                    "lng": 16.17802
                  },
                  {
                    "lat": 46.65628,
                    "lng": 16.178330000000003
                  },
                  {
                    "lat": 46.656220000000005,
                    "lng": 16.178700000000003
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.65681000000001,
                    "lng": 16.171940000000003
                  },
                  {
                    "lat": 46.65681000000001,
                    "lng": 16.17192
                  },
                  {
                    "lat": 46.65681000000001,
                    "lng": 16.17191
                  },
                  {
                    "lat": 46.65681000000001,
                    "lng": 16.1719
                  },
                  {
                    "lat": 46.656800000000004,
                    "lng": 16.17189
                  },
                  {
                    "lat": 46.656800000000004,
                    "lng": 16.17188
                  },
                  {
                    "lat": 46.656800000000004,
                    "lng": 16.171870000000002
                  },
                  {
                    "lat": 46.65679,
                    "lng": 16.171860000000002
                  },
                  {
                    "lat": 46.65679,
                    "lng": 16.171850000000003
                  },
                  {
                    "lat": 46.656780000000005,
                    "lng": 16.17184
                  },
                  {
                    "lat": 46.656780000000005,
                    "lng": 16.17183
                  },
                  {
                    "lat": 46.65677,
                    "lng": 16.17183
                  },
                  {
                    "lat": 46.65677,
                    "lng": 16.17182
                  },
                  {
                    "lat": 46.656760000000006,
                    "lng": 16.17181
                  },
                  {
                    "lat": 46.65675,
                    "lng": 16.1718
                  },
                  {
                    "lat": 46.656740000000006,
                    "lng": 16.17179
                  },
                  {
                    "lat": 46.65673,
                    "lng": 16.17179
                  },
                  {
                    "lat": 46.65672000000001,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.656710000000004,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.6567,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.656690000000005,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.65668,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.656670000000005,
                    "lng": 16.171780000000002
                  },
                  {
                    "lat": 46.65666,
                    "lng": 16.17179
                  },
                  {
                    "lat": 46.656650000000006,
                    "lng": 16.17179
                  },
                  {
                    "lat": 46.65664,
                    "lng": 16.1718
                  },
                  {
                    "lat": 46.65663000000001,
                    "lng": 16.1718
                  },
                  {
                    "lat": 46.656620000000004,
                    "lng": 16.17181
                  },
                  {
                    "lat": 46.65661,
                    "lng": 16.17182
                  },
                  {
                    "lat": 46.65661,
                    "lng": 16.17183
                  },
                  {
                    "lat": 46.656600000000005,
                    "lng": 16.17184
                  },
                  {
                    "lat": 46.65659,
                    "lng": 16.17184
                  },
                  {
                    "lat": 46.65659,
                    "lng": 16.171850000000003
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.171860000000002
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.171870000000002
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.17188
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.1719
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.17191
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17192
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17193
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.171950000000002
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.171960000000002
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17197
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17198
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17199
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.172
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17202
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.172030000000003
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.172040000000003
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.172050000000002
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.172060000000002
                  },
                  {
                    "lat": 46.65657,
                    "lng": 16.17207
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.17208
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.1721
                  },
                  {
                    "lat": 46.65655,
                    "lng": 16.17255
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17259
                  },
                  {
                    "lat": 46.65652,
                    "lng": 16.17321
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17366
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.174220000000002
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.17444
                  },
                  {
                    "lat": 46.656600000000005,
                    "lng": 16.174870000000002
                  },
                  {
                    "lat": 46.656600000000005,
                    "lng": 16.175510000000003
                  },
                  {
                    "lat": 46.656600000000005,
                    "lng": 16.175790000000003
                  },
                  {
                    "lat": 46.656600000000005,
                    "lng": 16.17613
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.1764
                  },
                  {
                    "lat": 46.656580000000005,
                    "lng": 16.17651
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.1766
                  },
                  {
                    "lat": 46.656560000000006,
                    "lng": 16.17661
                  },
                  {
                    "lat": 46.656530000000004,
                    "lng": 16.176840000000002
                  },
                  {
                    "lat": 46.656530000000004,
                    "lng": 16.17685
                  },
                  {
                    "lat": 46.65652,
                    "lng": 16.17687
                  },
                  {
                    "lat": 46.656510000000004,
                    "lng": 16.176920000000003
                  },
                  {
                    "lat": 46.656510000000004,
                    "lng": 16.176940000000002
                  },
                  {
                    "lat": 46.656330000000004,
                    "lng": 16.17802
                  },
                  {
                    "lat": 46.65628,
                    "lng": 16.178330000000003
                  },
                  {
                    "lat": 46.656220000000005,
                    "lng": 16.178700000000003
                  }
                ],
                "instructions": "At the roundabout, take the <b>2nd</b> exit onto <b>Panonska ulica</b>",
                "start_point": {
                  "lat": 46.6568128,
                  "lng": 16.1719352
                },
                "end_point": {
                  "lat": 46.6562221,
                  "lng": 16.1786955
                }
              },
              {
                "distance": {
                  "text": "0.9 km",
                  "value": 892
                },
                "duration": {
                  "text": "1 min",
                  "value": 67
                },
                "end_location": {
                  "lat": 46.65226819999999,
                  "lng": 16.188401
                },
                "maneuver": "roundabout-right",
                "polyline": {
                  "points": "kpw{G{{vaB@@@?@@B?@?@A@?B?@A@A@?@A@A@A@C@A?A@C@A?C@C?A?C@C?C?C?AAC?C?CAA?CACAA?AACAAAAAAAAAACARcBf@qDb@uCBO@ERmAF_@H_@J]JUJ[Rc@bAaCHU`@_Aj@wA`AiClBcF?CTk@h@uAVm@Zw@HUVm@t@mBJKHQNY"
                },
                "start_location": {
                  "lat": 46.6562221,
                  "lng": 16.1786955
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "kpw{G{{vaB@@@?@@B?@?@A@?B?@A@A@?@A@A@A@C@A?A@C@A?C@C?A?C@C?C?C?AAC?C?CAA?CACAA?AACAAAAAAAAAACARcBf@qDb@uCBO@ERmAF_@H_@J]JUJ[Rc@bAaCHU`@_Aj@wA`AiClBcF?CTk@h@uAVm@Zw@HUVm@t@mBJKHQNY",
                "path": [
                  {
                    "lat": 46.656220000000005,
                    "lng": 16.178700000000003
                  },
                  {
                    "lat": 46.65621,
                    "lng": 16.17869
                  },
                  {
                    "lat": 46.656200000000005,
                    "lng": 16.17869
                  },
                  {
                    "lat": 46.65619,
                    "lng": 16.17868
                  },
                  {
                    "lat": 46.65617,
                    "lng": 16.17868
                  },
                  {
                    "lat": 46.65616000000001,
                    "lng": 16.17868
                  },
                  {
                    "lat": 46.656150000000004,
                    "lng": 16.17869
                  },
                  {
                    "lat": 46.65614,
                    "lng": 16.17869
                  },
                  {
                    "lat": 46.65612,
                    "lng": 16.17869
                  },
                  {
                    "lat": 46.656110000000005,
                    "lng": 16.178700000000003
                  },
                  {
                    "lat": 46.6561,
                    "lng": 16.178710000000002
                  },
                  {
                    "lat": 46.656090000000006,
                    "lng": 16.178710000000002
                  },
                  {
                    "lat": 46.65608,
                    "lng": 16.178720000000002
                  },
                  {
                    "lat": 46.65607000000001,
                    "lng": 16.17873
                  },
                  {
                    "lat": 46.656060000000004,
                    "lng": 16.17874
                  },
                  {
                    "lat": 46.65605,
                    "lng": 16.17876
                  },
                  {
                    "lat": 46.656040000000004,
                    "lng": 16.17877
                  },
                  {
                    "lat": 46.656040000000004,
                    "lng": 16.17878
                  },
                  {
                    "lat": 46.65603,
                    "lng": 16.178800000000003
                  },
                  {
                    "lat": 46.656020000000005,
                    "lng": 16.178810000000002
                  },
                  {
                    "lat": 46.656020000000005,
                    "lng": 16.17883
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.17885
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.17886
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.178880000000003
                  },
                  {
                    "lat": 46.656000000000006,
                    "lng": 16.178900000000002
                  },
                  {
                    "lat": 46.656000000000006,
                    "lng": 16.17892
                  },
                  {
                    "lat": 46.656000000000006,
                    "lng": 16.17894
                  },
                  {
                    "lat": 46.656000000000006,
                    "lng": 16.17895
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.17897
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.178990000000002
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.17901
                  },
                  {
                    "lat": 46.656020000000005,
                    "lng": 16.17902
                  },
                  {
                    "lat": 46.656020000000005,
                    "lng": 16.17904
                  },
                  {
                    "lat": 46.65603,
                    "lng": 16.17906
                  },
                  {
                    "lat": 46.656040000000004,
                    "lng": 16.179070000000003
                  },
                  {
                    "lat": 46.656040000000004,
                    "lng": 16.179080000000003
                  },
                  {
                    "lat": 46.65605,
                    "lng": 16.179100000000002
                  },
                  {
                    "lat": 46.656060000000004,
                    "lng": 16.17911
                  },
                  {
                    "lat": 46.65607000000001,
                    "lng": 16.17912
                  },
                  {
                    "lat": 46.65608,
                    "lng": 16.17913
                  },
                  {
                    "lat": 46.656090000000006,
                    "lng": 16.17914
                  },
                  {
                    "lat": 46.6561,
                    "lng": 16.17915
                  },
                  {
                    "lat": 46.65612,
                    "lng": 16.179160000000003
                  },
                  {
                    "lat": 46.656020000000005,
                    "lng": 16.179660000000002
                  },
                  {
                    "lat": 46.655820000000006,
                    "lng": 16.18055
                  },
                  {
                    "lat": 46.655640000000005,
                    "lng": 16.1813
                  },
                  {
                    "lat": 46.655620000000006,
                    "lng": 16.18138
                  },
                  {
                    "lat": 46.65561,
                    "lng": 16.18141
                  },
                  {
                    "lat": 46.65551000000001,
                    "lng": 16.181800000000003
                  },
                  {
                    "lat": 46.65547,
                    "lng": 16.18196
                  },
                  {
                    "lat": 46.65542000000001,
                    "lng": 16.18212
                  },
                  {
                    "lat": 46.65536,
                    "lng": 16.182270000000003
                  },
                  {
                    "lat": 46.655300000000004,
                    "lng": 16.182380000000002
                  },
                  {
                    "lat": 46.655240000000006,
                    "lng": 16.18252
                  },
                  {
                    "lat": 46.65514,
                    "lng": 16.1827
                  },
                  {
                    "lat": 46.6548,
                    "lng": 16.18335
                  },
                  {
                    "lat": 46.65475000000001,
                    "lng": 16.18346
                  },
                  {
                    "lat": 46.65458,
                    "lng": 16.183780000000002
                  },
                  {
                    "lat": 46.654360000000004,
                    "lng": 16.18422
                  },
                  {
                    "lat": 46.654030000000006,
                    "lng": 16.184910000000002
                  },
                  {
                    "lat": 46.65348,
                    "lng": 16.18605
                  },
                  {
                    "lat": 46.65348,
                    "lng": 16.18607
                  },
                  {
                    "lat": 46.65337,
                    "lng": 16.18629
                  },
                  {
                    "lat": 46.65316000000001,
                    "lng": 16.18672
                  },
                  {
                    "lat": 46.653040000000004,
                    "lng": 16.186950000000003
                  },
                  {
                    "lat": 46.6529,
                    "lng": 16.18723
                  },
                  {
                    "lat": 46.65285,
                    "lng": 16.187340000000003
                  },
                  {
                    "lat": 46.652730000000005,
                    "lng": 16.18757
                  },
                  {
                    "lat": 46.652460000000005,
                    "lng": 16.18812
                  },
                  {
                    "lat": 46.65240000000001,
                    "lng": 16.188180000000003
                  },
                  {
                    "lat": 46.652350000000006,
                    "lng": 16.188270000000003
                  },
                  {
                    "lat": 46.65227,
                    "lng": 16.1884
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.656220000000005,
                    "lng": 16.178700000000003
                  },
                  {
                    "lat": 46.65621,
                    "lng": 16.17869
                  },
                  {
                    "lat": 46.656200000000005,
                    "lng": 16.17869
                  },
                  {
                    "lat": 46.65619,
                    "lng": 16.17868
                  },
                  {
                    "lat": 46.65617,
                    "lng": 16.17868
                  },
                  {
                    "lat": 46.65616000000001,
                    "lng": 16.17868
                  },
                  {
                    "lat": 46.656150000000004,
                    "lng": 16.17869
                  },
                  {
                    "lat": 46.65614,
                    "lng": 16.17869
                  },
                  {
                    "lat": 46.65612,
                    "lng": 16.17869
                  },
                  {
                    "lat": 46.656110000000005,
                    "lng": 16.178700000000003
                  },
                  {
                    "lat": 46.6561,
                    "lng": 16.178710000000002
                  },
                  {
                    "lat": 46.656090000000006,
                    "lng": 16.178710000000002
                  },
                  {
                    "lat": 46.65608,
                    "lng": 16.178720000000002
                  },
                  {
                    "lat": 46.65607000000001,
                    "lng": 16.17873
                  },
                  {
                    "lat": 46.656060000000004,
                    "lng": 16.17874
                  },
                  {
                    "lat": 46.65605,
                    "lng": 16.17876
                  },
                  {
                    "lat": 46.656040000000004,
                    "lng": 16.17877
                  },
                  {
                    "lat": 46.656040000000004,
                    "lng": 16.17878
                  },
                  {
                    "lat": 46.65603,
                    "lng": 16.178800000000003
                  },
                  {
                    "lat": 46.656020000000005,
                    "lng": 16.178810000000002
                  },
                  {
                    "lat": 46.656020000000005,
                    "lng": 16.17883
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.17885
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.17886
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.178880000000003
                  },
                  {
                    "lat": 46.656000000000006,
                    "lng": 16.178900000000002
                  },
                  {
                    "lat": 46.656000000000006,
                    "lng": 16.17892
                  },
                  {
                    "lat": 46.656000000000006,
                    "lng": 16.17894
                  },
                  {
                    "lat": 46.656000000000006,
                    "lng": 16.17895
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.17897
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.178990000000002
                  },
                  {
                    "lat": 46.65601,
                    "lng": 16.17901
                  },
                  {
                    "lat": 46.656020000000005,
                    "lng": 16.17902
                  },
                  {
                    "lat": 46.656020000000005,
                    "lng": 16.17904
                  },
                  {
                    "lat": 46.65603,
                    "lng": 16.17906
                  },
                  {
                    "lat": 46.656040000000004,
                    "lng": 16.179070000000003
                  },
                  {
                    "lat": 46.656040000000004,
                    "lng": 16.179080000000003
                  },
                  {
                    "lat": 46.65605,
                    "lng": 16.179100000000002
                  },
                  {
                    "lat": 46.656060000000004,
                    "lng": 16.17911
                  },
                  {
                    "lat": 46.65607000000001,
                    "lng": 16.17912
                  },
                  {
                    "lat": 46.65608,
                    "lng": 16.17913
                  },
                  {
                    "lat": 46.656090000000006,
                    "lng": 16.17914
                  },
                  {
                    "lat": 46.6561,
                    "lng": 16.17915
                  },
                  {
                    "lat": 46.65612,
                    "lng": 16.179160000000003
                  },
                  {
                    "lat": 46.656020000000005,
                    "lng": 16.179660000000002
                  },
                  {
                    "lat": 46.655820000000006,
                    "lng": 16.18055
                  },
                  {
                    "lat": 46.655640000000005,
                    "lng": 16.1813
                  },
                  {
                    "lat": 46.655620000000006,
                    "lng": 16.18138
                  },
                  {
                    "lat": 46.65561,
                    "lng": 16.18141
                  },
                  {
                    "lat": 46.65551000000001,
                    "lng": 16.181800000000003
                  },
                  {
                    "lat": 46.65547,
                    "lng": 16.18196
                  },
                  {
                    "lat": 46.65542000000001,
                    "lng": 16.18212
                  },
                  {
                    "lat": 46.65536,
                    "lng": 16.182270000000003
                  },
                  {
                    "lat": 46.655300000000004,
                    "lng": 16.182380000000002
                  },
                  {
                    "lat": 46.655240000000006,
                    "lng": 16.18252
                  },
                  {
                    "lat": 46.65514,
                    "lng": 16.1827
                  },
                  {
                    "lat": 46.6548,
                    "lng": 16.18335
                  },
                  {
                    "lat": 46.65475000000001,
                    "lng": 16.18346
                  },
                  {
                    "lat": 46.65458,
                    "lng": 16.183780000000002
                  },
                  {
                    "lat": 46.654360000000004,
                    "lng": 16.18422
                  },
                  {
                    "lat": 46.654030000000006,
                    "lng": 16.184910000000002
                  },
                  {
                    "lat": 46.65348,
                    "lng": 16.18605
                  },
                  {
                    "lat": 46.65348,
                    "lng": 16.18607
                  },
                  {
                    "lat": 46.65337,
                    "lng": 16.18629
                  },
                  {
                    "lat": 46.65316000000001,
                    "lng": 16.18672
                  },
                  {
                    "lat": 46.653040000000004,
                    "lng": 16.186950000000003
                  },
                  {
                    "lat": 46.6529,
                    "lng": 16.18723
                  },
                  {
                    "lat": 46.65285,
                    "lng": 16.187340000000003
                  },
                  {
                    "lat": 46.652730000000005,
                    "lng": 16.18757
                  },
                  {
                    "lat": 46.652460000000005,
                    "lng": 16.18812
                  },
                  {
                    "lat": 46.65240000000001,
                    "lng": 16.188180000000003
                  },
                  {
                    "lat": 46.652350000000006,
                    "lng": 16.188270000000003
                  },
                  {
                    "lat": 46.65227,
                    "lng": 16.1884
                  }
                ],
                "instructions": "At the roundabout, take the <b>2nd</b> exit and stay on <b>Panonska ulica</b>",
                "start_point": {
                  "lat": 46.6562221,
                  "lng": 16.1786955
                },
                "end_point": {
                  "lat": 46.65226819999999,
                  "lng": 16.188401
                }
              },
              {
                "distance": {
                  "text": "1.8 km",
                  "value": 1787
                },
                "duration": {
                  "text": "2 mins",
                  "value": 122
                },
                "end_location": {
                  "lat": 46.6395575,
                  "lng": 16.2009625
                },
                "maneuver": "roundabout-right",
                "polyline": {
                  "points": "uwv{GoxxaB@?@??@@?@?@A@?@?@A@??A@??A@??A@A@A?A?A@A?A@A?A?A?A?A?A?A?A?A?A?A?AAA?A?AAAP}@tA}DdBkEp@kBRe@L[\\}@t@cBh@qAlB_Dx@aA|@}@XS\\S~@g@|@]z@Uf@Ej@Eb@?vBH^@`@?r@ITG\\IBALETKv@c@FGRQHGBCNOXWfBeBz@y@\\[p@q@rBmBhEcEvFoF~B{BrAqANM"
                },
                "start_location": {
                  "lat": 46.65226819999999,
                  "lng": 16.188401
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "uwv{GoxxaB@?@??@@?@?@A@?@?@A@??A@??A@??A@A@A?A?A@A?A@A?A?A?A?A?A?A?A?A?A?A?AAA?A?AAAP}@tA}DdBkEp@kBRe@L[\\}@t@cBh@qAlB_Dx@aA|@}@XS\\S~@g@|@]z@Uf@Ej@Eb@?vBH^@`@?r@ITG\\IBALETKv@c@FGRQHGBCNOXWfBeBz@y@\\[p@q@rBmBhEcEvFoF~B{BrAqANM",
                "path": [
                  {
                    "lat": 46.65227,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.652260000000005,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.65225,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.65225,
                    "lng": 16.188390000000002
                  },
                  {
                    "lat": 46.652240000000006,
                    "lng": 16.188390000000002
                  },
                  {
                    "lat": 46.65223,
                    "lng": 16.188390000000002
                  },
                  {
                    "lat": 46.65222000000001,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.652210000000004,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.6522,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.652190000000004,
                    "lng": 16.18841
                  },
                  {
                    "lat": 46.65218,
                    "lng": 16.18841
                  },
                  {
                    "lat": 46.65218,
                    "lng": 16.18842
                  },
                  {
                    "lat": 46.652170000000005,
                    "lng": 16.18842
                  },
                  {
                    "lat": 46.652170000000005,
                    "lng": 16.18843
                  },
                  {
                    "lat": 46.65216,
                    "lng": 16.18843
                  },
                  {
                    "lat": 46.65216,
                    "lng": 16.18844
                  },
                  {
                    "lat": 46.652150000000006,
                    "lng": 16.18845
                  },
                  {
                    "lat": 46.65214,
                    "lng": 16.188460000000003
                  },
                  {
                    "lat": 46.65214,
                    "lng": 16.188470000000002
                  },
                  {
                    "lat": 46.65214,
                    "lng": 16.188480000000002
                  },
                  {
                    "lat": 46.65213000000001,
                    "lng": 16.18849
                  },
                  {
                    "lat": 46.65213000000001,
                    "lng": 16.1885
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18851
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18852
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18853
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18854
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.188550000000003
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.188560000000003
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.188570000000002
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18858
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18859
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.1886
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18861
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18862
                  },
                  {
                    "lat": 46.65213000000001,
                    "lng": 16.18863
                  },
                  {
                    "lat": 46.65213000000001,
                    "lng": 16.188640000000003
                  },
                  {
                    "lat": 46.65213000000001,
                    "lng": 16.188650000000003
                  },
                  {
                    "lat": 46.65214,
                    "lng": 16.188660000000002
                  },
                  {
                    "lat": 46.65205,
                    "lng": 16.18897
                  },
                  {
                    "lat": 46.65162,
                    "lng": 16.18992
                  },
                  {
                    "lat": 46.65111,
                    "lng": 16.19094
                  },
                  {
                    "lat": 46.65086,
                    "lng": 16.191480000000002
                  },
                  {
                    "lat": 46.650760000000005,
                    "lng": 16.191670000000002
                  },
                  {
                    "lat": 46.650690000000004,
                    "lng": 16.19181
                  },
                  {
                    "lat": 46.65054000000001,
                    "lng": 16.192120000000003
                  },
                  {
                    "lat": 46.650270000000006,
                    "lng": 16.19262
                  },
                  {
                    "lat": 46.65006,
                    "lng": 16.19303
                  },
                  {
                    "lat": 46.64951000000001,
                    "lng": 16.193830000000002
                  },
                  {
                    "lat": 46.64922000000001,
                    "lng": 16.19416
                  },
                  {
                    "lat": 46.64891,
                    "lng": 16.194470000000003
                  },
                  {
                    "lat": 46.64878,
                    "lng": 16.194570000000002
                  },
                  {
                    "lat": 46.648630000000004,
                    "lng": 16.194670000000002
                  },
                  {
                    "lat": 46.64831,
                    "lng": 16.19487
                  },
                  {
                    "lat": 46.648,
                    "lng": 16.195020000000003
                  },
                  {
                    "lat": 46.6477,
                    "lng": 16.195130000000002
                  },
                  {
                    "lat": 46.6475,
                    "lng": 16.19516
                  },
                  {
                    "lat": 46.64728,
                    "lng": 16.19519
                  },
                  {
                    "lat": 46.6471,
                    "lng": 16.19519
                  },
                  {
                    "lat": 46.6465,
                    "lng": 16.195140000000002
                  },
                  {
                    "lat": 46.64634,
                    "lng": 16.195130000000002
                  },
                  {
                    "lat": 46.646170000000005,
                    "lng": 16.195130000000002
                  },
                  {
                    "lat": 46.64591,
                    "lng": 16.19518
                  },
                  {
                    "lat": 46.6458,
                    "lng": 16.195220000000003
                  },
                  {
                    "lat": 46.64565,
                    "lng": 16.19527
                  },
                  {
                    "lat": 46.645630000000004,
                    "lng": 16.19528
                  },
                  {
                    "lat": 46.64556,
                    "lng": 16.195310000000003
                  },
                  {
                    "lat": 46.645450000000004,
                    "lng": 16.19537
                  },
                  {
                    "lat": 46.64517000000001,
                    "lng": 16.19555
                  },
                  {
                    "lat": 46.64513,
                    "lng": 16.195590000000003
                  },
                  {
                    "lat": 46.645030000000006,
                    "lng": 16.195680000000003
                  },
                  {
                    "lat": 46.644980000000004,
                    "lng": 16.19572
                  },
                  {
                    "lat": 46.644960000000005,
                    "lng": 16.19574
                  },
                  {
                    "lat": 46.64488,
                    "lng": 16.19582
                  },
                  {
                    "lat": 46.64475,
                    "lng": 16.19594
                  },
                  {
                    "lat": 46.64423,
                    "lng": 16.196450000000002
                  },
                  {
                    "lat": 46.643930000000005,
                    "lng": 16.196740000000002
                  },
                  {
                    "lat": 46.64378000000001,
                    "lng": 16.19688
                  },
                  {
                    "lat": 46.643530000000005,
                    "lng": 16.19713
                  },
                  {
                    "lat": 46.642950000000006,
                    "lng": 16.197680000000002
                  },
                  {
                    "lat": 46.641940000000005,
                    "lng": 16.19866
                  },
                  {
                    "lat": 46.6407,
                    "lng": 16.19986
                  },
                  {
                    "lat": 46.640060000000005,
                    "lng": 16.200480000000002
                  },
                  {
                    "lat": 46.63964000000001,
                    "lng": 16.20089
                  },
                  {
                    "lat": 46.63956,
                    "lng": 16.200960000000002
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.65227,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.652260000000005,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.65225,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.65225,
                    "lng": 16.188390000000002
                  },
                  {
                    "lat": 46.652240000000006,
                    "lng": 16.188390000000002
                  },
                  {
                    "lat": 46.65223,
                    "lng": 16.188390000000002
                  },
                  {
                    "lat": 46.65222000000001,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.652210000000004,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.6522,
                    "lng": 16.1884
                  },
                  {
                    "lat": 46.652190000000004,
                    "lng": 16.18841
                  },
                  {
                    "lat": 46.65218,
                    "lng": 16.18841
                  },
                  {
                    "lat": 46.65218,
                    "lng": 16.18842
                  },
                  {
                    "lat": 46.652170000000005,
                    "lng": 16.18842
                  },
                  {
                    "lat": 46.652170000000005,
                    "lng": 16.18843
                  },
                  {
                    "lat": 46.65216,
                    "lng": 16.18843
                  },
                  {
                    "lat": 46.65216,
                    "lng": 16.18844
                  },
                  {
                    "lat": 46.652150000000006,
                    "lng": 16.18845
                  },
                  {
                    "lat": 46.65214,
                    "lng": 16.188460000000003
                  },
                  {
                    "lat": 46.65214,
                    "lng": 16.188470000000002
                  },
                  {
                    "lat": 46.65214,
                    "lng": 16.188480000000002
                  },
                  {
                    "lat": 46.65213000000001,
                    "lng": 16.18849
                  },
                  {
                    "lat": 46.65213000000001,
                    "lng": 16.1885
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18851
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18852
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18853
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18854
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.188550000000003
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.188560000000003
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.188570000000002
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18858
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18859
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.1886
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18861
                  },
                  {
                    "lat": 46.652120000000004,
                    "lng": 16.18862
                  },
                  {
                    "lat": 46.65213000000001,
                    "lng": 16.18863
                  },
                  {
                    "lat": 46.65213000000001,
                    "lng": 16.188640000000003
                  },
                  {
                    "lat": 46.65213000000001,
                    "lng": 16.188650000000003
                  },
                  {
                    "lat": 46.65214,
                    "lng": 16.188660000000002
                  },
                  {
                    "lat": 46.65205,
                    "lng": 16.18897
                  },
                  {
                    "lat": 46.65162,
                    "lng": 16.18992
                  },
                  {
                    "lat": 46.65111,
                    "lng": 16.19094
                  },
                  {
                    "lat": 46.65086,
                    "lng": 16.191480000000002
                  },
                  {
                    "lat": 46.650760000000005,
                    "lng": 16.191670000000002
                  },
                  {
                    "lat": 46.650690000000004,
                    "lng": 16.19181
                  },
                  {
                    "lat": 46.65054000000001,
                    "lng": 16.192120000000003
                  },
                  {
                    "lat": 46.650270000000006,
                    "lng": 16.19262
                  },
                  {
                    "lat": 46.65006,
                    "lng": 16.19303
                  },
                  {
                    "lat": 46.64951000000001,
                    "lng": 16.193830000000002
                  },
                  {
                    "lat": 46.64922000000001,
                    "lng": 16.19416
                  },
                  {
                    "lat": 46.64891,
                    "lng": 16.194470000000003
                  },
                  {
                    "lat": 46.64878,
                    "lng": 16.194570000000002
                  },
                  {
                    "lat": 46.648630000000004,
                    "lng": 16.194670000000002
                  },
                  {
                    "lat": 46.64831,
                    "lng": 16.19487
                  },
                  {
                    "lat": 46.648,
                    "lng": 16.195020000000003
                  },
                  {
                    "lat": 46.6477,
                    "lng": 16.195130000000002
                  },
                  {
                    "lat": 46.6475,
                    "lng": 16.19516
                  },
                  {
                    "lat": 46.64728,
                    "lng": 16.19519
                  },
                  {
                    "lat": 46.6471,
                    "lng": 16.19519
                  },
                  {
                    "lat": 46.6465,
                    "lng": 16.195140000000002
                  },
                  {
                    "lat": 46.64634,
                    "lng": 16.195130000000002
                  },
                  {
                    "lat": 46.646170000000005,
                    "lng": 16.195130000000002
                  },
                  {
                    "lat": 46.64591,
                    "lng": 16.19518
                  },
                  {
                    "lat": 46.6458,
                    "lng": 16.195220000000003
                  },
                  {
                    "lat": 46.64565,
                    "lng": 16.19527
                  },
                  {
                    "lat": 46.645630000000004,
                    "lng": 16.19528
                  },
                  {
                    "lat": 46.64556,
                    "lng": 16.195310000000003
                  },
                  {
                    "lat": 46.645450000000004,
                    "lng": 16.19537
                  },
                  {
                    "lat": 46.64517000000001,
                    "lng": 16.19555
                  },
                  {
                    "lat": 46.64513,
                    "lng": 16.195590000000003
                  },
                  {
                    "lat": 46.645030000000006,
                    "lng": 16.195680000000003
                  },
                  {
                    "lat": 46.644980000000004,
                    "lng": 16.19572
                  },
                  {
                    "lat": 46.644960000000005,
                    "lng": 16.19574
                  },
                  {
                    "lat": 46.64488,
                    "lng": 16.19582
                  },
                  {
                    "lat": 46.64475,
                    "lng": 16.19594
                  },
                  {
                    "lat": 46.64423,
                    "lng": 16.196450000000002
                  },
                  {
                    "lat": 46.643930000000005,
                    "lng": 16.196740000000002
                  },
                  {
                    "lat": 46.64378000000001,
                    "lng": 16.19688
                  },
                  {
                    "lat": 46.643530000000005,
                    "lng": 16.19713
                  },
                  {
                    "lat": 46.642950000000006,
                    "lng": 16.197680000000002
                  },
                  {
                    "lat": 46.641940000000005,
                    "lng": 16.19866
                  },
                  {
                    "lat": 46.6407,
                    "lng": 16.19986
                  },
                  {
                    "lat": 46.640060000000005,
                    "lng": 16.200480000000002
                  },
                  {
                    "lat": 46.63964000000001,
                    "lng": 16.20089
                  },
                  {
                    "lat": 46.63956,
                    "lng": 16.200960000000002
                  }
                ],
                "instructions": "At the roundabout, continue straight onto <b>Lendavska ulica</b>",
                "start_point": {
                  "lat": 46.65226819999999,
                  "lng": 16.188401
                },
                "end_point": {
                  "lat": 46.6395575,
                  "lng": 16.2009625
                }
              },
              {
                "distance": {
                  "text": "0.5 km",
                  "value": 486
                },
                "duration": {
                  "text": "1 min",
                  "value": 24
                },
                "end_location": {
                  "lat": 46.635913,
                  "lng": 16.204473
                },
                "polyline": {
                  "points": "ght{G_g{aBzCuCjAgA|FuF|@y@DCZY|A}At@s@"
                },
                "start_location": {
                  "lat": 46.6395575,
                  "lng": 16.2009625
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "ght{G_g{aBzCuCjAgA|FuF|@y@DCZY|A}At@s@",
                "path": [
                  {
                    "lat": 46.63956,
                    "lng": 16.200960000000002
                  },
                  {
                    "lat": 46.638780000000004,
                    "lng": 16.201710000000002
                  },
                  {
                    "lat": 46.638400000000004,
                    "lng": 16.202070000000003
                  },
                  {
                    "lat": 46.637130000000006,
                    "lng": 16.203300000000002
                  },
                  {
                    "lat": 46.63682000000001,
                    "lng": 16.203590000000002
                  },
                  {
                    "lat": 46.636790000000005,
                    "lng": 16.20361
                  },
                  {
                    "lat": 46.63665,
                    "lng": 16.20374
                  },
                  {
                    "lat": 46.63618,
                    "lng": 16.20421
                  },
                  {
                    "lat": 46.63591,
                    "lng": 16.20447
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.63956,
                    "lng": 16.200960000000002
                  },
                  {
                    "lat": 46.638780000000004,
                    "lng": 16.201710000000002
                  },
                  {
                    "lat": 46.638400000000004,
                    "lng": 16.202070000000003
                  },
                  {
                    "lat": 46.637130000000006,
                    "lng": 16.203300000000002
                  },
                  {
                    "lat": 46.63682000000001,
                    "lng": 16.203590000000002
                  },
                  {
                    "lat": 46.636790000000005,
                    "lng": 16.20361
                  },
                  {
                    "lat": 46.63665,
                    "lng": 16.20374
                  },
                  {
                    "lat": 46.63618,
                    "lng": 16.20421
                  },
                  {
                    "lat": 46.63591,
                    "lng": 16.20447
                  }
                ],
                "instructions": "Continue onto <b>Rakičan</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.6395575,
                  "lng": 16.2009625
                },
                "end_point": {
                  "lat": 46.635913,
                  "lng": 16.204473
                }
              },
              {
                "distance": {
                  "text": "2.3 km",
                  "value": 2322
                },
                "duration": {
                  "text": "3 mins",
                  "value": 167
                },
                "end_location": {
                  "lat": 46.6186981,
                  "lng": 16.2208664
                },
                "polyline": {
                  "points": "mqs{G}|{aBtAqAb@a@TU|AwABCNSvAuAFCDA|B{BlBkB`EyDBI@A\\[bAaA`B_B^]~A{AZW@@?@@@?@@?@@@@@@@?@?@?@@@??A@?@?@??A@?@A@??A@A@A?A@??A?A@A?A?A@??A?A?A?A?A?A?A?A?A?A?A?AAA?A?AAAtDkDnK}JnFcF~@}@vCoCTS@ApEiE@@?@@@?@@@@@?@@?@@@@@?@?@@@?@?@?@?@A@?@A@?@A?A@?@A?A@A@A?A?A@A?A@A?A?A?C?A?A@AAA?C?A?A?A?AAC?AAA`DyCxBqBHCp@o@ZWbA_Av@u@h@e@|@_AtAqADEh@g@|@s@jCeC"
                },
                "start_location": {
                  "lat": 46.635913,
                  "lng": 16.204473
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "mqs{G}|{aBtAqAb@a@TU|AwABCNSvAuAFCDA|B{BlBkB`EyDBI@A\\[bAaA`B_B^]~A{AZW@@?@@@?@@?@@@@@@@?@?@?@@@??A@?@?@??A@?@A@??A@A@A?A@??A?A@A?A?A@??A?A?A?A?A?A?A?A?A?A?A?AAA?A?AAAtDkDnK}JnFcF~@}@vCoCTS@ApEiE@@?@@@?@@@@@?@@?@@@@@?@?@@@?@?@?@?@A@?@A@?@A?A@?@A?A@A@A?A?A@A?A@A?A?A?C?A?A@AAA?C?A?A?A?AAC?AAA`DyCxBqBHCp@o@ZWbA_Av@u@h@e@|@_AtAqADEh@g@|@s@jCeC",
                "path": [
                  {
                    "lat": 46.63591,
                    "lng": 16.20447
                  },
                  {
                    "lat": 46.63548,
                    "lng": 16.204880000000003
                  },
                  {
                    "lat": 46.6353,
                    "lng": 16.20505
                  },
                  {
                    "lat": 46.63519,
                    "lng": 16.205160000000003
                  },
                  {
                    "lat": 46.63472,
                    "lng": 16.2056
                  },
                  {
                    "lat": 46.6347,
                    "lng": 16.20562
                  },
                  {
                    "lat": 46.634620000000005,
                    "lng": 16.205720000000003
                  },
                  {
                    "lat": 46.63418,
                    "lng": 16.20615
                  },
                  {
                    "lat": 46.63414,
                    "lng": 16.20617
                  },
                  {
                    "lat": 46.63411000000001,
                    "lng": 16.20618
                  },
                  {
                    "lat": 46.633480000000006,
                    "lng": 16.2068
                  },
                  {
                    "lat": 46.63293,
                    "lng": 16.207340000000002
                  },
                  {
                    "lat": 46.63196000000001,
                    "lng": 16.208270000000002
                  },
                  {
                    "lat": 46.63194000000001,
                    "lng": 16.20832
                  },
                  {
                    "lat": 46.631930000000004,
                    "lng": 16.20833
                  },
                  {
                    "lat": 46.631780000000006,
                    "lng": 16.208470000000002
                  },
                  {
                    "lat": 46.631440000000005,
                    "lng": 16.2088
                  },
                  {
                    "lat": 46.630950000000006,
                    "lng": 16.20928
                  },
                  {
                    "lat": 46.630790000000005,
                    "lng": 16.20943
                  },
                  {
                    "lat": 46.63031,
                    "lng": 16.20989
                  },
                  {
                    "lat": 46.63017000000001,
                    "lng": 16.21001
                  },
                  {
                    "lat": 46.630160000000004,
                    "lng": 16.21
                  },
                  {
                    "lat": 46.630160000000004,
                    "lng": 16.20999
                  },
                  {
                    "lat": 46.63015,
                    "lng": 16.20998
                  },
                  {
                    "lat": 46.63015,
                    "lng": 16.209970000000002
                  },
                  {
                    "lat": 46.630140000000004,
                    "lng": 16.209970000000002
                  },
                  {
                    "lat": 46.63013,
                    "lng": 16.209960000000002
                  },
                  {
                    "lat": 46.630120000000005,
                    "lng": 16.209950000000003
                  },
                  {
                    "lat": 46.63011,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.630100000000006,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.63009,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.63008000000001,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.63007,
                    "lng": 16.20993
                  },
                  {
                    "lat": 46.63006,
                    "lng": 16.20993
                  },
                  {
                    "lat": 46.63006,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.630050000000004,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.63004,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.630030000000005,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.630030000000005,
                    "lng": 16.209950000000003
                  },
                  {
                    "lat": 46.63002,
                    "lng": 16.209950000000003
                  },
                  {
                    "lat": 46.630010000000006,
                    "lng": 16.209960000000002
                  },
                  {
                    "lat": 46.63,
                    "lng": 16.209960000000002
                  },
                  {
                    "lat": 46.63,
                    "lng": 16.209970000000002
                  },
                  {
                    "lat": 46.62999000000001,
                    "lng": 16.20998
                  },
                  {
                    "lat": 46.62998,
                    "lng": 16.20999
                  },
                  {
                    "lat": 46.62998,
                    "lng": 16.21
                  },
                  {
                    "lat": 46.62997000000001,
                    "lng": 16.21
                  },
                  {
                    "lat": 46.62997000000001,
                    "lng": 16.21001
                  },
                  {
                    "lat": 46.62997000000001,
                    "lng": 16.21002
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.21003
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.210040000000003
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.210050000000003
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210050000000003
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210060000000002
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21007
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21008
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21009
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.2101
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21011
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21012
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210130000000003
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210140000000003
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210150000000002
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210160000000002
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21017
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.21018
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.21019
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.2102
                  },
                  {
                    "lat": 46.62997000000001,
                    "lng": 16.21021
                  },
                  {
                    "lat": 46.62906,
                    "lng": 16.211070000000003
                  },
                  {
                    "lat": 46.62706000000001,
                    "lng": 16.21298
                  },
                  {
                    "lat": 46.62586,
                    "lng": 16.21412
                  },
                  {
                    "lat": 46.62554,
                    "lng": 16.21443
                  },
                  {
                    "lat": 46.62478,
                    "lng": 16.21515
                  },
                  {
                    "lat": 46.62467,
                    "lng": 16.21525
                  },
                  {
                    "lat": 46.624660000000006,
                    "lng": 16.21526
                  },
                  {
                    "lat": 46.623610000000006,
                    "lng": 16.21627
                  },
                  {
                    "lat": 46.6236,
                    "lng": 16.216260000000002
                  },
                  {
                    "lat": 46.6236,
                    "lng": 16.216250000000002
                  },
                  {
                    "lat": 46.62359000000001,
                    "lng": 16.216240000000003
                  },
                  {
                    "lat": 46.62359000000001,
                    "lng": 16.216230000000003
                  },
                  {
                    "lat": 46.623580000000004,
                    "lng": 16.21622
                  },
                  {
                    "lat": 46.62357,
                    "lng": 16.21621
                  },
                  {
                    "lat": 46.62357,
                    "lng": 16.2162
                  },
                  {
                    "lat": 46.623560000000005,
                    "lng": 16.2162
                  },
                  {
                    "lat": 46.62355,
                    "lng": 16.21619
                  },
                  {
                    "lat": 46.623540000000006,
                    "lng": 16.21618
                  },
                  {
                    "lat": 46.62353,
                    "lng": 16.21618
                  },
                  {
                    "lat": 46.623520000000006,
                    "lng": 16.21618
                  },
                  {
                    "lat": 46.62351,
                    "lng": 16.21617
                  },
                  {
                    "lat": 46.62350000000001,
                    "lng": 16.21617
                  },
                  {
                    "lat": 46.623490000000004,
                    "lng": 16.21617
                  },
                  {
                    "lat": 46.62348,
                    "lng": 16.21617
                  },
                  {
                    "lat": 46.623470000000005,
                    "lng": 16.21617
                  },
                  {
                    "lat": 46.62346,
                    "lng": 16.21618
                  },
                  {
                    "lat": 46.623450000000005,
                    "lng": 16.21618
                  },
                  {
                    "lat": 46.62344,
                    "lng": 16.21619
                  },
                  {
                    "lat": 46.623430000000006,
                    "lng": 16.21619
                  },
                  {
                    "lat": 46.62342,
                    "lng": 16.2162
                  },
                  {
                    "lat": 46.62342,
                    "lng": 16.21621
                  },
                  {
                    "lat": 46.62341000000001,
                    "lng": 16.21621
                  },
                  {
                    "lat": 46.623400000000004,
                    "lng": 16.21622
                  },
                  {
                    "lat": 46.623400000000004,
                    "lng": 16.216230000000003
                  },
                  {
                    "lat": 46.62339,
                    "lng": 16.216240000000003
                  },
                  {
                    "lat": 46.623380000000004,
                    "lng": 16.216250000000002
                  },
                  {
                    "lat": 46.623380000000004,
                    "lng": 16.216260000000002
                  },
                  {
                    "lat": 46.623380000000004,
                    "lng": 16.21627
                  },
                  {
                    "lat": 46.62337,
                    "lng": 16.21628
                  },
                  {
                    "lat": 46.62337,
                    "lng": 16.21629
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.2163
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.21631
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.21632
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.216340000000002
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.216350000000002
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.21636
                  },
                  {
                    "lat": 46.62335,
                    "lng": 16.21637
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.21638
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.2164
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.21641
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.216420000000003
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.216430000000003
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.216440000000002
                  },
                  {
                    "lat": 46.62337,
                    "lng": 16.21646
                  },
                  {
                    "lat": 46.62337,
                    "lng": 16.21647
                  },
                  {
                    "lat": 46.623380000000004,
                    "lng": 16.21648
                  },
                  {
                    "lat": 46.62257,
                    "lng": 16.21725
                  },
                  {
                    "lat": 46.62196,
                    "lng": 16.21782
                  },
                  {
                    "lat": 46.62191000000001,
                    "lng": 16.217840000000002
                  },
                  {
                    "lat": 46.621660000000006,
                    "lng": 16.21808
                  },
                  {
                    "lat": 46.621520000000004,
                    "lng": 16.218200000000003
                  },
                  {
                    "lat": 46.62118,
                    "lng": 16.21852
                  },
                  {
                    "lat": 46.620900000000006,
                    "lng": 16.218790000000002
                  },
                  {
                    "lat": 46.62069,
                    "lng": 16.218980000000002
                  },
                  {
                    "lat": 46.620380000000004,
                    "lng": 16.2193
                  },
                  {
                    "lat": 46.61995,
                    "lng": 16.219710000000003
                  },
                  {
                    "lat": 46.61992,
                    "lng": 16.21974
                  },
                  {
                    "lat": 46.619710000000005,
                    "lng": 16.21994
                  },
                  {
                    "lat": 46.619400000000006,
                    "lng": 16.220200000000002
                  },
                  {
                    "lat": 46.618700000000004,
                    "lng": 16.22087
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.63591,
                    "lng": 16.20447
                  },
                  {
                    "lat": 46.63548,
                    "lng": 16.204880000000003
                  },
                  {
                    "lat": 46.6353,
                    "lng": 16.20505
                  },
                  {
                    "lat": 46.63519,
                    "lng": 16.205160000000003
                  },
                  {
                    "lat": 46.63472,
                    "lng": 16.2056
                  },
                  {
                    "lat": 46.6347,
                    "lng": 16.20562
                  },
                  {
                    "lat": 46.634620000000005,
                    "lng": 16.205720000000003
                  },
                  {
                    "lat": 46.63418,
                    "lng": 16.20615
                  },
                  {
                    "lat": 46.63414,
                    "lng": 16.20617
                  },
                  {
                    "lat": 46.63411000000001,
                    "lng": 16.20618
                  },
                  {
                    "lat": 46.633480000000006,
                    "lng": 16.2068
                  },
                  {
                    "lat": 46.63293,
                    "lng": 16.207340000000002
                  },
                  {
                    "lat": 46.63196000000001,
                    "lng": 16.208270000000002
                  },
                  {
                    "lat": 46.63194000000001,
                    "lng": 16.20832
                  },
                  {
                    "lat": 46.631930000000004,
                    "lng": 16.20833
                  },
                  {
                    "lat": 46.631780000000006,
                    "lng": 16.208470000000002
                  },
                  {
                    "lat": 46.631440000000005,
                    "lng": 16.2088
                  },
                  {
                    "lat": 46.630950000000006,
                    "lng": 16.20928
                  },
                  {
                    "lat": 46.630790000000005,
                    "lng": 16.20943
                  },
                  {
                    "lat": 46.63031,
                    "lng": 16.20989
                  },
                  {
                    "lat": 46.63017000000001,
                    "lng": 16.21001
                  },
                  {
                    "lat": 46.630160000000004,
                    "lng": 16.21
                  },
                  {
                    "lat": 46.630160000000004,
                    "lng": 16.20999
                  },
                  {
                    "lat": 46.63015,
                    "lng": 16.20998
                  },
                  {
                    "lat": 46.63015,
                    "lng": 16.209970000000002
                  },
                  {
                    "lat": 46.630140000000004,
                    "lng": 16.209970000000002
                  },
                  {
                    "lat": 46.63013,
                    "lng": 16.209960000000002
                  },
                  {
                    "lat": 46.630120000000005,
                    "lng": 16.209950000000003
                  },
                  {
                    "lat": 46.63011,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.630100000000006,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.63009,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.63008000000001,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.63007,
                    "lng": 16.20993
                  },
                  {
                    "lat": 46.63006,
                    "lng": 16.20993
                  },
                  {
                    "lat": 46.63006,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.630050000000004,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.63004,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.630030000000005,
                    "lng": 16.20994
                  },
                  {
                    "lat": 46.630030000000005,
                    "lng": 16.209950000000003
                  },
                  {
                    "lat": 46.63002,
                    "lng": 16.209950000000003
                  },
                  {
                    "lat": 46.630010000000006,
                    "lng": 16.209960000000002
                  },
                  {
                    "lat": 46.63,
                    "lng": 16.209960000000002
                  },
                  {
                    "lat": 46.63,
                    "lng": 16.209970000000002
                  },
                  {
                    "lat": 46.62999000000001,
                    "lng": 16.20998
                  },
                  {
                    "lat": 46.62998,
                    "lng": 16.20999
                  },
                  {
                    "lat": 46.62998,
                    "lng": 16.21
                  },
                  {
                    "lat": 46.62997000000001,
                    "lng": 16.21
                  },
                  {
                    "lat": 46.62997000000001,
                    "lng": 16.21001
                  },
                  {
                    "lat": 46.62997000000001,
                    "lng": 16.21002
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.21003
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.210040000000003
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.210050000000003
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210050000000003
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210060000000002
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21007
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21008
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21009
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.2101
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21011
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21012
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210130000000003
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210140000000003
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210150000000002
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.210160000000002
                  },
                  {
                    "lat": 46.62995,
                    "lng": 16.21017
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.21018
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.21019
                  },
                  {
                    "lat": 46.629960000000004,
                    "lng": 16.2102
                  },
                  {
                    "lat": 46.62997000000001,
                    "lng": 16.21021
                  },
                  {
                    "lat": 46.62906,
                    "lng": 16.211070000000003
                  },
                  {
                    "lat": 46.62706000000001,
                    "lng": 16.21298
                  },
                  {
                    "lat": 46.62586,
                    "lng": 16.21412
                  },
                  {
                    "lat": 46.62554,
                    "lng": 16.21443
                  },
                  {
                    "lat": 46.62478,
                    "lng": 16.21515
                  },
                  {
                    "lat": 46.62467,
                    "lng": 16.21525
                  },
                  {
                    "lat": 46.624660000000006,
                    "lng": 16.21526
                  },
                  {
                    "lat": 46.623610000000006,
                    "lng": 16.21627
                  },
                  {
                    "lat": 46.6236,
                    "lng": 16.216260000000002
                  },
                  {
                    "lat": 46.6236,
                    "lng": 16.216250000000002
                  },
                  {
                    "lat": 46.62359000000001,
                    "lng": 16.216240000000003
                  },
                  {
                    "lat": 46.62359000000001,
                    "lng": 16.216230000000003
                  },
                  {
                    "lat": 46.623580000000004,
                    "lng": 16.21622
                  },
                  {
                    "lat": 46.62357,
                    "lng": 16.21621
                  },
                  {
                    "lat": 46.62357,
                    "lng": 16.2162
                  },
                  {
                    "lat": 46.623560000000005,
                    "lng": 16.2162
                  },
                  {
                    "lat": 46.62355,
                    "lng": 16.21619
                  },
                  {
                    "lat": 46.623540000000006,
                    "lng": 16.21618
                  },
                  {
                    "lat": 46.62353,
                    "lng": 16.21618
                  },
                  {
                    "lat": 46.623520000000006,
                    "lng": 16.21618
                  },
                  {
                    "lat": 46.62351,
                    "lng": 16.21617
                  },
                  {
                    "lat": 46.62350000000001,
                    "lng": 16.21617
                  },
                  {
                    "lat": 46.623490000000004,
                    "lng": 16.21617
                  },
                  {
                    "lat": 46.62348,
                    "lng": 16.21617
                  },
                  {
                    "lat": 46.623470000000005,
                    "lng": 16.21617
                  },
                  {
                    "lat": 46.62346,
                    "lng": 16.21618
                  },
                  {
                    "lat": 46.623450000000005,
                    "lng": 16.21618
                  },
                  {
                    "lat": 46.62344,
                    "lng": 16.21619
                  },
                  {
                    "lat": 46.623430000000006,
                    "lng": 16.21619
                  },
                  {
                    "lat": 46.62342,
                    "lng": 16.2162
                  },
                  {
                    "lat": 46.62342,
                    "lng": 16.21621
                  },
                  {
                    "lat": 46.62341000000001,
                    "lng": 16.21621
                  },
                  {
                    "lat": 46.623400000000004,
                    "lng": 16.21622
                  },
                  {
                    "lat": 46.623400000000004,
                    "lng": 16.216230000000003
                  },
                  {
                    "lat": 46.62339,
                    "lng": 16.216240000000003
                  },
                  {
                    "lat": 46.623380000000004,
                    "lng": 16.216250000000002
                  },
                  {
                    "lat": 46.623380000000004,
                    "lng": 16.216260000000002
                  },
                  {
                    "lat": 46.623380000000004,
                    "lng": 16.21627
                  },
                  {
                    "lat": 46.62337,
                    "lng": 16.21628
                  },
                  {
                    "lat": 46.62337,
                    "lng": 16.21629
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.2163
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.21631
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.21632
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.216340000000002
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.216350000000002
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.21636
                  },
                  {
                    "lat": 46.62335,
                    "lng": 16.21637
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.21638
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.2164
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.21641
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.216420000000003
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.216430000000003
                  },
                  {
                    "lat": 46.623360000000005,
                    "lng": 16.216440000000002
                  },
                  {
                    "lat": 46.62337,
                    "lng": 16.21646
                  },
                  {
                    "lat": 46.62337,
                    "lng": 16.21647
                  },
                  {
                    "lat": 46.623380000000004,
                    "lng": 16.21648
                  },
                  {
                    "lat": 46.62257,
                    "lng": 16.21725
                  },
                  {
                    "lat": 46.62196,
                    "lng": 16.21782
                  },
                  {
                    "lat": 46.62191000000001,
                    "lng": 16.217840000000002
                  },
                  {
                    "lat": 46.621660000000006,
                    "lng": 16.21808
                  },
                  {
                    "lat": 46.621520000000004,
                    "lng": 16.218200000000003
                  },
                  {
                    "lat": 46.62118,
                    "lng": 16.21852
                  },
                  {
                    "lat": 46.620900000000006,
                    "lng": 16.218790000000002
                  },
                  {
                    "lat": 46.62069,
                    "lng": 16.218980000000002
                  },
                  {
                    "lat": 46.620380000000004,
                    "lng": 16.2193
                  },
                  {
                    "lat": 46.61995,
                    "lng": 16.219710000000003
                  },
                  {
                    "lat": 46.61992,
                    "lng": 16.21974
                  },
                  {
                    "lat": 46.619710000000005,
                    "lng": 16.21994
                  },
                  {
                    "lat": 46.619400000000006,
                    "lng": 16.220200000000002
                  },
                  {
                    "lat": 46.618700000000004,
                    "lng": 16.22087
                  }
                ],
                "instructions": "Continue onto <b>Lipovci</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.635913,
                  "lng": 16.204473
                },
                "end_point": {
                  "lat": 46.6186981,
                  "lng": 16.2208664
                }
              },
              {
                "distance": {
                  "text": "0.9 km",
                  "value": 865
                },
                "duration": {
                  "text": "1 min",
                  "value": 56
                },
                "end_location": {
                  "lat": 46.6122163,
                  "lng": 16.227126
                },
                "polyline": {
                  "points": "{ep{Gmc_bBXUXYf@c@j@o@^_@@Gt@s@~@{@hCeC~ByBn@m@lF_FdD}CpBoBdAaAVUl@k@b@g@"
                },
                "start_location": {
                  "lat": 46.6186981,
                  "lng": 16.2208664
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "{ep{Gmc_bBXUXYf@c@j@o@^_@@Gt@s@~@{@hCeC~ByBn@m@lF_FdD}CpBoBdAaAVUl@k@b@g@",
                "path": [
                  {
                    "lat": 46.618700000000004,
                    "lng": 16.22087
                  },
                  {
                    "lat": 46.618570000000005,
                    "lng": 16.22098
                  },
                  {
                    "lat": 46.61844000000001,
                    "lng": 16.221110000000003
                  },
                  {
                    "lat": 46.61824000000001,
                    "lng": 16.22129
                  },
                  {
                    "lat": 46.61802,
                    "lng": 16.22153
                  },
                  {
                    "lat": 46.61786,
                    "lng": 16.221690000000002
                  },
                  {
                    "lat": 46.617850000000004,
                    "lng": 16.22173
                  },
                  {
                    "lat": 46.617580000000004,
                    "lng": 16.22199
                  },
                  {
                    "lat": 46.61726,
                    "lng": 16.22229
                  },
                  {
                    "lat": 46.61657,
                    "lng": 16.22296
                  },
                  {
                    "lat": 46.615930000000006,
                    "lng": 16.223570000000002
                  },
                  {
                    "lat": 46.61569,
                    "lng": 16.2238
                  },
                  {
                    "lat": 46.61450000000001,
                    "lng": 16.22492
                  },
                  {
                    "lat": 46.613670000000006,
                    "lng": 16.225710000000003
                  },
                  {
                    "lat": 46.6131,
                    "lng": 16.226270000000003
                  },
                  {
                    "lat": 46.612750000000005,
                    "lng": 16.2266
                  },
                  {
                    "lat": 46.61263,
                    "lng": 16.22671
                  },
                  {
                    "lat": 46.6124,
                    "lng": 16.226930000000003
                  },
                  {
                    "lat": 46.61222,
                    "lng": 16.227130000000002
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.618700000000004,
                    "lng": 16.22087
                  },
                  {
                    "lat": 46.618570000000005,
                    "lng": 16.22098
                  },
                  {
                    "lat": 46.61844000000001,
                    "lng": 16.221110000000003
                  },
                  {
                    "lat": 46.61824000000001,
                    "lng": 16.22129
                  },
                  {
                    "lat": 46.61802,
                    "lng": 16.22153
                  },
                  {
                    "lat": 46.61786,
                    "lng": 16.221690000000002
                  },
                  {
                    "lat": 46.617850000000004,
                    "lng": 16.22173
                  },
                  {
                    "lat": 46.617580000000004,
                    "lng": 16.22199
                  },
                  {
                    "lat": 46.61726,
                    "lng": 16.22229
                  },
                  {
                    "lat": 46.61657,
                    "lng": 16.22296
                  },
                  {
                    "lat": 46.615930000000006,
                    "lng": 16.223570000000002
                  },
                  {
                    "lat": 46.61569,
                    "lng": 16.2238
                  },
                  {
                    "lat": 46.61450000000001,
                    "lng": 16.22492
                  },
                  {
                    "lat": 46.613670000000006,
                    "lng": 16.225710000000003
                  },
                  {
                    "lat": 46.6131,
                    "lng": 16.226270000000003
                  },
                  {
                    "lat": 46.612750000000005,
                    "lng": 16.2266
                  },
                  {
                    "lat": 46.61263,
                    "lng": 16.22671
                  },
                  {
                    "lat": 46.6124,
                    "lng": 16.226930000000003
                  },
                  {
                    "lat": 46.61222,
                    "lng": 16.227130000000002
                  }
                ],
                "instructions": "Continue onto <b>Bratonci</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.6186981,
                  "lng": 16.2208664
                },
                "end_point": {
                  "lat": 46.6122163,
                  "lng": 16.227126
                }
              },
              {
                "distance": {
                  "text": "0.9 km",
                  "value": 897
                },
                "duration": {
                  "text": "1 min",
                  "value": 81
                },
                "end_location": {
                  "lat": 46.6079247,
                  "lng": 16.2364621
                },
                "polyline": {
                  "points": "k}n{Gqj`bBz@y@r@o@lAeAx@u@`@_@p@m@PCd@q@T_@Ti@Xy@Ns@n@cCTcABSBYFSx@eDt@kCbAmDn@{B\\iBPkAFc@Bc@Bu@DgB@e@"
                },
                "start_location": {
                  "lat": 46.6122163,
                  "lng": 16.227126
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "k}n{Gqj`bBz@y@r@o@lAeAx@u@`@_@p@m@PCd@q@T_@Ti@Xy@Ns@n@cCTcABSBYFSx@eDt@kCbAmDn@{B\\iBPkAFc@Bc@Bu@DgB@e@",
                "path": [
                  {
                    "lat": 46.61222,
                    "lng": 16.227130000000002
                  },
                  {
                    "lat": 46.611920000000005,
                    "lng": 16.227420000000002
                  },
                  {
                    "lat": 46.61166,
                    "lng": 16.22766
                  },
                  {
                    "lat": 46.611270000000005,
                    "lng": 16.22801
                  },
                  {
                    "lat": 46.610980000000005,
                    "lng": 16.22828
                  },
                  {
                    "lat": 46.61081,
                    "lng": 16.228440000000003
                  },
                  {
                    "lat": 46.61056000000001,
                    "lng": 16.22867
                  },
                  {
                    "lat": 46.61047000000001,
                    "lng": 16.22869
                  },
                  {
                    "lat": 46.61028,
                    "lng": 16.22894
                  },
                  {
                    "lat": 46.610170000000004,
                    "lng": 16.229100000000003
                  },
                  {
                    "lat": 46.610060000000004,
                    "lng": 16.22931
                  },
                  {
                    "lat": 46.609930000000006,
                    "lng": 16.2296
                  },
                  {
                    "lat": 46.60985,
                    "lng": 16.229860000000002
                  },
                  {
                    "lat": 46.60961,
                    "lng": 16.230520000000002
                  },
                  {
                    "lat": 46.609500000000004,
                    "lng": 16.23086
                  },
                  {
                    "lat": 46.609480000000005,
                    "lng": 16.23096
                  },
                  {
                    "lat": 46.609460000000006,
                    "lng": 16.231090000000002
                  },
                  {
                    "lat": 46.60942000000001,
                    "lng": 16.23119
                  },
                  {
                    "lat": 46.60913,
                    "lng": 16.232020000000002
                  },
                  {
                    "lat": 46.60886000000001,
                    "lng": 16.23272
                  },
                  {
                    "lat": 46.608520000000006,
                    "lng": 16.233590000000003
                  },
                  {
                    "lat": 46.60828,
                    "lng": 16.23421
                  },
                  {
                    "lat": 46.60813,
                    "lng": 16.234740000000002
                  },
                  {
                    "lat": 46.60804,
                    "lng": 16.235120000000002
                  },
                  {
                    "lat": 46.608000000000004,
                    "lng": 16.235300000000002
                  },
                  {
                    "lat": 46.607980000000005,
                    "lng": 16.235480000000003
                  },
                  {
                    "lat": 46.607960000000006,
                    "lng": 16.235750000000003
                  },
                  {
                    "lat": 46.60793,
                    "lng": 16.23627
                  },
                  {
                    "lat": 46.60792000000001,
                    "lng": 16.23646
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.61222,
                    "lng": 16.227130000000002
                  },
                  {
                    "lat": 46.611920000000005,
                    "lng": 16.227420000000002
                  },
                  {
                    "lat": 46.61166,
                    "lng": 16.22766
                  },
                  {
                    "lat": 46.611270000000005,
                    "lng": 16.22801
                  },
                  {
                    "lat": 46.610980000000005,
                    "lng": 16.22828
                  },
                  {
                    "lat": 46.61081,
                    "lng": 16.228440000000003
                  },
                  {
                    "lat": 46.61056000000001,
                    "lng": 16.22867
                  },
                  {
                    "lat": 46.61047000000001,
                    "lng": 16.22869
                  },
                  {
                    "lat": 46.61028,
                    "lng": 16.22894
                  },
                  {
                    "lat": 46.610170000000004,
                    "lng": 16.229100000000003
                  },
                  {
                    "lat": 46.610060000000004,
                    "lng": 16.22931
                  },
                  {
                    "lat": 46.609930000000006,
                    "lng": 16.2296
                  },
                  {
                    "lat": 46.60985,
                    "lng": 16.229860000000002
                  },
                  {
                    "lat": 46.60961,
                    "lng": 16.230520000000002
                  },
                  {
                    "lat": 46.609500000000004,
                    "lng": 16.23086
                  },
                  {
                    "lat": 46.609480000000005,
                    "lng": 16.23096
                  },
                  {
                    "lat": 46.609460000000006,
                    "lng": 16.231090000000002
                  },
                  {
                    "lat": 46.60942000000001,
                    "lng": 16.23119
                  },
                  {
                    "lat": 46.60913,
                    "lng": 16.232020000000002
                  },
                  {
                    "lat": 46.60886000000001,
                    "lng": 16.23272
                  },
                  {
                    "lat": 46.608520000000006,
                    "lng": 16.233590000000003
                  },
                  {
                    "lat": 46.60828,
                    "lng": 16.23421
                  },
                  {
                    "lat": 46.60813,
                    "lng": 16.234740000000002
                  },
                  {
                    "lat": 46.60804,
                    "lng": 16.235120000000002
                  },
                  {
                    "lat": 46.608000000000004,
                    "lng": 16.235300000000002
                  },
                  {
                    "lat": 46.607980000000005,
                    "lng": 16.235480000000003
                  },
                  {
                    "lat": 46.607960000000006,
                    "lng": 16.235750000000003
                  },
                  {
                    "lat": 46.60793,
                    "lng": 16.23627
                  },
                  {
                    "lat": 46.60792000000001,
                    "lng": 16.23646
                  }
                ],
                "instructions": "Continue onto <b>Panonska ul.</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.6122163,
                  "lng": 16.227126
                },
                "end_point": {
                  "lat": 46.6079247,
                  "lng": 16.2364621
                }
              },
              {
                "distance": {
                  "text": "0.3 km",
                  "value": 294
                },
                "duration": {
                  "text": "1 min",
                  "value": 31
                },
                "end_location": {
                  "lat": 46.6058298,
                  "lng": 16.2343881
                },
                "maneuver": "turn-right",
                "polyline": {
                  "points": "obn{G{dbbBfAF`@DLFJFf@f@f@h@FFLJNLPNJNJPFLXn@Vj@bAnB"
                },
                "start_location": {
                  "lat": 46.6079247,
                  "lng": 16.2364621
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "obn{G{dbbBfAF`@DLFJFf@f@f@h@FFLJNLPNJNJPFLXn@Vj@bAnB",
                "path": [
                  {
                    "lat": 46.60792000000001,
                    "lng": 16.23646
                  },
                  {
                    "lat": 46.60756000000001,
                    "lng": 16.236420000000003
                  },
                  {
                    "lat": 46.60739,
                    "lng": 16.23639
                  },
                  {
                    "lat": 46.60732,
                    "lng": 16.23635
                  },
                  {
                    "lat": 46.607260000000004,
                    "lng": 16.23631
                  },
                  {
                    "lat": 46.607060000000004,
                    "lng": 16.23611
                  },
                  {
                    "lat": 46.606860000000005,
                    "lng": 16.2359
                  },
                  {
                    "lat": 46.606820000000006,
                    "lng": 16.235860000000002
                  },
                  {
                    "lat": 46.606750000000005,
                    "lng": 16.2358
                  },
                  {
                    "lat": 46.60667,
                    "lng": 16.23573
                  },
                  {
                    "lat": 46.60658,
                    "lng": 16.23565
                  },
                  {
                    "lat": 46.60652,
                    "lng": 16.235570000000003
                  },
                  {
                    "lat": 46.606460000000006,
                    "lng": 16.235480000000003
                  },
                  {
                    "lat": 46.60642000000001,
                    "lng": 16.23541
                  },
                  {
                    "lat": 46.60629,
                    "lng": 16.23517
                  },
                  {
                    "lat": 46.606170000000006,
                    "lng": 16.23495
                  },
                  {
                    "lat": 46.605830000000005,
                    "lng": 16.23439
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.60792000000001,
                    "lng": 16.23646
                  },
                  {
                    "lat": 46.60756000000001,
                    "lng": 16.236420000000003
                  },
                  {
                    "lat": 46.60739,
                    "lng": 16.23639
                  },
                  {
                    "lat": 46.60732,
                    "lng": 16.23635
                  },
                  {
                    "lat": 46.607260000000004,
                    "lng": 16.23631
                  },
                  {
                    "lat": 46.607060000000004,
                    "lng": 16.23611
                  },
                  {
                    "lat": 46.606860000000005,
                    "lng": 16.2359
                  },
                  {
                    "lat": 46.606820000000006,
                    "lng": 16.235860000000002
                  },
                  {
                    "lat": 46.606750000000005,
                    "lng": 16.2358
                  },
                  {
                    "lat": 46.60667,
                    "lng": 16.23573
                  },
                  {
                    "lat": 46.60658,
                    "lng": 16.23565
                  },
                  {
                    "lat": 46.60652,
                    "lng": 16.235570000000003
                  },
                  {
                    "lat": 46.606460000000006,
                    "lng": 16.235480000000003
                  },
                  {
                    "lat": 46.60642000000001,
                    "lng": 16.23541
                  },
                  {
                    "lat": 46.60629,
                    "lng": 16.23517
                  },
                  {
                    "lat": 46.606170000000006,
                    "lng": 16.23495
                  },
                  {
                    "lat": 46.605830000000005,
                    "lng": 16.23439
                  }
                ],
                "instructions": "Turn <b>right</b> onto <b>Mladinska ulica</b>",
                "start_point": {
                  "lat": 46.6079247,
                  "lng": 16.2364621
                },
                "end_point": {
                  "lat": 46.6058298,
                  "lng": 16.2343881
                }
              },
              {
                "distance": {
                  "text": "5.4 km",
                  "value": 5360
                },
                "duration": {
                  "text": "5 mins",
                  "value": 281
                },
                "end_location": {
                  "lat": 46.5611277,
                  "lng": 16.2587651
                },
                "maneuver": "turn-slight-left",
                "polyline": {
                  "points": "mum{G}wabBHHLJNHjAf@f@Tv@PnA\\xAVZ@T?XCZGf@MPI^QVO|CcBzBiAf@WTMhCqAtCwApAq@`FcC`CmAPKlGaD|GiDfIcEJETKfEuB^SnLaGNI`By@`@SxJ_FBC|C{ArCwA~CaBLGXOFAdOuHDC|NmHLGnJ}EvAq@pMsGHCxAy@fAk@jFiC`MoGxC{AtSgKjIgE\\Ob@W`CiAbEsBjDgBh@WZQNI"
                },
                "start_location": {
                  "lat": 46.6058298,
                  "lng": 16.2343881
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "mum{G}wabBHHLJNHjAf@f@Tv@PnA\\xAVZ@T?XCZGf@MPI^QVO|CcBzBiAf@WTMhCqAtCwApAq@`FcC`CmAPKlGaD|GiDfIcEJETKfEuB^SnLaGNI`By@`@SxJ_FBC|C{ArCwA~CaBLGXOFAdOuHDC|NmHLGnJ}EvAq@pMsGHCxAy@fAk@jFiC`MoGxC{AtSgKjIgE\\Ob@W`CiAbEsBjDgBh@WZQNI",
                "path": [
                  {
                    "lat": 46.605830000000005,
                    "lng": 16.23439
                  },
                  {
                    "lat": 46.60578,
                    "lng": 16.234340000000003
                  },
                  {
                    "lat": 46.60571,
                    "lng": 16.234280000000002
                  },
                  {
                    "lat": 46.605630000000005,
                    "lng": 16.23423
                  },
                  {
                    "lat": 46.605250000000005,
                    "lng": 16.23403
                  },
                  {
                    "lat": 46.605050000000006,
                    "lng": 16.23392
                  },
                  {
                    "lat": 46.60477,
                    "lng": 16.23383
                  },
                  {
                    "lat": 46.60437,
                    "lng": 16.23368
                  },
                  {
                    "lat": 46.60392,
                    "lng": 16.23356
                  },
                  {
                    "lat": 46.60378,
                    "lng": 16.23355
                  },
                  {
                    "lat": 46.60367,
                    "lng": 16.23355
                  },
                  {
                    "lat": 46.60354,
                    "lng": 16.23357
                  },
                  {
                    "lat": 46.6034,
                    "lng": 16.233610000000002
                  },
                  {
                    "lat": 46.6032,
                    "lng": 16.23368
                  },
                  {
                    "lat": 46.60311,
                    "lng": 16.23373
                  },
                  {
                    "lat": 46.60295000000001,
                    "lng": 16.23382
                  },
                  {
                    "lat": 46.602830000000004,
                    "lng": 16.233900000000002
                  },
                  {
                    "lat": 46.60204,
                    "lng": 16.2344
                  },
                  {
                    "lat": 46.601420000000005,
                    "lng": 16.23477
                  },
                  {
                    "lat": 46.601220000000005,
                    "lng": 16.23489
                  },
                  {
                    "lat": 46.601110000000006,
                    "lng": 16.23496
                  },
                  {
                    "lat": 46.60042000000001,
                    "lng": 16.23537
                  },
                  {
                    "lat": 46.59967,
                    "lng": 16.23581
                  },
                  {
                    "lat": 46.59926,
                    "lng": 16.236060000000002
                  },
                  {
                    "lat": 46.598130000000005,
                    "lng": 16.236720000000002
                  },
                  {
                    "lat": 46.597480000000004,
                    "lng": 16.23711
                  },
                  {
                    "lat": 46.597390000000004,
                    "lng": 16.237170000000003
                  },
                  {
                    "lat": 46.59604,
                    "lng": 16.23798
                  },
                  {
                    "lat": 46.59461,
                    "lng": 16.23883
                  },
                  {
                    "lat": 46.59297,
                    "lng": 16.239810000000002
                  },
                  {
                    "lat": 46.59291,
                    "lng": 16.23984
                  },
                  {
                    "lat": 46.592800000000004,
                    "lng": 16.239900000000002
                  },
                  {
                    "lat": 46.591800000000006,
                    "lng": 16.24049
                  },
                  {
                    "lat": 46.591640000000005,
                    "lng": 16.24059
                  },
                  {
                    "lat": 46.58948,
                    "lng": 16.241880000000002
                  },
                  {
                    "lat": 46.589400000000005,
                    "lng": 16.24193
                  },
                  {
                    "lat": 46.588910000000006,
                    "lng": 16.24222
                  },
                  {
                    "lat": 46.58874,
                    "lng": 16.242320000000003
                  },
                  {
                    "lat": 46.586850000000005,
                    "lng": 16.24344
                  },
                  {
                    "lat": 46.586830000000006,
                    "lng": 16.243460000000002
                  },
                  {
                    "lat": 46.586040000000004,
                    "lng": 16.243920000000003
                  },
                  {
                    "lat": 46.585300000000004,
                    "lng": 16.24436
                  },
                  {
                    "lat": 46.584500000000006,
                    "lng": 16.24485
                  },
                  {
                    "lat": 46.584430000000005,
                    "lng": 16.24489
                  },
                  {
                    "lat": 46.584300000000006,
                    "lng": 16.244970000000002
                  },
                  {
                    "lat": 46.58426,
                    "lng": 16.24498
                  },
                  {
                    "lat": 46.58167,
                    "lng": 16.24653
                  },
                  {
                    "lat": 46.58164000000001,
                    "lng": 16.246550000000003
                  },
                  {
                    "lat": 46.57909,
                    "lng": 16.248060000000002
                  },
                  {
                    "lat": 46.57902000000001,
                    "lng": 16.2481
                  },
                  {
                    "lat": 46.577180000000006,
                    "lng": 16.24921
                  },
                  {
                    "lat": 46.57674,
                    "lng": 16.249460000000003
                  },
                  {
                    "lat": 46.57441,
                    "lng": 16.25084
                  },
                  {
                    "lat": 46.574360000000006,
                    "lng": 16.250860000000003
                  },
                  {
                    "lat": 46.573910000000005,
                    "lng": 16.251150000000003
                  },
                  {
                    "lat": 46.573550000000004,
                    "lng": 16.25137
                  },
                  {
                    "lat": 46.57237000000001,
                    "lng": 16.25206
                  },
                  {
                    "lat": 46.57012,
                    "lng": 16.253420000000002
                  },
                  {
                    "lat": 46.56935000000001,
                    "lng": 16.253880000000002
                  },
                  {
                    "lat": 46.56604,
                    "lng": 16.255840000000003
                  },
                  {
                    "lat": 46.56438000000001,
                    "lng": 16.25684
                  },
                  {
                    "lat": 46.56423,
                    "lng": 16.25692
                  },
                  {
                    "lat": 46.56405,
                    "lng": 16.25704
                  },
                  {
                    "lat": 46.5634,
                    "lng": 16.25741
                  },
                  {
                    "lat": 46.56242,
                    "lng": 16.257990000000003
                  },
                  {
                    "lat": 46.56156000000001,
                    "lng": 16.25851
                  },
                  {
                    "lat": 46.561350000000004,
                    "lng": 16.25863
                  },
                  {
                    "lat": 46.56121,
                    "lng": 16.25872
                  },
                  {
                    "lat": 46.561130000000006,
                    "lng": 16.258770000000002
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.605830000000005,
                    "lng": 16.23439
                  },
                  {
                    "lat": 46.60578,
                    "lng": 16.234340000000003
                  },
                  {
                    "lat": 46.60571,
                    "lng": 16.234280000000002
                  },
                  {
                    "lat": 46.605630000000005,
                    "lng": 16.23423
                  },
                  {
                    "lat": 46.605250000000005,
                    "lng": 16.23403
                  },
                  {
                    "lat": 46.605050000000006,
                    "lng": 16.23392
                  },
                  {
                    "lat": 46.60477,
                    "lng": 16.23383
                  },
                  {
                    "lat": 46.60437,
                    "lng": 16.23368
                  },
                  {
                    "lat": 46.60392,
                    "lng": 16.23356
                  },
                  {
                    "lat": 46.60378,
                    "lng": 16.23355
                  },
                  {
                    "lat": 46.60367,
                    "lng": 16.23355
                  },
                  {
                    "lat": 46.60354,
                    "lng": 16.23357
                  },
                  {
                    "lat": 46.6034,
                    "lng": 16.233610000000002
                  },
                  {
                    "lat": 46.6032,
                    "lng": 16.23368
                  },
                  {
                    "lat": 46.60311,
                    "lng": 16.23373
                  },
                  {
                    "lat": 46.60295000000001,
                    "lng": 16.23382
                  },
                  {
                    "lat": 46.602830000000004,
                    "lng": 16.233900000000002
                  },
                  {
                    "lat": 46.60204,
                    "lng": 16.2344
                  },
                  {
                    "lat": 46.601420000000005,
                    "lng": 16.23477
                  },
                  {
                    "lat": 46.601220000000005,
                    "lng": 16.23489
                  },
                  {
                    "lat": 46.601110000000006,
                    "lng": 16.23496
                  },
                  {
                    "lat": 46.60042000000001,
                    "lng": 16.23537
                  },
                  {
                    "lat": 46.59967,
                    "lng": 16.23581
                  },
                  {
                    "lat": 46.59926,
                    "lng": 16.236060000000002
                  },
                  {
                    "lat": 46.598130000000005,
                    "lng": 16.236720000000002
                  },
                  {
                    "lat": 46.597480000000004,
                    "lng": 16.23711
                  },
                  {
                    "lat": 46.597390000000004,
                    "lng": 16.237170000000003
                  },
                  {
                    "lat": 46.59604,
                    "lng": 16.23798
                  },
                  {
                    "lat": 46.59461,
                    "lng": 16.23883
                  },
                  {
                    "lat": 46.59297,
                    "lng": 16.239810000000002
                  },
                  {
                    "lat": 46.59291,
                    "lng": 16.23984
                  },
                  {
                    "lat": 46.592800000000004,
                    "lng": 16.239900000000002
                  },
                  {
                    "lat": 46.591800000000006,
                    "lng": 16.24049
                  },
                  {
                    "lat": 46.591640000000005,
                    "lng": 16.24059
                  },
                  {
                    "lat": 46.58948,
                    "lng": 16.241880000000002
                  },
                  {
                    "lat": 46.589400000000005,
                    "lng": 16.24193
                  },
                  {
                    "lat": 46.588910000000006,
                    "lng": 16.24222
                  },
                  {
                    "lat": 46.58874,
                    "lng": 16.242320000000003
                  },
                  {
                    "lat": 46.586850000000005,
                    "lng": 16.24344
                  },
                  {
                    "lat": 46.586830000000006,
                    "lng": 16.243460000000002
                  },
                  {
                    "lat": 46.586040000000004,
                    "lng": 16.243920000000003
                  },
                  {
                    "lat": 46.585300000000004,
                    "lng": 16.24436
                  },
                  {
                    "lat": 46.584500000000006,
                    "lng": 16.24485
                  },
                  {
                    "lat": 46.584430000000005,
                    "lng": 16.24489
                  },
                  {
                    "lat": 46.584300000000006,
                    "lng": 16.244970000000002
                  },
                  {
                    "lat": 46.58426,
                    "lng": 16.24498
                  },
                  {
                    "lat": 46.58167,
                    "lng": 16.24653
                  },
                  {
                    "lat": 46.58164000000001,
                    "lng": 16.246550000000003
                  },
                  {
                    "lat": 46.57909,
                    "lng": 16.248060000000002
                  },
                  {
                    "lat": 46.57902000000001,
                    "lng": 16.2481
                  },
                  {
                    "lat": 46.577180000000006,
                    "lng": 16.24921
                  },
                  {
                    "lat": 46.57674,
                    "lng": 16.249460000000003
                  },
                  {
                    "lat": 46.57441,
                    "lng": 16.25084
                  },
                  {
                    "lat": 46.574360000000006,
                    "lng": 16.250860000000003
                  },
                  {
                    "lat": 46.573910000000005,
                    "lng": 16.251150000000003
                  },
                  {
                    "lat": 46.573550000000004,
                    "lng": 16.25137
                  },
                  {
                    "lat": 46.57237000000001,
                    "lng": 16.25206
                  },
                  {
                    "lat": 46.57012,
                    "lng": 16.253420000000002
                  },
                  {
                    "lat": 46.56935000000001,
                    "lng": 16.253880000000002
                  },
                  {
                    "lat": 46.56604,
                    "lng": 16.255840000000003
                  },
                  {
                    "lat": 46.56438000000001,
                    "lng": 16.25684
                  },
                  {
                    "lat": 46.56423,
                    "lng": 16.25692
                  },
                  {
                    "lat": 46.56405,
                    "lng": 16.25704
                  },
                  {
                    "lat": 46.5634,
                    "lng": 16.25741
                  },
                  {
                    "lat": 46.56242,
                    "lng": 16.257990000000003
                  },
                  {
                    "lat": 46.56156000000001,
                    "lng": 16.25851
                  },
                  {
                    "lat": 46.561350000000004,
                    "lng": 16.25863
                  },
                  {
                    "lat": 46.56121,
                    "lng": 16.25872
                  },
                  {
                    "lat": 46.561130000000006,
                    "lng": 16.258770000000002
                  }
                ],
                "instructions": "Slight <b>left</b> onto <b>Ravenska cesta</b>",
                "start_point": {
                  "lat": 46.6058298,
                  "lng": 16.2343881
                },
                "end_point": {
                  "lat": 46.5611277,
                  "lng": 16.2587651
                }
              },
              {
                "distance": {
                  "text": "0.5 km",
                  "value": 454
                },
                "duration": {
                  "text": "1 min",
                  "value": 30
                },
                "end_location": {
                  "lat": 46.5592561,
                  "lng": 16.2639089
                },
                "maneuver": "turn-left",
                "polyline": {
                  "points": "a~d{GipfbBL{@RcAl@aDj@aDr@}DTwARgAH]HYBEFMHQNUb@g@^c@\\a@"
                },
                "start_location": {
                  "lat": 46.5611277,
                  "lng": 16.2587651
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "a~d{GipfbBL{@RcAl@aDj@aDr@}DTwARgAH]HYBEFMHQNUb@g@^c@\\a@",
                "path": [
                  {
                    "lat": 46.561130000000006,
                    "lng": 16.258770000000002
                  },
                  {
                    "lat": 46.561060000000005,
                    "lng": 16.25907
                  },
                  {
                    "lat": 46.56096,
                    "lng": 16.259410000000003
                  },
                  {
                    "lat": 46.56073000000001,
                    "lng": 16.26022
                  },
                  {
                    "lat": 46.56051,
                    "lng": 16.26103
                  },
                  {
                    "lat": 46.56025,
                    "lng": 16.26198
                  },
                  {
                    "lat": 46.560140000000004,
                    "lng": 16.262420000000002
                  },
                  {
                    "lat": 46.56004,
                    "lng": 16.262780000000003
                  },
                  {
                    "lat": 46.559990000000006,
                    "lng": 16.26293
                  },
                  {
                    "lat": 46.559940000000005,
                    "lng": 16.263060000000003
                  },
                  {
                    "lat": 46.559920000000005,
                    "lng": 16.263090000000002
                  },
                  {
                    "lat": 46.55988000000001,
                    "lng": 16.263160000000003
                  },
                  {
                    "lat": 46.559830000000005,
                    "lng": 16.263250000000003
                  },
                  {
                    "lat": 46.55975,
                    "lng": 16.263360000000002
                  },
                  {
                    "lat": 46.55957,
                    "lng": 16.263560000000002
                  },
                  {
                    "lat": 46.55941000000001,
                    "lng": 16.263740000000002
                  },
                  {
                    "lat": 46.55926,
                    "lng": 16.263910000000003
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.561130000000006,
                    "lng": 16.258770000000002
                  },
                  {
                    "lat": 46.561060000000005,
                    "lng": 16.25907
                  },
                  {
                    "lat": 46.56096,
                    "lng": 16.259410000000003
                  },
                  {
                    "lat": 46.56073000000001,
                    "lng": 16.26022
                  },
                  {
                    "lat": 46.56051,
                    "lng": 16.26103
                  },
                  {
                    "lat": 46.56025,
                    "lng": 16.26198
                  },
                  {
                    "lat": 46.560140000000004,
                    "lng": 16.262420000000002
                  },
                  {
                    "lat": 46.56004,
                    "lng": 16.262780000000003
                  },
                  {
                    "lat": 46.559990000000006,
                    "lng": 16.26293
                  },
                  {
                    "lat": 46.559940000000005,
                    "lng": 16.263060000000003
                  },
                  {
                    "lat": 46.559920000000005,
                    "lng": 16.263090000000002
                  },
                  {
                    "lat": 46.55988000000001,
                    "lng": 16.263160000000003
                  },
                  {
                    "lat": 46.559830000000005,
                    "lng": 16.263250000000003
                  },
                  {
                    "lat": 46.55975,
                    "lng": 16.263360000000002
                  },
                  {
                    "lat": 46.55957,
                    "lng": 16.263560000000002
                  },
                  {
                    "lat": 46.55941000000001,
                    "lng": 16.263740000000002
                  },
                  {
                    "lat": 46.55926,
                    "lng": 16.263910000000003
                  }
                ],
                "instructions": "Turn <b>left</b> at <b>Gornja Bistrica</b>",
                "start_point": {
                  "lat": 46.5611277,
                  "lng": 16.2587651
                },
                "end_point": {
                  "lat": 46.5592561,
                  "lng": 16.2639089
                }
              },
              {
                "distance": {
                  "text": "1.0 km",
                  "value": 953
                },
                "duration": {
                  "text": "1 min",
                  "value": 75
                },
                "end_location": {
                  "lat": 46.5536288,
                  "lng": 16.2730746
                },
                "polyline": {
                  "points": "krd{GmpgbBX[b@e@NQZa@NWRYNWf@{@HOHKNQNODELO\\[RSNQFGJQFOH[F_@Hi@F]DWJe@Lm@FWHQHQJMJMPQRSZYp@o@LONSZk@DMh@eAjAgCx@gBhAiC`DeHL_@b@oA"
                },
                "start_location": {
                  "lat": 46.5592561,
                  "lng": 16.2639089
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "krd{GmpgbBX[b@e@NQZa@NWRYNWf@{@HOHKNQNODELO\\[RSNQFGJQFOH[F_@Hi@F]DWJe@Lm@FWHQHQJMJMPQRSZYp@o@LONSZk@DMh@eAjAgCx@gBhAiC`DeHL_@b@oA",
                "path": [
                  {
                    "lat": 46.55926,
                    "lng": 16.263910000000003
                  },
                  {
                    "lat": 46.55913,
                    "lng": 16.26405
                  },
                  {
                    "lat": 46.55895,
                    "lng": 16.26424
                  },
                  {
                    "lat": 46.558870000000006,
                    "lng": 16.26433
                  },
                  {
                    "lat": 46.558730000000004,
                    "lng": 16.2645
                  },
                  {
                    "lat": 46.55865000000001,
                    "lng": 16.26462
                  },
                  {
                    "lat": 46.558550000000004,
                    "lng": 16.264750000000003
                  },
                  {
                    "lat": 46.55847000000001,
                    "lng": 16.264870000000002
                  },
                  {
                    "lat": 46.55827,
                    "lng": 16.26517
                  },
                  {
                    "lat": 46.558220000000006,
                    "lng": 16.26525
                  },
                  {
                    "lat": 46.558170000000004,
                    "lng": 16.265310000000003
                  },
                  {
                    "lat": 46.55809000000001,
                    "lng": 16.2654
                  },
                  {
                    "lat": 46.55801,
                    "lng": 16.26548
                  },
                  {
                    "lat": 46.55798,
                    "lng": 16.265510000000003
                  },
                  {
                    "lat": 46.55791000000001,
                    "lng": 16.265590000000003
                  },
                  {
                    "lat": 46.55776,
                    "lng": 16.26573
                  },
                  {
                    "lat": 46.557660000000006,
                    "lng": 16.26583
                  },
                  {
                    "lat": 46.55758,
                    "lng": 16.26592
                  },
                  {
                    "lat": 46.55754,
                    "lng": 16.26596
                  },
                  {
                    "lat": 46.557480000000005,
                    "lng": 16.26605
                  },
                  {
                    "lat": 46.55744000000001,
                    "lng": 16.26613
                  },
                  {
                    "lat": 46.557390000000005,
                    "lng": 16.266270000000002
                  },
                  {
                    "lat": 46.55735000000001,
                    "lng": 16.26643
                  },
                  {
                    "lat": 46.557300000000005,
                    "lng": 16.266640000000002
                  },
                  {
                    "lat": 46.55726000000001,
                    "lng": 16.26679
                  },
                  {
                    "lat": 46.557230000000004,
                    "lng": 16.266910000000003
                  },
                  {
                    "lat": 46.557170000000006,
                    "lng": 16.267100000000003
                  },
                  {
                    "lat": 46.557100000000005,
                    "lng": 16.26733
                  },
                  {
                    "lat": 46.55706000000001,
                    "lng": 16.26745
                  },
                  {
                    "lat": 46.557010000000005,
                    "lng": 16.26754
                  },
                  {
                    "lat": 46.556960000000004,
                    "lng": 16.26763
                  },
                  {
                    "lat": 46.556900000000006,
                    "lng": 16.2677
                  },
                  {
                    "lat": 46.55684,
                    "lng": 16.267770000000002
                  },
                  {
                    "lat": 46.55675,
                    "lng": 16.267860000000002
                  },
                  {
                    "lat": 46.556650000000005,
                    "lng": 16.267960000000002
                  },
                  {
                    "lat": 46.55651,
                    "lng": 16.26809
                  },
                  {
                    "lat": 46.55626,
                    "lng": 16.268330000000002
                  },
                  {
                    "lat": 46.55619,
                    "lng": 16.268410000000003
                  },
                  {
                    "lat": 46.556110000000004,
                    "lng": 16.268510000000003
                  },
                  {
                    "lat": 46.55597,
                    "lng": 16.26873
                  },
                  {
                    "lat": 46.55594000000001,
                    "lng": 16.268800000000002
                  },
                  {
                    "lat": 46.555730000000004,
                    "lng": 16.26915
                  },
                  {
                    "lat": 46.555350000000004,
                    "lng": 16.269830000000002
                  },
                  {
                    "lat": 46.555060000000005,
                    "lng": 16.27035
                  },
                  {
                    "lat": 46.55469,
                    "lng": 16.271040000000003
                  },
                  {
                    "lat": 46.55388000000001,
                    "lng": 16.27251
                  },
                  {
                    "lat": 46.553810000000006,
                    "lng": 16.27267
                  },
                  {
                    "lat": 46.553630000000005,
                    "lng": 16.27307
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.55926,
                    "lng": 16.263910000000003
                  },
                  {
                    "lat": 46.55913,
                    "lng": 16.26405
                  },
                  {
                    "lat": 46.55895,
                    "lng": 16.26424
                  },
                  {
                    "lat": 46.558870000000006,
                    "lng": 16.26433
                  },
                  {
                    "lat": 46.558730000000004,
                    "lng": 16.2645
                  },
                  {
                    "lat": 46.55865000000001,
                    "lng": 16.26462
                  },
                  {
                    "lat": 46.558550000000004,
                    "lng": 16.264750000000003
                  },
                  {
                    "lat": 46.55847000000001,
                    "lng": 16.264870000000002
                  },
                  {
                    "lat": 46.55827,
                    "lng": 16.26517
                  },
                  {
                    "lat": 46.558220000000006,
                    "lng": 16.26525
                  },
                  {
                    "lat": 46.558170000000004,
                    "lng": 16.265310000000003
                  },
                  {
                    "lat": 46.55809000000001,
                    "lng": 16.2654
                  },
                  {
                    "lat": 46.55801,
                    "lng": 16.26548
                  },
                  {
                    "lat": 46.55798,
                    "lng": 16.265510000000003
                  },
                  {
                    "lat": 46.55791000000001,
                    "lng": 16.265590000000003
                  },
                  {
                    "lat": 46.55776,
                    "lng": 16.26573
                  },
                  {
                    "lat": 46.557660000000006,
                    "lng": 16.26583
                  },
                  {
                    "lat": 46.55758,
                    "lng": 16.26592
                  },
                  {
                    "lat": 46.55754,
                    "lng": 16.26596
                  },
                  {
                    "lat": 46.557480000000005,
                    "lng": 16.26605
                  },
                  {
                    "lat": 46.55744000000001,
                    "lng": 16.26613
                  },
                  {
                    "lat": 46.557390000000005,
                    "lng": 16.266270000000002
                  },
                  {
                    "lat": 46.55735000000001,
                    "lng": 16.26643
                  },
                  {
                    "lat": 46.557300000000005,
                    "lng": 16.266640000000002
                  },
                  {
                    "lat": 46.55726000000001,
                    "lng": 16.26679
                  },
                  {
                    "lat": 46.557230000000004,
                    "lng": 16.266910000000003
                  },
                  {
                    "lat": 46.557170000000006,
                    "lng": 16.267100000000003
                  },
                  {
                    "lat": 46.557100000000005,
                    "lng": 16.26733
                  },
                  {
                    "lat": 46.55706000000001,
                    "lng": 16.26745
                  },
                  {
                    "lat": 46.557010000000005,
                    "lng": 16.26754
                  },
                  {
                    "lat": 46.556960000000004,
                    "lng": 16.26763
                  },
                  {
                    "lat": 46.556900000000006,
                    "lng": 16.2677
                  },
                  {
                    "lat": 46.55684,
                    "lng": 16.267770000000002
                  },
                  {
                    "lat": 46.55675,
                    "lng": 16.267860000000002
                  },
                  {
                    "lat": 46.556650000000005,
                    "lng": 16.267960000000002
                  },
                  {
                    "lat": 46.55651,
                    "lng": 16.26809
                  },
                  {
                    "lat": 46.55626,
                    "lng": 16.268330000000002
                  },
                  {
                    "lat": 46.55619,
                    "lng": 16.268410000000003
                  },
                  {
                    "lat": 46.556110000000004,
                    "lng": 16.268510000000003
                  },
                  {
                    "lat": 46.55597,
                    "lng": 16.26873
                  },
                  {
                    "lat": 46.55594000000001,
                    "lng": 16.268800000000002
                  },
                  {
                    "lat": 46.555730000000004,
                    "lng": 16.26915
                  },
                  {
                    "lat": 46.555350000000004,
                    "lng": 16.269830000000002
                  },
                  {
                    "lat": 46.555060000000005,
                    "lng": 16.27035
                  },
                  {
                    "lat": 46.55469,
                    "lng": 16.271040000000003
                  },
                  {
                    "lat": 46.55388000000001,
                    "lng": 16.27251
                  },
                  {
                    "lat": 46.553810000000006,
                    "lng": 16.27267
                  },
                  {
                    "lat": 46.553630000000005,
                    "lng": 16.27307
                  }
                ],
                "instructions": "Continue onto <b>Gornja Bistrica</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.5592561,
                  "lng": 16.2639089
                },
                "end_point": {
                  "lat": 46.5536288,
                  "lng": 16.2730746
                }
              },
              {
                "distance": {
                  "text": "0.1 km",
                  "value": 95
                },
                "duration": {
                  "text": "1 min",
                  "value": 10
                },
                "end_location": {
                  "lat": 46.552915,
                  "lng": 16.2724096
                },
                "maneuver": "turn-right",
                "polyline": {
                  "points": "eoc{GuiibBp@t@f@f@PPNHHDFB"
                },
                "start_location": {
                  "lat": 46.5536288,
                  "lng": 16.2730746
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "eoc{GuiibBp@t@f@f@PPNHHDFB",
                "path": [
                  {
                    "lat": 46.553630000000005,
                    "lng": 16.27307
                  },
                  {
                    "lat": 46.553380000000004,
                    "lng": 16.2728
                  },
                  {
                    "lat": 46.553180000000005,
                    "lng": 16.2726
                  },
                  {
                    "lat": 46.553090000000005,
                    "lng": 16.27251
                  },
                  {
                    "lat": 46.55301,
                    "lng": 16.272460000000002
                  },
                  {
                    "lat": 46.552960000000006,
                    "lng": 16.27243
                  },
                  {
                    "lat": 46.55292,
                    "lng": 16.27241
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.553630000000005,
                    "lng": 16.27307
                  },
                  {
                    "lat": 46.553380000000004,
                    "lng": 16.2728
                  },
                  {
                    "lat": 46.553180000000005,
                    "lng": 16.2726
                  },
                  {
                    "lat": 46.553090000000005,
                    "lng": 16.27251
                  },
                  {
                    "lat": 46.55301,
                    "lng": 16.272460000000002
                  },
                  {
                    "lat": 46.552960000000006,
                    "lng": 16.27243
                  },
                  {
                    "lat": 46.55292,
                    "lng": 16.27241
                  }
                ],
                "instructions": "Turn <b>right</b> to stay on <b>Gornja Bistrica</b>",
                "start_point": {
                  "lat": 46.5536288,
                  "lng": 16.2730746
                },
                "end_point": {
                  "lat": 46.552915,
                  "lng": 16.2724096
                }
              },
              {
                "distance": {
                  "text": "1.2 km",
                  "value": 1193
                },
                "duration": {
                  "text": "1 min",
                  "value": 74
                },
                "end_location": {
                  "lat": 46.5430552,
                  "lng": 16.2732196
                },
                "polyline": {
                  "points": "wjc{GqeibBJ@L@D?LANCPGJEFGFGJMFKZk@~@aB~@}A`@m@v@w@h@e@DCRKPGXCVC^@t@J`@L^TB@^VDDd@\\PN`Az@VTNLLFLFVFL@^Bd@Jf@LJDz@VZLlA`@z@T\\FR@p@@~BI~CMtC[xCc@"
                },
                "start_location": {
                  "lat": 46.552915,
                  "lng": 16.2724096
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "wjc{GqeibBJ@L@D?LANCPGJEFGFGJMFKZk@~@aB~@}A`@m@v@w@h@e@DCRKPGXCVC^@t@J`@L^TB@^VDDd@\\PN`Az@VTNLLFLFVFL@^Bd@Jf@LJDz@VZLlA`@z@T\\FR@p@@~BI~CMtC[xCc@",
                "path": [
                  {
                    "lat": 46.55292,
                    "lng": 16.27241
                  },
                  {
                    "lat": 46.55286,
                    "lng": 16.2724
                  },
                  {
                    "lat": 46.55279,
                    "lng": 16.27239
                  },
                  {
                    "lat": 46.552760000000006,
                    "lng": 16.27239
                  },
                  {
                    "lat": 46.552690000000005,
                    "lng": 16.2724
                  },
                  {
                    "lat": 46.55261,
                    "lng": 16.27242
                  },
                  {
                    "lat": 46.55252,
                    "lng": 16.272460000000002
                  },
                  {
                    "lat": 46.55246,
                    "lng": 16.27249
                  },
                  {
                    "lat": 46.552420000000005,
                    "lng": 16.27253
                  },
                  {
                    "lat": 46.55238000000001,
                    "lng": 16.27257
                  },
                  {
                    "lat": 46.55232,
                    "lng": 16.272640000000003
                  },
                  {
                    "lat": 46.55228,
                    "lng": 16.2727
                  },
                  {
                    "lat": 46.55214,
                    "lng": 16.272920000000003
                  },
                  {
                    "lat": 46.551820000000006,
                    "lng": 16.273410000000002
                  },
                  {
                    "lat": 46.551500000000004,
                    "lng": 16.273880000000002
                  },
                  {
                    "lat": 46.55133000000001,
                    "lng": 16.27411
                  },
                  {
                    "lat": 46.551050000000004,
                    "lng": 16.27439
                  },
                  {
                    "lat": 46.55084,
                    "lng": 16.27458
                  },
                  {
                    "lat": 46.550810000000006,
                    "lng": 16.274600000000003
                  },
                  {
                    "lat": 46.55071,
                    "lng": 16.27466
                  },
                  {
                    "lat": 46.55062,
                    "lng": 16.274700000000003
                  },
                  {
                    "lat": 46.55049,
                    "lng": 16.274720000000002
                  },
                  {
                    "lat": 46.55037,
                    "lng": 16.27474
                  },
                  {
                    "lat": 46.55021000000001,
                    "lng": 16.27473
                  },
                  {
                    "lat": 46.54994000000001,
                    "lng": 16.27467
                  },
                  {
                    "lat": 46.54977,
                    "lng": 16.274600000000003
                  },
                  {
                    "lat": 46.54961,
                    "lng": 16.27449
                  },
                  {
                    "lat": 46.54959,
                    "lng": 16.27448
                  },
                  {
                    "lat": 46.54943,
                    "lng": 16.27436
                  },
                  {
                    "lat": 46.549400000000006,
                    "lng": 16.274330000000003
                  },
                  {
                    "lat": 46.54921,
                    "lng": 16.27418
                  },
                  {
                    "lat": 46.54912,
                    "lng": 16.2741
                  },
                  {
                    "lat": 46.548790000000004,
                    "lng": 16.2738
                  },
                  {
                    "lat": 46.54867,
                    "lng": 16.273690000000002
                  },
                  {
                    "lat": 46.548590000000004,
                    "lng": 16.27362
                  },
                  {
                    "lat": 46.54852,
                    "lng": 16.273580000000003
                  },
                  {
                    "lat": 46.54845,
                    "lng": 16.27354
                  },
                  {
                    "lat": 46.54833000000001,
                    "lng": 16.273500000000002
                  },
                  {
                    "lat": 46.548260000000006,
                    "lng": 16.273490000000002
                  },
                  {
                    "lat": 46.548100000000005,
                    "lng": 16.27347
                  },
                  {
                    "lat": 46.54791,
                    "lng": 16.273410000000002
                  },
                  {
                    "lat": 46.54771,
                    "lng": 16.27334
                  },
                  {
                    "lat": 46.547650000000004,
                    "lng": 16.273310000000002
                  },
                  {
                    "lat": 46.54735,
                    "lng": 16.27319
                  },
                  {
                    "lat": 46.54721000000001,
                    "lng": 16.273120000000002
                  },
                  {
                    "lat": 46.546820000000004,
                    "lng": 16.27295
                  },
                  {
                    "lat": 46.54652,
                    "lng": 16.272840000000002
                  },
                  {
                    "lat": 46.54637,
                    "lng": 16.2728
                  },
                  {
                    "lat": 46.54627000000001,
                    "lng": 16.27279
                  },
                  {
                    "lat": 46.546020000000006,
                    "lng": 16.27278
                  },
                  {
                    "lat": 46.54538,
                    "lng": 16.272830000000003
                  },
                  {
                    "lat": 46.54458,
                    "lng": 16.2729
                  },
                  {
                    "lat": 46.54383000000001,
                    "lng": 16.27304
                  },
                  {
                    "lat": 46.543060000000004,
                    "lng": 16.273220000000002
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.55292,
                    "lng": 16.27241
                  },
                  {
                    "lat": 46.55286,
                    "lng": 16.2724
                  },
                  {
                    "lat": 46.55279,
                    "lng": 16.27239
                  },
                  {
                    "lat": 46.552760000000006,
                    "lng": 16.27239
                  },
                  {
                    "lat": 46.552690000000005,
                    "lng": 16.2724
                  },
                  {
                    "lat": 46.55261,
                    "lng": 16.27242
                  },
                  {
                    "lat": 46.55252,
                    "lng": 16.272460000000002
                  },
                  {
                    "lat": 46.55246,
                    "lng": 16.27249
                  },
                  {
                    "lat": 46.552420000000005,
                    "lng": 16.27253
                  },
                  {
                    "lat": 46.55238000000001,
                    "lng": 16.27257
                  },
                  {
                    "lat": 46.55232,
                    "lng": 16.272640000000003
                  },
                  {
                    "lat": 46.55228,
                    "lng": 16.2727
                  },
                  {
                    "lat": 46.55214,
                    "lng": 16.272920000000003
                  },
                  {
                    "lat": 46.551820000000006,
                    "lng": 16.273410000000002
                  },
                  {
                    "lat": 46.551500000000004,
                    "lng": 16.273880000000002
                  },
                  {
                    "lat": 46.55133000000001,
                    "lng": 16.27411
                  },
                  {
                    "lat": 46.551050000000004,
                    "lng": 16.27439
                  },
                  {
                    "lat": 46.55084,
                    "lng": 16.27458
                  },
                  {
                    "lat": 46.550810000000006,
                    "lng": 16.274600000000003
                  },
                  {
                    "lat": 46.55071,
                    "lng": 16.27466
                  },
                  {
                    "lat": 46.55062,
                    "lng": 16.274700000000003
                  },
                  {
                    "lat": 46.55049,
                    "lng": 16.274720000000002
                  },
                  {
                    "lat": 46.55037,
                    "lng": 16.27474
                  },
                  {
                    "lat": 46.55021000000001,
                    "lng": 16.27473
                  },
                  {
                    "lat": 46.54994000000001,
                    "lng": 16.27467
                  },
                  {
                    "lat": 46.54977,
                    "lng": 16.274600000000003
                  },
                  {
                    "lat": 46.54961,
                    "lng": 16.27449
                  },
                  {
                    "lat": 46.54959,
                    "lng": 16.27448
                  },
                  {
                    "lat": 46.54943,
                    "lng": 16.27436
                  },
                  {
                    "lat": 46.549400000000006,
                    "lng": 16.274330000000003
                  },
                  {
                    "lat": 46.54921,
                    "lng": 16.27418
                  },
                  {
                    "lat": 46.54912,
                    "lng": 16.2741
                  },
                  {
                    "lat": 46.548790000000004,
                    "lng": 16.2738
                  },
                  {
                    "lat": 46.54867,
                    "lng": 16.273690000000002
                  },
                  {
                    "lat": 46.548590000000004,
                    "lng": 16.27362
                  },
                  {
                    "lat": 46.54852,
                    "lng": 16.273580000000003
                  },
                  {
                    "lat": 46.54845,
                    "lng": 16.27354
                  },
                  {
                    "lat": 46.54833000000001,
                    "lng": 16.273500000000002
                  },
                  {
                    "lat": 46.548260000000006,
                    "lng": 16.273490000000002
                  },
                  {
                    "lat": 46.548100000000005,
                    "lng": 16.27347
                  },
                  {
                    "lat": 46.54791,
                    "lng": 16.273410000000002
                  },
                  {
                    "lat": 46.54771,
                    "lng": 16.27334
                  },
                  {
                    "lat": 46.547650000000004,
                    "lng": 16.273310000000002
                  },
                  {
                    "lat": 46.54735,
                    "lng": 16.27319
                  },
                  {
                    "lat": 46.54721000000001,
                    "lng": 16.273120000000002
                  },
                  {
                    "lat": 46.546820000000004,
                    "lng": 16.27295
                  },
                  {
                    "lat": 46.54652,
                    "lng": 16.272840000000002
                  },
                  {
                    "lat": 46.54637,
                    "lng": 16.2728
                  },
                  {
                    "lat": 46.54627000000001,
                    "lng": 16.27279
                  },
                  {
                    "lat": 46.546020000000006,
                    "lng": 16.27278
                  },
                  {
                    "lat": 46.54538,
                    "lng": 16.272830000000003
                  },
                  {
                    "lat": 46.54458,
                    "lng": 16.2729
                  },
                  {
                    "lat": 46.54383000000001,
                    "lng": 16.27304
                  },
                  {
                    "lat": 46.543060000000004,
                    "lng": 16.273220000000002
                  }
                ],
                "instructions": "Continue onto <b>Srednja Bistrica</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.552915,
                  "lng": 16.2724096
                },
                "end_point": {
                  "lat": 46.5430552,
                  "lng": 16.2732196
                }
              },
              {
                "distance": {
                  "text": "1.2 km",
                  "value": 1233
                },
                "duration": {
                  "text": "1 min",
                  "value": 64
                },
                "end_location": {
                  "lat": 46.5328235,
                  "lng": 16.2752676
                },
                "polyline": {
                  "points": "cma{GsjibBhAQpC_@^CLAt@Ah@?\\?X@X@j@Fv@JTD`AP`@Hj@Nh@Jb@JPDNBb@J`@JfAV~@Tb@J@@fB`@b@HB@^Fb@FTD^@RAH?RCH?\\Gf@MfAi@RIjB_ANIPKVMLGRKFELIRMFETST[R]Xu@Lg@DMBMJYNa@Rc@NUHMJKRQVO"
                },
                "start_location": {
                  "lat": 46.5430552,
                  "lng": 16.2732196
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "cma{GsjibBhAQpC_@^CLAt@Ah@?\\?X@X@j@Fv@JTD`AP`@Hj@Nh@Jb@JPDNBb@J`@JfAV~@Tb@J@@fB`@b@HB@^Fb@FTD^@RAH?RCH?\\Gf@MfAi@RIjB_ANIPKVMLGRKFELIRMFETST[R]Xu@Lg@DMBMJYNa@Rc@NUHMJKRQVO",
                "path": [
                  {
                    "lat": 46.543060000000004,
                    "lng": 16.273220000000002
                  },
                  {
                    "lat": 46.54269,
                    "lng": 16.273310000000002
                  },
                  {
                    "lat": 46.54196,
                    "lng": 16.27347
                  },
                  {
                    "lat": 46.5418,
                    "lng": 16.273490000000002
                  },
                  {
                    "lat": 46.54173,
                    "lng": 16.273500000000002
                  },
                  {
                    "lat": 46.54146,
                    "lng": 16.27351
                  },
                  {
                    "lat": 46.541250000000005,
                    "lng": 16.27351
                  },
                  {
                    "lat": 46.54110000000001,
                    "lng": 16.27351
                  },
                  {
                    "lat": 46.54097,
                    "lng": 16.273500000000002
                  },
                  {
                    "lat": 46.54084,
                    "lng": 16.273490000000002
                  },
                  {
                    "lat": 46.540620000000004,
                    "lng": 16.27345
                  },
                  {
                    "lat": 46.54034,
                    "lng": 16.273390000000003
                  },
                  {
                    "lat": 46.54023,
                    "lng": 16.27336
                  },
                  {
                    "lat": 46.5399,
                    "lng": 16.27327
                  },
                  {
                    "lat": 46.539730000000006,
                    "lng": 16.273220000000002
                  },
                  {
                    "lat": 46.53951000000001,
                    "lng": 16.27314
                  },
                  {
                    "lat": 46.539300000000004,
                    "lng": 16.27308
                  },
                  {
                    "lat": 46.539120000000004,
                    "lng": 16.273020000000002
                  },
                  {
                    "lat": 46.539030000000004,
                    "lng": 16.27299
                  },
                  {
                    "lat": 46.53895000000001,
                    "lng": 16.27297
                  },
                  {
                    "lat": 46.53877000000001,
                    "lng": 16.272910000000003
                  },
                  {
                    "lat": 46.5386,
                    "lng": 16.272850000000002
                  },
                  {
                    "lat": 46.53824,
                    "lng": 16.272730000000003
                  },
                  {
                    "lat": 46.53792000000001,
                    "lng": 16.27262
                  },
                  {
                    "lat": 46.53774000000001,
                    "lng": 16.272560000000002
                  },
                  {
                    "lat": 46.53773,
                    "lng": 16.272550000000003
                  },
                  {
                    "lat": 46.53721,
                    "lng": 16.272380000000002
                  },
                  {
                    "lat": 46.53703,
                    "lng": 16.27233
                  },
                  {
                    "lat": 46.53701,
                    "lng": 16.27232
                  },
                  {
                    "lat": 46.53685,
                    "lng": 16.272280000000002
                  },
                  {
                    "lat": 46.53667,
                    "lng": 16.27224
                  },
                  {
                    "lat": 46.53656,
                    "lng": 16.27221
                  },
                  {
                    "lat": 46.5364,
                    "lng": 16.2722
                  },
                  {
                    "lat": 46.536300000000004,
                    "lng": 16.27221
                  },
                  {
                    "lat": 46.53625,
                    "lng": 16.27221
                  },
                  {
                    "lat": 46.536150000000006,
                    "lng": 16.27223
                  },
                  {
                    "lat": 46.536100000000005,
                    "lng": 16.27223
                  },
                  {
                    "lat": 46.53595000000001,
                    "lng": 16.272270000000002
                  },
                  {
                    "lat": 46.53575000000001,
                    "lng": 16.27234
                  },
                  {
                    "lat": 46.53539000000001,
                    "lng": 16.272550000000003
                  },
                  {
                    "lat": 46.53529,
                    "lng": 16.2726
                  },
                  {
                    "lat": 46.53475,
                    "lng": 16.272920000000003
                  },
                  {
                    "lat": 46.534670000000006,
                    "lng": 16.27297
                  },
                  {
                    "lat": 46.534580000000005,
                    "lng": 16.273030000000002
                  },
                  {
                    "lat": 46.53446,
                    "lng": 16.273100000000003
                  },
                  {
                    "lat": 46.53439,
                    "lng": 16.27314
                  },
                  {
                    "lat": 46.534290000000006,
                    "lng": 16.273200000000003
                  },
                  {
                    "lat": 46.53425000000001,
                    "lng": 16.27323
                  },
                  {
                    "lat": 46.534180000000006,
                    "lng": 16.27328
                  },
                  {
                    "lat": 46.53408,
                    "lng": 16.27335
                  },
                  {
                    "lat": 46.534040000000005,
                    "lng": 16.273380000000003
                  },
                  {
                    "lat": 46.533930000000005,
                    "lng": 16.273480000000003
                  },
                  {
                    "lat": 46.533820000000006,
                    "lng": 16.27362
                  },
                  {
                    "lat": 46.53372,
                    "lng": 16.273770000000003
                  },
                  {
                    "lat": 46.533590000000004,
                    "lng": 16.274040000000003
                  },
                  {
                    "lat": 46.53352,
                    "lng": 16.274240000000002
                  },
                  {
                    "lat": 46.53349,
                    "lng": 16.27431
                  },
                  {
                    "lat": 46.53347,
                    "lng": 16.27438
                  },
                  {
                    "lat": 46.53341,
                    "lng": 16.274510000000003
                  },
                  {
                    "lat": 46.53333000000001,
                    "lng": 16.27468
                  },
                  {
                    "lat": 46.53323,
                    "lng": 16.27486
                  },
                  {
                    "lat": 46.533150000000006,
                    "lng": 16.27497
                  },
                  {
                    "lat": 46.533100000000005,
                    "lng": 16.27504
                  },
                  {
                    "lat": 46.53304000000001,
                    "lng": 16.275100000000002
                  },
                  {
                    "lat": 46.53294,
                    "lng": 16.275190000000002
                  },
                  {
                    "lat": 46.53282,
                    "lng": 16.275270000000003
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.543060000000004,
                    "lng": 16.273220000000002
                  },
                  {
                    "lat": 46.54269,
                    "lng": 16.273310000000002
                  },
                  {
                    "lat": 46.54196,
                    "lng": 16.27347
                  },
                  {
                    "lat": 46.5418,
                    "lng": 16.273490000000002
                  },
                  {
                    "lat": 46.54173,
                    "lng": 16.273500000000002
                  },
                  {
                    "lat": 46.54146,
                    "lng": 16.27351
                  },
                  {
                    "lat": 46.541250000000005,
                    "lng": 16.27351
                  },
                  {
                    "lat": 46.54110000000001,
                    "lng": 16.27351
                  },
                  {
                    "lat": 46.54097,
                    "lng": 16.273500000000002
                  },
                  {
                    "lat": 46.54084,
                    "lng": 16.273490000000002
                  },
                  {
                    "lat": 46.540620000000004,
                    "lng": 16.27345
                  },
                  {
                    "lat": 46.54034,
                    "lng": 16.273390000000003
                  },
                  {
                    "lat": 46.54023,
                    "lng": 16.27336
                  },
                  {
                    "lat": 46.5399,
                    "lng": 16.27327
                  },
                  {
                    "lat": 46.539730000000006,
                    "lng": 16.273220000000002
                  },
                  {
                    "lat": 46.53951000000001,
                    "lng": 16.27314
                  },
                  {
                    "lat": 46.539300000000004,
                    "lng": 16.27308
                  },
                  {
                    "lat": 46.539120000000004,
                    "lng": 16.273020000000002
                  },
                  {
                    "lat": 46.539030000000004,
                    "lng": 16.27299
                  },
                  {
                    "lat": 46.53895000000001,
                    "lng": 16.27297
                  },
                  {
                    "lat": 46.53877000000001,
                    "lng": 16.272910000000003
                  },
                  {
                    "lat": 46.5386,
                    "lng": 16.272850000000002
                  },
                  {
                    "lat": 46.53824,
                    "lng": 16.272730000000003
                  },
                  {
                    "lat": 46.53792000000001,
                    "lng": 16.27262
                  },
                  {
                    "lat": 46.53774000000001,
                    "lng": 16.272560000000002
                  },
                  {
                    "lat": 46.53773,
                    "lng": 16.272550000000003
                  },
                  {
                    "lat": 46.53721,
                    "lng": 16.272380000000002
                  },
                  {
                    "lat": 46.53703,
                    "lng": 16.27233
                  },
                  {
                    "lat": 46.53701,
                    "lng": 16.27232
                  },
                  {
                    "lat": 46.53685,
                    "lng": 16.272280000000002
                  },
                  {
                    "lat": 46.53667,
                    "lng": 16.27224
                  },
                  {
                    "lat": 46.53656,
                    "lng": 16.27221
                  },
                  {
                    "lat": 46.5364,
                    "lng": 16.2722
                  },
                  {
                    "lat": 46.536300000000004,
                    "lng": 16.27221
                  },
                  {
                    "lat": 46.53625,
                    "lng": 16.27221
                  },
                  {
                    "lat": 46.536150000000006,
                    "lng": 16.27223
                  },
                  {
                    "lat": 46.536100000000005,
                    "lng": 16.27223
                  },
                  {
                    "lat": 46.53595000000001,
                    "lng": 16.272270000000002
                  },
                  {
                    "lat": 46.53575000000001,
                    "lng": 16.27234
                  },
                  {
                    "lat": 46.53539000000001,
                    "lng": 16.272550000000003
                  },
                  {
                    "lat": 46.53529,
                    "lng": 16.2726
                  },
                  {
                    "lat": 46.53475,
                    "lng": 16.272920000000003
                  },
                  {
                    "lat": 46.534670000000006,
                    "lng": 16.27297
                  },
                  {
                    "lat": 46.534580000000005,
                    "lng": 16.273030000000002
                  },
                  {
                    "lat": 46.53446,
                    "lng": 16.273100000000003
                  },
                  {
                    "lat": 46.53439,
                    "lng": 16.27314
                  },
                  {
                    "lat": 46.534290000000006,
                    "lng": 16.273200000000003
                  },
                  {
                    "lat": 46.53425000000001,
                    "lng": 16.27323
                  },
                  {
                    "lat": 46.534180000000006,
                    "lng": 16.27328
                  },
                  {
                    "lat": 46.53408,
                    "lng": 16.27335
                  },
                  {
                    "lat": 46.534040000000005,
                    "lng": 16.273380000000003
                  },
                  {
                    "lat": 46.533930000000005,
                    "lng": 16.273480000000003
                  },
                  {
                    "lat": 46.533820000000006,
                    "lng": 16.27362
                  },
                  {
                    "lat": 46.53372,
                    "lng": 16.273770000000003
                  },
                  {
                    "lat": 46.533590000000004,
                    "lng": 16.274040000000003
                  },
                  {
                    "lat": 46.53352,
                    "lng": 16.274240000000002
                  },
                  {
                    "lat": 46.53349,
                    "lng": 16.27431
                  },
                  {
                    "lat": 46.53347,
                    "lng": 16.27438
                  },
                  {
                    "lat": 46.53341,
                    "lng": 16.274510000000003
                  },
                  {
                    "lat": 46.53333000000001,
                    "lng": 16.27468
                  },
                  {
                    "lat": 46.53323,
                    "lng": 16.27486
                  },
                  {
                    "lat": 46.533150000000006,
                    "lng": 16.27497
                  },
                  {
                    "lat": 46.533100000000005,
                    "lng": 16.27504
                  },
                  {
                    "lat": 46.53304000000001,
                    "lng": 16.275100000000002
                  },
                  {
                    "lat": 46.53294,
                    "lng": 16.275190000000002
                  },
                  {
                    "lat": 46.53282,
                    "lng": 16.275270000000003
                  }
                ],
                "instructions": "Continue onto <b>Gornja Bistrica</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.5430552,
                  "lng": 16.2732196
                },
                "end_point": {
                  "lat": 46.5328235,
                  "lng": 16.2752676
                }
              },
              {
                "distance": {
                  "text": "1.2 km",
                  "value": 1242
                },
                "duration": {
                  "text": "1 min",
                  "value": 81
                },
                "end_location": {
                  "lat": 46.5222217,
                  "lng": 16.2785148
                },
                "polyline": {
                  "points": "cm_{GmwibB^M`@G\\C~@GXARA`@?N@VBjARh@DZBpACb@Ar@AdBIfCI`ACnEOb@Af@Gb@EJAx@Id@G@A^EdAQd@In@M^Of@Sp@]b@Yv@e@b@c@p@w@BCT_@BEV_@X_@X]V_@@AZ[@AZUdAm@h@U"
                },
                "start_location": {
                  "lat": 46.5328235,
                  "lng": 16.2752676
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "cm_{GmwibB^M`@G\\C~@GXARA`@?N@VBjARh@DZBpACb@Ar@AdBIfCI`ACnEOb@Af@Gb@EJAx@Id@G@A^EdAQd@In@M^Of@Sp@]b@Yv@e@b@c@p@w@BCT_@BEV_@X_@X]V_@@AZ[@AZUdAm@h@U",
                "path": [
                  {
                    "lat": 46.53282,
                    "lng": 16.275270000000003
                  },
                  {
                    "lat": 46.53266000000001,
                    "lng": 16.27534
                  },
                  {
                    "lat": 46.53249,
                    "lng": 16.275380000000002
                  },
                  {
                    "lat": 46.532340000000005,
                    "lng": 16.2754
                  },
                  {
                    "lat": 46.53202,
                    "lng": 16.27544
                  },
                  {
                    "lat": 46.531890000000004,
                    "lng": 16.275450000000003
                  },
                  {
                    "lat": 46.53179,
                    "lng": 16.275460000000002
                  },
                  {
                    "lat": 46.531620000000004,
                    "lng": 16.275460000000002
                  },
                  {
                    "lat": 46.53154000000001,
                    "lng": 16.275450000000003
                  },
                  {
                    "lat": 46.531420000000004,
                    "lng": 16.27543
                  },
                  {
                    "lat": 46.531040000000004,
                    "lng": 16.27533
                  },
                  {
                    "lat": 46.53083,
                    "lng": 16.2753
                  },
                  {
                    "lat": 46.53069000000001,
                    "lng": 16.275280000000002
                  },
                  {
                    "lat": 46.530280000000005,
                    "lng": 16.2753
                  },
                  {
                    "lat": 46.530100000000004,
                    "lng": 16.27531
                  },
                  {
                    "lat": 46.52984000000001,
                    "lng": 16.27532
                  },
                  {
                    "lat": 46.52933,
                    "lng": 16.275370000000002
                  },
                  {
                    "lat": 46.528650000000006,
                    "lng": 16.27542
                  },
                  {
                    "lat": 46.52832,
                    "lng": 16.27544
                  },
                  {
                    "lat": 46.527280000000005,
                    "lng": 16.27552
                  },
                  {
                    "lat": 46.527100000000004,
                    "lng": 16.27553
                  },
                  {
                    "lat": 46.526900000000005,
                    "lng": 16.275570000000002
                  },
                  {
                    "lat": 46.526720000000005,
                    "lng": 16.2756
                  },
                  {
                    "lat": 46.52666000000001,
                    "lng": 16.27561
                  },
                  {
                    "lat": 46.52637000000001,
                    "lng": 16.275660000000002
                  },
                  {
                    "lat": 46.526180000000004,
                    "lng": 16.2757
                  },
                  {
                    "lat": 46.52617,
                    "lng": 16.27571
                  },
                  {
                    "lat": 46.52601000000001,
                    "lng": 16.275740000000003
                  },
                  {
                    "lat": 46.52566,
                    "lng": 16.275830000000003
                  },
                  {
                    "lat": 46.525470000000006,
                    "lng": 16.27588
                  },
                  {
                    "lat": 46.52523,
                    "lng": 16.27595
                  },
                  {
                    "lat": 46.52507000000001,
                    "lng": 16.276030000000002
                  },
                  {
                    "lat": 46.52487000000001,
                    "lng": 16.276130000000002
                  },
                  {
                    "lat": 46.524620000000006,
                    "lng": 16.27628
                  },
                  {
                    "lat": 46.524440000000006,
                    "lng": 16.276410000000002
                  },
                  {
                    "lat": 46.52416,
                    "lng": 16.276600000000002
                  },
                  {
                    "lat": 46.52398,
                    "lng": 16.276780000000002
                  },
                  {
                    "lat": 46.52373,
                    "lng": 16.277060000000002
                  },
                  {
                    "lat": 46.52371,
                    "lng": 16.27708
                  },
                  {
                    "lat": 46.5236,
                    "lng": 16.277240000000003
                  },
                  {
                    "lat": 46.52358,
                    "lng": 16.27727
                  },
                  {
                    "lat": 46.52346000000001,
                    "lng": 16.277430000000003
                  },
                  {
                    "lat": 46.52333,
                    "lng": 16.27759
                  },
                  {
                    "lat": 46.5232,
                    "lng": 16.27774
                  },
                  {
                    "lat": 46.52308000000001,
                    "lng": 16.277900000000002
                  },
                  {
                    "lat": 46.523070000000004,
                    "lng": 16.277910000000002
                  },
                  {
                    "lat": 46.52293,
                    "lng": 16.27805
                  },
                  {
                    "lat": 46.522920000000006,
                    "lng": 16.27806
                  },
                  {
                    "lat": 46.522780000000004,
                    "lng": 16.278170000000003
                  },
                  {
                    "lat": 46.52243000000001,
                    "lng": 16.2784
                  },
                  {
                    "lat": 46.522220000000004,
                    "lng": 16.27851
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.53282,
                    "lng": 16.275270000000003
                  },
                  {
                    "lat": 46.53266000000001,
                    "lng": 16.27534
                  },
                  {
                    "lat": 46.53249,
                    "lng": 16.275380000000002
                  },
                  {
                    "lat": 46.532340000000005,
                    "lng": 16.2754
                  },
                  {
                    "lat": 46.53202,
                    "lng": 16.27544
                  },
                  {
                    "lat": 46.531890000000004,
                    "lng": 16.275450000000003
                  },
                  {
                    "lat": 46.53179,
                    "lng": 16.275460000000002
                  },
                  {
                    "lat": 46.531620000000004,
                    "lng": 16.275460000000002
                  },
                  {
                    "lat": 46.53154000000001,
                    "lng": 16.275450000000003
                  },
                  {
                    "lat": 46.531420000000004,
                    "lng": 16.27543
                  },
                  {
                    "lat": 46.531040000000004,
                    "lng": 16.27533
                  },
                  {
                    "lat": 46.53083,
                    "lng": 16.2753
                  },
                  {
                    "lat": 46.53069000000001,
                    "lng": 16.275280000000002
                  },
                  {
                    "lat": 46.530280000000005,
                    "lng": 16.2753
                  },
                  {
                    "lat": 46.530100000000004,
                    "lng": 16.27531
                  },
                  {
                    "lat": 46.52984000000001,
                    "lng": 16.27532
                  },
                  {
                    "lat": 46.52933,
                    "lng": 16.275370000000002
                  },
                  {
                    "lat": 46.528650000000006,
                    "lng": 16.27542
                  },
                  {
                    "lat": 46.52832,
                    "lng": 16.27544
                  },
                  {
                    "lat": 46.527280000000005,
                    "lng": 16.27552
                  },
                  {
                    "lat": 46.527100000000004,
                    "lng": 16.27553
                  },
                  {
                    "lat": 46.526900000000005,
                    "lng": 16.275570000000002
                  },
                  {
                    "lat": 46.526720000000005,
                    "lng": 16.2756
                  },
                  {
                    "lat": 46.52666000000001,
                    "lng": 16.27561
                  },
                  {
                    "lat": 46.52637000000001,
                    "lng": 16.275660000000002
                  },
                  {
                    "lat": 46.526180000000004,
                    "lng": 16.2757
                  },
                  {
                    "lat": 46.52617,
                    "lng": 16.27571
                  },
                  {
                    "lat": 46.52601000000001,
                    "lng": 16.275740000000003
                  },
                  {
                    "lat": 46.52566,
                    "lng": 16.275830000000003
                  },
                  {
                    "lat": 46.525470000000006,
                    "lng": 16.27588
                  },
                  {
                    "lat": 46.52523,
                    "lng": 16.27595
                  },
                  {
                    "lat": 46.52507000000001,
                    "lng": 16.276030000000002
                  },
                  {
                    "lat": 46.52487000000001,
                    "lng": 16.276130000000002
                  },
                  {
                    "lat": 46.524620000000006,
                    "lng": 16.27628
                  },
                  {
                    "lat": 46.524440000000006,
                    "lng": 16.276410000000002
                  },
                  {
                    "lat": 46.52416,
                    "lng": 16.276600000000002
                  },
                  {
                    "lat": 46.52398,
                    "lng": 16.276780000000002
                  },
                  {
                    "lat": 46.52373,
                    "lng": 16.277060000000002
                  },
                  {
                    "lat": 46.52371,
                    "lng": 16.27708
                  },
                  {
                    "lat": 46.5236,
                    "lng": 16.277240000000003
                  },
                  {
                    "lat": 46.52358,
                    "lng": 16.27727
                  },
                  {
                    "lat": 46.52346000000001,
                    "lng": 16.277430000000003
                  },
                  {
                    "lat": 46.52333,
                    "lng": 16.27759
                  },
                  {
                    "lat": 46.5232,
                    "lng": 16.27774
                  },
                  {
                    "lat": 46.52308000000001,
                    "lng": 16.277900000000002
                  },
                  {
                    "lat": 46.523070000000004,
                    "lng": 16.277910000000002
                  },
                  {
                    "lat": 46.52293,
                    "lng": 16.27805
                  },
                  {
                    "lat": 46.522920000000006,
                    "lng": 16.27806
                  },
                  {
                    "lat": 46.522780000000004,
                    "lng": 16.278170000000003
                  },
                  {
                    "lat": 46.52243000000001,
                    "lng": 16.2784
                  },
                  {
                    "lat": 46.522220000000004,
                    "lng": 16.27851
                  }
                ],
                "instructions": "Continue onto <b>Razkrižje</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.5328235,
                  "lng": 16.2752676
                },
                "end_point": {
                  "lat": 46.5222217,
                  "lng": 16.2785148
                }
              },
              {
                "distance": {
                  "text": "0.6 km",
                  "value": 646
                },
                "duration": {
                  "text": "1 min",
                  "value": 50
                },
                "end_location": {
                  "lat": 46.5200933,
                  "lng": 16.2713343
                },
                "maneuver": "turn-right",
                "polyline": {
                  "points": "{j}zGukjbBTCN?J@PHLLT\\Rz@J`@J`@DJPj@Rj@LZDLRj@JXPj@|@nC^lA`@xAX`ABPBXBXAH?b@?NAl@@x@Dx@B^F|@B\\?b@?V?DEn@Gr@Gd@"
                },
                "start_location": {
                  "lat": 46.5222217,
                  "lng": 16.2785148
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "{j}zGukjbBTCN?J@PHLLT\\Rz@J`@J`@DJPj@Rj@LZDLRj@JXPj@|@nC^lA`@xAX`ABPBXBXAH?b@?NAl@@x@Dx@B^F|@B\\?b@?V?DEn@Gr@Gd@",
                "path": [
                  {
                    "lat": 46.522220000000004,
                    "lng": 16.27851
                  },
                  {
                    "lat": 46.522110000000005,
                    "lng": 16.27853
                  },
                  {
                    "lat": 46.52203,
                    "lng": 16.27853
                  },
                  {
                    "lat": 46.52197,
                    "lng": 16.27852
                  },
                  {
                    "lat": 46.52188,
                    "lng": 16.278470000000002
                  },
                  {
                    "lat": 46.52181,
                    "lng": 16.2784
                  },
                  {
                    "lat": 46.5217,
                    "lng": 16.27825
                  },
                  {
                    "lat": 46.52160000000001,
                    "lng": 16.27795
                  },
                  {
                    "lat": 46.52154,
                    "lng": 16.27778
                  },
                  {
                    "lat": 46.521480000000004,
                    "lng": 16.277610000000003
                  },
                  {
                    "lat": 46.52145,
                    "lng": 16.27755
                  },
                  {
                    "lat": 46.52136,
                    "lng": 16.277330000000003
                  },
                  {
                    "lat": 46.521260000000005,
                    "lng": 16.27711
                  },
                  {
                    "lat": 46.521190000000004,
                    "lng": 16.276970000000002
                  },
                  {
                    "lat": 46.52116,
                    "lng": 16.2769
                  },
                  {
                    "lat": 46.521060000000006,
                    "lng": 16.276680000000002
                  },
                  {
                    "lat": 46.521,
                    "lng": 16.27655
                  },
                  {
                    "lat": 46.52091,
                    "lng": 16.27633
                  },
                  {
                    "lat": 46.5206,
                    "lng": 16.27561
                  },
                  {
                    "lat": 46.52044,
                    "lng": 16.27522
                  },
                  {
                    "lat": 46.520270000000004,
                    "lng": 16.27477
                  },
                  {
                    "lat": 46.520140000000005,
                    "lng": 16.274440000000002
                  },
                  {
                    "lat": 46.520120000000006,
                    "lng": 16.274350000000002
                  },
                  {
                    "lat": 46.520100000000006,
                    "lng": 16.27422
                  },
                  {
                    "lat": 46.52008000000001,
                    "lng": 16.27409
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.274040000000003
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.273860000000003
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.273780000000002
                  },
                  {
                    "lat": 46.520100000000006,
                    "lng": 16.27355
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.27326
                  },
                  {
                    "lat": 46.52006,
                    "lng": 16.27297
                  },
                  {
                    "lat": 46.52004,
                    "lng": 16.27281
                  },
                  {
                    "lat": 46.52,
                    "lng": 16.2725
                  },
                  {
                    "lat": 46.519980000000004,
                    "lng": 16.272350000000003
                  },
                  {
                    "lat": 46.519980000000004,
                    "lng": 16.272170000000003
                  },
                  {
                    "lat": 46.519980000000004,
                    "lng": 16.27205
                  },
                  {
                    "lat": 46.519980000000004,
                    "lng": 16.27202
                  },
                  {
                    "lat": 46.520010000000006,
                    "lng": 16.27178
                  },
                  {
                    "lat": 46.520050000000005,
                    "lng": 16.271520000000002
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.271330000000003
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.522220000000004,
                    "lng": 16.27851
                  },
                  {
                    "lat": 46.522110000000005,
                    "lng": 16.27853
                  },
                  {
                    "lat": 46.52203,
                    "lng": 16.27853
                  },
                  {
                    "lat": 46.52197,
                    "lng": 16.27852
                  },
                  {
                    "lat": 46.52188,
                    "lng": 16.278470000000002
                  },
                  {
                    "lat": 46.52181,
                    "lng": 16.2784
                  },
                  {
                    "lat": 46.5217,
                    "lng": 16.27825
                  },
                  {
                    "lat": 46.52160000000001,
                    "lng": 16.27795
                  },
                  {
                    "lat": 46.52154,
                    "lng": 16.27778
                  },
                  {
                    "lat": 46.521480000000004,
                    "lng": 16.277610000000003
                  },
                  {
                    "lat": 46.52145,
                    "lng": 16.27755
                  },
                  {
                    "lat": 46.52136,
                    "lng": 16.277330000000003
                  },
                  {
                    "lat": 46.521260000000005,
                    "lng": 16.27711
                  },
                  {
                    "lat": 46.521190000000004,
                    "lng": 16.276970000000002
                  },
                  {
                    "lat": 46.52116,
                    "lng": 16.2769
                  },
                  {
                    "lat": 46.521060000000006,
                    "lng": 16.276680000000002
                  },
                  {
                    "lat": 46.521,
                    "lng": 16.27655
                  },
                  {
                    "lat": 46.52091,
                    "lng": 16.27633
                  },
                  {
                    "lat": 46.5206,
                    "lng": 16.27561
                  },
                  {
                    "lat": 46.52044,
                    "lng": 16.27522
                  },
                  {
                    "lat": 46.520270000000004,
                    "lng": 16.27477
                  },
                  {
                    "lat": 46.520140000000005,
                    "lng": 16.274440000000002
                  },
                  {
                    "lat": 46.520120000000006,
                    "lng": 16.274350000000002
                  },
                  {
                    "lat": 46.520100000000006,
                    "lng": 16.27422
                  },
                  {
                    "lat": 46.52008000000001,
                    "lng": 16.27409
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.274040000000003
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.273860000000003
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.273780000000002
                  },
                  {
                    "lat": 46.520100000000006,
                    "lng": 16.27355
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.27326
                  },
                  {
                    "lat": 46.52006,
                    "lng": 16.27297
                  },
                  {
                    "lat": 46.52004,
                    "lng": 16.27281
                  },
                  {
                    "lat": 46.52,
                    "lng": 16.2725
                  },
                  {
                    "lat": 46.519980000000004,
                    "lng": 16.272350000000003
                  },
                  {
                    "lat": 46.519980000000004,
                    "lng": 16.272170000000003
                  },
                  {
                    "lat": 46.519980000000004,
                    "lng": 16.27205
                  },
                  {
                    "lat": 46.519980000000004,
                    "lng": 16.27202
                  },
                  {
                    "lat": 46.520010000000006,
                    "lng": 16.27178
                  },
                  {
                    "lat": 46.520050000000005,
                    "lng": 16.271520000000002
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.271330000000003
                  }
                ],
                "instructions": "Turn <b>right</b> to stay on <b>Razkrižje</b> (signs for <b>Ljutomer</b>)",
                "start_point": {
                  "lat": 46.5222217,
                  "lng": 16.2785148
                },
                "end_point": {
                  "lat": 46.5200933,
                  "lng": 16.2713343
                }
              },
              {
                "distance": {
                  "text": "1.9 km",
                  "value": 1926
                },
                "duration": {
                  "text": "2 mins",
                  "value": 113
                },
                "end_location": {
                  "lat": 46.5170416,
                  "lng": 16.2477216
                },
                "polyline": {
                  "points": "q}|zGy~hbBEXSdBCh@Ah@?z@AvA?^Ct@EdAC`@AXEv@Cn@?XAf@@J@r@?HD|@F|@J|@NlAPtAPrAJt@Db@B^BTB\\?T?N?l@G`A?@KbAC\\MrAIfAAl@BbADp@Lz@hA|GP~@ZnBPhAj@~BTn@h@bBtChIf@fBFXb@bB`@|A\\zALh@XfAFZLf@FTLj@Nr@Hd@JrAFxBC|@?FAD?HADAF?HAFCHAJCJCLCJSn@IXS|@Kd@Il@Ch@A^@J@JDh@BDDP"
                },
                "start_location": {
                  "lat": 46.5200933,
                  "lng": 16.2713343
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "q}|zGy~hbBEXSdBCh@Ah@?z@AvA?^Ct@EdAC`@AXEv@Cn@?XAf@@J@r@?HD|@F|@J|@NlAPtAPrAJt@Db@B^BTB\\?T?N?l@G`A?@KbAC\\MrAIfAAl@BbADp@Lz@hA|GP~@ZnBPhAj@~BTn@h@bBtChIf@fBFXb@bB`@|A\\zALh@XfAFZLf@FTLj@Nr@Hd@JrAFxBC|@?FAD?HADAF?HAFCHAJCJCLCJSn@IXS|@Kd@Il@Ch@A^@J@JDh@BDDP",
                "path": [
                  {
                    "lat": 46.52009,
                    "lng": 16.271330000000003
                  },
                  {
                    "lat": 46.520120000000006,
                    "lng": 16.2712
                  },
                  {
                    "lat": 46.52022,
                    "lng": 16.270690000000002
                  },
                  {
                    "lat": 46.52024,
                    "lng": 16.270480000000003
                  },
                  {
                    "lat": 46.520250000000004,
                    "lng": 16.27027
                  },
                  {
                    "lat": 46.520250000000004,
                    "lng": 16.26997
                  },
                  {
                    "lat": 46.52026,
                    "lng": 16.26953
                  },
                  {
                    "lat": 46.52026,
                    "lng": 16.269370000000002
                  },
                  {
                    "lat": 46.52028000000001,
                    "lng": 16.2691
                  },
                  {
                    "lat": 46.52031,
                    "lng": 16.26875
                  },
                  {
                    "lat": 46.52033,
                    "lng": 16.26858
                  },
                  {
                    "lat": 46.520340000000004,
                    "lng": 16.26845
                  },
                  {
                    "lat": 46.52037000000001,
                    "lng": 16.26817
                  },
                  {
                    "lat": 46.520390000000006,
                    "lng": 16.26793
                  },
                  {
                    "lat": 46.520390000000006,
                    "lng": 16.2678
                  },
                  {
                    "lat": 46.5204,
                    "lng": 16.2676
                  },
                  {
                    "lat": 46.520390000000006,
                    "lng": 16.26754
                  },
                  {
                    "lat": 46.52038,
                    "lng": 16.267280000000003
                  },
                  {
                    "lat": 46.52038,
                    "lng": 16.26723
                  },
                  {
                    "lat": 46.52035,
                    "lng": 16.266920000000002
                  },
                  {
                    "lat": 46.52031,
                    "lng": 16.26661
                  },
                  {
                    "lat": 46.520250000000004,
                    "lng": 16.2663
                  },
                  {
                    "lat": 46.52017000000001,
                    "lng": 16.26591
                  },
                  {
                    "lat": 46.52008000000001,
                    "lng": 16.26548
                  },
                  {
                    "lat": 46.51999000000001,
                    "lng": 16.265060000000002
                  },
                  {
                    "lat": 46.51993,
                    "lng": 16.26479
                  },
                  {
                    "lat": 46.51990000000001,
                    "lng": 16.26461
                  },
                  {
                    "lat": 46.51988,
                    "lng": 16.26445
                  },
                  {
                    "lat": 46.51986,
                    "lng": 16.26434
                  },
                  {
                    "lat": 46.51984,
                    "lng": 16.264190000000003
                  },
                  {
                    "lat": 46.51984,
                    "lng": 16.26408
                  },
                  {
                    "lat": 46.51984,
                    "lng": 16.264000000000003
                  },
                  {
                    "lat": 46.51984,
                    "lng": 16.26377
                  },
                  {
                    "lat": 46.51988,
                    "lng": 16.263440000000003
                  },
                  {
                    "lat": 46.51988,
                    "lng": 16.26343
                  },
                  {
                    "lat": 46.519940000000005,
                    "lng": 16.263090000000002
                  },
                  {
                    "lat": 46.519960000000005,
                    "lng": 16.26294
                  },
                  {
                    "lat": 46.520030000000006,
                    "lng": 16.262520000000002
                  },
                  {
                    "lat": 46.52008000000001,
                    "lng": 16.26216
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.261930000000003
                  },
                  {
                    "lat": 46.520070000000004,
                    "lng": 16.26159
                  },
                  {
                    "lat": 46.52004,
                    "lng": 16.26134
                  },
                  {
                    "lat": 46.51997,
                    "lng": 16.26104
                  },
                  {
                    "lat": 46.519600000000004,
                    "lng": 16.259610000000002
                  },
                  {
                    "lat": 46.519510000000004,
                    "lng": 16.25929
                  },
                  {
                    "lat": 46.51937,
                    "lng": 16.25873
                  },
                  {
                    "lat": 46.51928,
                    "lng": 16.25836
                  },
                  {
                    "lat": 46.51906,
                    "lng": 16.257720000000003
                  },
                  {
                    "lat": 46.518950000000004,
                    "lng": 16.25748
                  },
                  {
                    "lat": 46.51874,
                    "lng": 16.256980000000002
                  },
                  {
                    "lat": 46.517990000000005,
                    "lng": 16.25533
                  },
                  {
                    "lat": 46.517790000000005,
                    "lng": 16.254810000000003
                  },
                  {
                    "lat": 46.51775000000001,
                    "lng": 16.25468
                  },
                  {
                    "lat": 46.517570000000006,
                    "lng": 16.25418
                  },
                  {
                    "lat": 46.5174,
                    "lng": 16.25371
                  },
                  {
                    "lat": 46.517250000000004,
                    "lng": 16.25325
                  },
                  {
                    "lat": 46.51718,
                    "lng": 16.253040000000002
                  },
                  {
                    "lat": 46.517050000000005,
                    "lng": 16.25268
                  },
                  {
                    "lat": 46.517010000000006,
                    "lng": 16.25254
                  },
                  {
                    "lat": 46.516940000000005,
                    "lng": 16.25234
                  },
                  {
                    "lat": 46.51690000000001,
                    "lng": 16.25223
                  },
                  {
                    "lat": 46.516830000000006,
                    "lng": 16.252010000000002
                  },
                  {
                    "lat": 46.51675,
                    "lng": 16.25175
                  },
                  {
                    "lat": 46.51670000000001,
                    "lng": 16.25156
                  },
                  {
                    "lat": 46.51664,
                    "lng": 16.251140000000003
                  },
                  {
                    "lat": 46.516600000000004,
                    "lng": 16.25053
                  },
                  {
                    "lat": 46.51662,
                    "lng": 16.250220000000002
                  },
                  {
                    "lat": 46.51662,
                    "lng": 16.25018
                  },
                  {
                    "lat": 46.516630000000006,
                    "lng": 16.25015
                  },
                  {
                    "lat": 46.516630000000006,
                    "lng": 16.2501
                  },
                  {
                    "lat": 46.51664,
                    "lng": 16.25007
                  },
                  {
                    "lat": 46.516650000000006,
                    "lng": 16.250030000000002
                  },
                  {
                    "lat": 46.516650000000006,
                    "lng": 16.24998
                  },
                  {
                    "lat": 46.51666,
                    "lng": 16.249940000000002
                  },
                  {
                    "lat": 46.51668,
                    "lng": 16.24989
                  },
                  {
                    "lat": 46.516690000000004,
                    "lng": 16.249830000000003
                  },
                  {
                    "lat": 46.51671,
                    "lng": 16.24977
                  },
                  {
                    "lat": 46.51673,
                    "lng": 16.2497
                  },
                  {
                    "lat": 46.51675,
                    "lng": 16.249640000000003
                  },
                  {
                    "lat": 46.516850000000005,
                    "lng": 16.2494
                  },
                  {
                    "lat": 46.51690000000001,
                    "lng": 16.249270000000003
                  },
                  {
                    "lat": 46.517,
                    "lng": 16.24896
                  },
                  {
                    "lat": 46.51706,
                    "lng": 16.24877
                  },
                  {
                    "lat": 46.51711,
                    "lng": 16.248540000000002
                  },
                  {
                    "lat": 46.51713,
                    "lng": 16.248330000000003
                  },
                  {
                    "lat": 46.517140000000005,
                    "lng": 16.248170000000002
                  },
                  {
                    "lat": 46.51713,
                    "lng": 16.24811
                  },
                  {
                    "lat": 46.517120000000006,
                    "lng": 16.248050000000003
                  },
                  {
                    "lat": 46.51709,
                    "lng": 16.24784
                  },
                  {
                    "lat": 46.517070000000004,
                    "lng": 16.24781
                  },
                  {
                    "lat": 46.51704,
                    "lng": 16.24772
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.52009,
                    "lng": 16.271330000000003
                  },
                  {
                    "lat": 46.520120000000006,
                    "lng": 16.2712
                  },
                  {
                    "lat": 46.52022,
                    "lng": 16.270690000000002
                  },
                  {
                    "lat": 46.52024,
                    "lng": 16.270480000000003
                  },
                  {
                    "lat": 46.520250000000004,
                    "lng": 16.27027
                  },
                  {
                    "lat": 46.520250000000004,
                    "lng": 16.26997
                  },
                  {
                    "lat": 46.52026,
                    "lng": 16.26953
                  },
                  {
                    "lat": 46.52026,
                    "lng": 16.269370000000002
                  },
                  {
                    "lat": 46.52028000000001,
                    "lng": 16.2691
                  },
                  {
                    "lat": 46.52031,
                    "lng": 16.26875
                  },
                  {
                    "lat": 46.52033,
                    "lng": 16.26858
                  },
                  {
                    "lat": 46.520340000000004,
                    "lng": 16.26845
                  },
                  {
                    "lat": 46.52037000000001,
                    "lng": 16.26817
                  },
                  {
                    "lat": 46.520390000000006,
                    "lng": 16.26793
                  },
                  {
                    "lat": 46.520390000000006,
                    "lng": 16.2678
                  },
                  {
                    "lat": 46.5204,
                    "lng": 16.2676
                  },
                  {
                    "lat": 46.520390000000006,
                    "lng": 16.26754
                  },
                  {
                    "lat": 46.52038,
                    "lng": 16.267280000000003
                  },
                  {
                    "lat": 46.52038,
                    "lng": 16.26723
                  },
                  {
                    "lat": 46.52035,
                    "lng": 16.266920000000002
                  },
                  {
                    "lat": 46.52031,
                    "lng": 16.26661
                  },
                  {
                    "lat": 46.520250000000004,
                    "lng": 16.2663
                  },
                  {
                    "lat": 46.52017000000001,
                    "lng": 16.26591
                  },
                  {
                    "lat": 46.52008000000001,
                    "lng": 16.26548
                  },
                  {
                    "lat": 46.51999000000001,
                    "lng": 16.265060000000002
                  },
                  {
                    "lat": 46.51993,
                    "lng": 16.26479
                  },
                  {
                    "lat": 46.51990000000001,
                    "lng": 16.26461
                  },
                  {
                    "lat": 46.51988,
                    "lng": 16.26445
                  },
                  {
                    "lat": 46.51986,
                    "lng": 16.26434
                  },
                  {
                    "lat": 46.51984,
                    "lng": 16.264190000000003
                  },
                  {
                    "lat": 46.51984,
                    "lng": 16.26408
                  },
                  {
                    "lat": 46.51984,
                    "lng": 16.264000000000003
                  },
                  {
                    "lat": 46.51984,
                    "lng": 16.26377
                  },
                  {
                    "lat": 46.51988,
                    "lng": 16.263440000000003
                  },
                  {
                    "lat": 46.51988,
                    "lng": 16.26343
                  },
                  {
                    "lat": 46.519940000000005,
                    "lng": 16.263090000000002
                  },
                  {
                    "lat": 46.519960000000005,
                    "lng": 16.26294
                  },
                  {
                    "lat": 46.520030000000006,
                    "lng": 16.262520000000002
                  },
                  {
                    "lat": 46.52008000000001,
                    "lng": 16.26216
                  },
                  {
                    "lat": 46.52009,
                    "lng": 16.261930000000003
                  },
                  {
                    "lat": 46.520070000000004,
                    "lng": 16.26159
                  },
                  {
                    "lat": 46.52004,
                    "lng": 16.26134
                  },
                  {
                    "lat": 46.51997,
                    "lng": 16.26104
                  },
                  {
                    "lat": 46.519600000000004,
                    "lng": 16.259610000000002
                  },
                  {
                    "lat": 46.519510000000004,
                    "lng": 16.25929
                  },
                  {
                    "lat": 46.51937,
                    "lng": 16.25873
                  },
                  {
                    "lat": 46.51928,
                    "lng": 16.25836
                  },
                  {
                    "lat": 46.51906,
                    "lng": 16.257720000000003
                  },
                  {
                    "lat": 46.518950000000004,
                    "lng": 16.25748
                  },
                  {
                    "lat": 46.51874,
                    "lng": 16.256980000000002
                  },
                  {
                    "lat": 46.517990000000005,
                    "lng": 16.25533
                  },
                  {
                    "lat": 46.517790000000005,
                    "lng": 16.254810000000003
                  },
                  {
                    "lat": 46.51775000000001,
                    "lng": 16.25468
                  },
                  {
                    "lat": 46.517570000000006,
                    "lng": 16.25418
                  },
                  {
                    "lat": 46.5174,
                    "lng": 16.25371
                  },
                  {
                    "lat": 46.517250000000004,
                    "lng": 16.25325
                  },
                  {
                    "lat": 46.51718,
                    "lng": 16.253040000000002
                  },
                  {
                    "lat": 46.517050000000005,
                    "lng": 16.25268
                  },
                  {
                    "lat": 46.517010000000006,
                    "lng": 16.25254
                  },
                  {
                    "lat": 46.516940000000005,
                    "lng": 16.25234
                  },
                  {
                    "lat": 46.51690000000001,
                    "lng": 16.25223
                  },
                  {
                    "lat": 46.516830000000006,
                    "lng": 16.252010000000002
                  },
                  {
                    "lat": 46.51675,
                    "lng": 16.25175
                  },
                  {
                    "lat": 46.51670000000001,
                    "lng": 16.25156
                  },
                  {
                    "lat": 46.51664,
                    "lng": 16.251140000000003
                  },
                  {
                    "lat": 46.516600000000004,
                    "lng": 16.25053
                  },
                  {
                    "lat": 46.51662,
                    "lng": 16.250220000000002
                  },
                  {
                    "lat": 46.51662,
                    "lng": 16.25018
                  },
                  {
                    "lat": 46.516630000000006,
                    "lng": 16.25015
                  },
                  {
                    "lat": 46.516630000000006,
                    "lng": 16.2501
                  },
                  {
                    "lat": 46.51664,
                    "lng": 16.25007
                  },
                  {
                    "lat": 46.516650000000006,
                    "lng": 16.250030000000002
                  },
                  {
                    "lat": 46.516650000000006,
                    "lng": 16.24998
                  },
                  {
                    "lat": 46.51666,
                    "lng": 16.249940000000002
                  },
                  {
                    "lat": 46.51668,
                    "lng": 16.24989
                  },
                  {
                    "lat": 46.516690000000004,
                    "lng": 16.249830000000003
                  },
                  {
                    "lat": 46.51671,
                    "lng": 16.24977
                  },
                  {
                    "lat": 46.51673,
                    "lng": 16.2497
                  },
                  {
                    "lat": 46.51675,
                    "lng": 16.249640000000003
                  },
                  {
                    "lat": 46.516850000000005,
                    "lng": 16.2494
                  },
                  {
                    "lat": 46.51690000000001,
                    "lng": 16.249270000000003
                  },
                  {
                    "lat": 46.517,
                    "lng": 16.24896
                  },
                  {
                    "lat": 46.51706,
                    "lng": 16.24877
                  },
                  {
                    "lat": 46.51711,
                    "lng": 16.248540000000002
                  },
                  {
                    "lat": 46.51713,
                    "lng": 16.248330000000003
                  },
                  {
                    "lat": 46.517140000000005,
                    "lng": 16.248170000000002
                  },
                  {
                    "lat": 46.51713,
                    "lng": 16.24811
                  },
                  {
                    "lat": 46.517120000000006,
                    "lng": 16.248050000000003
                  },
                  {
                    "lat": 46.51709,
                    "lng": 16.24784
                  },
                  {
                    "lat": 46.517070000000004,
                    "lng": 16.24781
                  },
                  {
                    "lat": 46.51704,
                    "lng": 16.24772
                  }
                ],
                "instructions": "Continue onto <b>Veščica</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.5200933,
                  "lng": 16.2713343
                },
                "end_point": {
                  "lat": 46.5170416,
                  "lng": 16.2477216
                }
              },
              {
                "distance": {
                  "text": "0.4 km",
                  "value": 350
                },
                "duration": {
                  "text": "1 min",
                  "value": 20
                },
                "end_location": {
                  "lat": 46.5150097,
                  "lng": 16.2442556
                },
                "polyline": {
                  "points": "oj|zGgkdbBVt@HN`@`ALXf@hAj@lAd@bAFPLVDJd@bAd@`Az@nARTNP@@"
                },
                "start_location": {
                  "lat": 46.5170416,
                  "lng": 16.2477216
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "oj|zGgkdbBVt@HN`@`ALXf@hAj@lAd@bAFPLVDJd@bAd@`Az@nARTNP@@",
                "path": [
                  {
                    "lat": 46.51704,
                    "lng": 16.24772
                  },
                  {
                    "lat": 46.516920000000006,
                    "lng": 16.24745
                  },
                  {
                    "lat": 46.516870000000004,
                    "lng": 16.24737
                  },
                  {
                    "lat": 46.51670000000001,
                    "lng": 16.247040000000002
                  },
                  {
                    "lat": 46.516630000000006,
                    "lng": 16.24691
                  },
                  {
                    "lat": 46.51643000000001,
                    "lng": 16.246540000000003
                  },
                  {
                    "lat": 46.51621,
                    "lng": 16.24615
                  },
                  {
                    "lat": 46.516020000000005,
                    "lng": 16.245810000000002
                  },
                  {
                    "lat": 46.515980000000006,
                    "lng": 16.245720000000002
                  },
                  {
                    "lat": 46.515910000000005,
                    "lng": 16.2456
                  },
                  {
                    "lat": 46.51588,
                    "lng": 16.245540000000002
                  },
                  {
                    "lat": 46.515690000000006,
                    "lng": 16.2452
                  },
                  {
                    "lat": 46.5155,
                    "lng": 16.244870000000002
                  },
                  {
                    "lat": 46.51520000000001,
                    "lng": 16.24447
                  },
                  {
                    "lat": 46.515100000000004,
                    "lng": 16.24436
                  },
                  {
                    "lat": 46.51502000000001,
                    "lng": 16.24427
                  },
                  {
                    "lat": 46.515010000000004,
                    "lng": 16.24426
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.51704,
                    "lng": 16.24772
                  },
                  {
                    "lat": 46.516920000000006,
                    "lng": 16.24745
                  },
                  {
                    "lat": 46.516870000000004,
                    "lng": 16.24737
                  },
                  {
                    "lat": 46.51670000000001,
                    "lng": 16.247040000000002
                  },
                  {
                    "lat": 46.516630000000006,
                    "lng": 16.24691
                  },
                  {
                    "lat": 46.51643000000001,
                    "lng": 16.246540000000003
                  },
                  {
                    "lat": 46.51621,
                    "lng": 16.24615
                  },
                  {
                    "lat": 46.516020000000005,
                    "lng": 16.245810000000002
                  },
                  {
                    "lat": 46.515980000000006,
                    "lng": 16.245720000000002
                  },
                  {
                    "lat": 46.515910000000005,
                    "lng": 16.2456
                  },
                  {
                    "lat": 46.51588,
                    "lng": 16.245540000000002
                  },
                  {
                    "lat": 46.515690000000006,
                    "lng": 16.2452
                  },
                  {
                    "lat": 46.5155,
                    "lng": 16.244870000000002
                  },
                  {
                    "lat": 46.51520000000001,
                    "lng": 16.24447
                  },
                  {
                    "lat": 46.515100000000004,
                    "lng": 16.24436
                  },
                  {
                    "lat": 46.51502000000001,
                    "lng": 16.24427
                  },
                  {
                    "lat": 46.515010000000004,
                    "lng": 16.24426
                  }
                ],
                "instructions": "Continue onto <b>Pristava</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.5170416,
                  "lng": 16.2477216
                },
                "end_point": {
                  "lat": 46.5150097,
                  "lng": 16.2442556
                }
              },
              {
                "distance": {
                  "text": "0.6 km",
                  "value": 619
                },
                "duration": {
                  "text": "1 min",
                  "value": 33
                },
                "end_location": {
                  "lat": 46.5120222,
                  "lng": 16.2376281
                },
                "polyline": {
                  "points": "y}{zGsucbBJLJLX\\DFX`@`A`Bf@`Al@jAVj@Rf@^`A\\z@FRJZ@DJd@H`@Jp@Fh@Fn@Dl@Df@Hh@@JHp@BRNf@Jd@L^LV@BN\\Pf@R`@b@x@"
                },
                "start_location": {
                  "lat": 46.5150097,
                  "lng": 16.2442556
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "y}{zGsucbBJLJLX\\DFX`@`A`Bf@`Al@jAVj@Rf@^`A\\z@FRJZ@DJd@H`@Jp@Fh@Fn@Dl@Df@Hh@@JHp@BRNf@Jd@L^LV@BN\\Pf@R`@b@x@",
                "path": [
                  {
                    "lat": 46.515010000000004,
                    "lng": 16.24426
                  },
                  {
                    "lat": 46.514950000000006,
                    "lng": 16.24419
                  },
                  {
                    "lat": 46.51489,
                    "lng": 16.244120000000002
                  },
                  {
                    "lat": 46.51476,
                    "lng": 16.24397
                  },
                  {
                    "lat": 46.51473000000001,
                    "lng": 16.243930000000002
                  },
                  {
                    "lat": 46.5146,
                    "lng": 16.24376
                  },
                  {
                    "lat": 46.51427,
                    "lng": 16.243270000000003
                  },
                  {
                    "lat": 46.514070000000004,
                    "lng": 16.24294
                  },
                  {
                    "lat": 46.51384,
                    "lng": 16.24256
                  },
                  {
                    "lat": 46.513720000000006,
                    "lng": 16.242340000000002
                  },
                  {
                    "lat": 46.51362,
                    "lng": 16.242140000000003
                  },
                  {
                    "lat": 46.51346,
                    "lng": 16.24181
                  },
                  {
                    "lat": 46.513310000000004,
                    "lng": 16.24151
                  },
                  {
                    "lat": 46.513270000000006,
                    "lng": 16.241410000000002
                  },
                  {
                    "lat": 46.51321,
                    "lng": 16.24127
                  },
                  {
                    "lat": 46.513200000000005,
                    "lng": 16.24124
                  },
                  {
                    "lat": 46.51314000000001,
                    "lng": 16.24105
                  },
                  {
                    "lat": 46.513090000000005,
                    "lng": 16.24088
                  },
                  {
                    "lat": 46.51303,
                    "lng": 16.240630000000003
                  },
                  {
                    "lat": 46.51299,
                    "lng": 16.24042
                  },
                  {
                    "lat": 46.512950000000004,
                    "lng": 16.240180000000002
                  },
                  {
                    "lat": 46.51292,
                    "lng": 16.23995
                  },
                  {
                    "lat": 46.512890000000006,
                    "lng": 16.23975
                  },
                  {
                    "lat": 46.512840000000004,
                    "lng": 16.23954
                  },
                  {
                    "lat": 46.51283,
                    "lng": 16.23948
                  },
                  {
                    "lat": 46.51278000000001,
                    "lng": 16.239230000000003
                  },
                  {
                    "lat": 46.51276000000001,
                    "lng": 16.239130000000003
                  },
                  {
                    "lat": 46.51268,
                    "lng": 16.23893
                  },
                  {
                    "lat": 46.512620000000005,
                    "lng": 16.23874
                  },
                  {
                    "lat": 46.512550000000005,
                    "lng": 16.238580000000002
                  },
                  {
                    "lat": 46.512480000000004,
                    "lng": 16.23846
                  },
                  {
                    "lat": 46.51247,
                    "lng": 16.23844
                  },
                  {
                    "lat": 46.51239,
                    "lng": 16.238290000000003
                  },
                  {
                    "lat": 46.5123,
                    "lng": 16.23809
                  },
                  {
                    "lat": 46.51220000000001,
                    "lng": 16.237920000000003
                  },
                  {
                    "lat": 46.51202000000001,
                    "lng": 16.237630000000003
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.515010000000004,
                    "lng": 16.24426
                  },
                  {
                    "lat": 46.514950000000006,
                    "lng": 16.24419
                  },
                  {
                    "lat": 46.51489,
                    "lng": 16.244120000000002
                  },
                  {
                    "lat": 46.51476,
                    "lng": 16.24397
                  },
                  {
                    "lat": 46.51473000000001,
                    "lng": 16.243930000000002
                  },
                  {
                    "lat": 46.5146,
                    "lng": 16.24376
                  },
                  {
                    "lat": 46.51427,
                    "lng": 16.243270000000003
                  },
                  {
                    "lat": 46.514070000000004,
                    "lng": 16.24294
                  },
                  {
                    "lat": 46.51384,
                    "lng": 16.24256
                  },
                  {
                    "lat": 46.513720000000006,
                    "lng": 16.242340000000002
                  },
                  {
                    "lat": 46.51362,
                    "lng": 16.242140000000003
                  },
                  {
                    "lat": 46.51346,
                    "lng": 16.24181
                  },
                  {
                    "lat": 46.513310000000004,
                    "lng": 16.24151
                  },
                  {
                    "lat": 46.513270000000006,
                    "lng": 16.241410000000002
                  },
                  {
                    "lat": 46.51321,
                    "lng": 16.24127
                  },
                  {
                    "lat": 46.513200000000005,
                    "lng": 16.24124
                  },
                  {
                    "lat": 46.51314000000001,
                    "lng": 16.24105
                  },
                  {
                    "lat": 46.513090000000005,
                    "lng": 16.24088
                  },
                  {
                    "lat": 46.51303,
                    "lng": 16.240630000000003
                  },
                  {
                    "lat": 46.51299,
                    "lng": 16.24042
                  },
                  {
                    "lat": 46.512950000000004,
                    "lng": 16.240180000000002
                  },
                  {
                    "lat": 46.51292,
                    "lng": 16.23995
                  },
                  {
                    "lat": 46.512890000000006,
                    "lng": 16.23975
                  },
                  {
                    "lat": 46.512840000000004,
                    "lng": 16.23954
                  },
                  {
                    "lat": 46.51283,
                    "lng": 16.23948
                  },
                  {
                    "lat": 46.51278000000001,
                    "lng": 16.239230000000003
                  },
                  {
                    "lat": 46.51276000000001,
                    "lng": 16.239130000000003
                  },
                  {
                    "lat": 46.51268,
                    "lng": 16.23893
                  },
                  {
                    "lat": 46.512620000000005,
                    "lng": 16.23874
                  },
                  {
                    "lat": 46.512550000000005,
                    "lng": 16.238580000000002
                  },
                  {
                    "lat": 46.512480000000004,
                    "lng": 16.23846
                  },
                  {
                    "lat": 46.51247,
                    "lng": 16.23844
                  },
                  {
                    "lat": 46.51239,
                    "lng": 16.238290000000003
                  },
                  {
                    "lat": 46.5123,
                    "lng": 16.23809
                  },
                  {
                    "lat": 46.51220000000001,
                    "lng": 16.237920000000003
                  },
                  {
                    "lat": 46.51202000000001,
                    "lng": 16.237630000000003
                  }
                ],
                "instructions": "Continue onto <b>Veščica</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.5150097,
                  "lng": 16.2442556
                },
                "end_point": {
                  "lat": 46.5120222,
                  "lng": 16.2376281
                }
              },
              {
                "distance": {
                  "text": "0.1 km",
                  "value": 135
                },
                "duration": {
                  "text": "1 min",
                  "value": 8
                },
                "end_location": {
                  "lat": 46.51137809999999,
                  "lng": 16.2361422
                },
                "polyline": {
                  "points": "ck{zGelbbBXn@Tl@@@Pf@J^Nd@^zA"
                },
                "start_location": {
                  "lat": 46.5120222,
                  "lng": 16.2376281
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "ck{zGelbbBXn@Tl@@@Pf@J^Nd@^zA",
                "path": [
                  {
                    "lat": 46.51202000000001,
                    "lng": 16.237630000000003
                  },
                  {
                    "lat": 46.51189,
                    "lng": 16.23739
                  },
                  {
                    "lat": 46.51178,
                    "lng": 16.237160000000003
                  },
                  {
                    "lat": 46.511770000000006,
                    "lng": 16.23715
                  },
                  {
                    "lat": 46.511680000000005,
                    "lng": 16.23695
                  },
                  {
                    "lat": 46.51162,
                    "lng": 16.236790000000003
                  },
                  {
                    "lat": 46.511540000000004,
                    "lng": 16.236600000000003
                  },
                  {
                    "lat": 46.51138,
                    "lng": 16.236140000000002
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.51202000000001,
                    "lng": 16.237630000000003
                  },
                  {
                    "lat": 46.51189,
                    "lng": 16.23739
                  },
                  {
                    "lat": 46.51178,
                    "lng": 16.237160000000003
                  },
                  {
                    "lat": 46.511770000000006,
                    "lng": 16.23715
                  },
                  {
                    "lat": 46.511680000000005,
                    "lng": 16.23695
                  },
                  {
                    "lat": 46.51162,
                    "lng": 16.236790000000003
                  },
                  {
                    "lat": 46.511540000000004,
                    "lng": 16.236600000000003
                  },
                  {
                    "lat": 46.51138,
                    "lng": 16.236140000000002
                  }
                ],
                "instructions": "Continue onto <b>Presika</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.5120222,
                  "lng": 16.2376281
                },
                "end_point": {
                  "lat": 46.51137809999999,
                  "lng": 16.2361422
                }
              },
              {
                "distance": {
                  "text": "0.7 km",
                  "value": 739
                },
                "duration": {
                  "text": "1 min",
                  "value": 53
                },
                "end_location": {
                  "lat": 46.5100319,
                  "lng": 16.2270616
                },
                "polyline": {
                  "points": "cg{zG{bbbBPz@H\\DPJf@@DLn@FbA@XDv@?X@l@?n@?h@APCf@IrAIt@Et@?l@Ad@B^?D@J@T?DBRBTH`@j@nBXl@N^Th@@@Ph@L`@BHPp@H^BJLn@Fl@Dj@B^Bh@C`AAj@El@C^"
                },
                "start_location": {
                  "lat": 46.51137809999999,
                  "lng": 16.2361422
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "cg{zG{bbbBPz@H\\DPJf@@DLn@FbA@XDv@?X@l@?n@?h@APCf@IrAIt@Et@?l@Ad@B^?D@J@T?DBRBTH`@j@nBXl@N^Th@@@Ph@L`@BHPp@H^BJLn@Fl@Dj@B^Bh@C`AAj@El@C^",
                "path": [
                  {
                    "lat": 46.51138,
                    "lng": 16.236140000000002
                  },
                  {
                    "lat": 46.51129,
                    "lng": 16.23584
                  },
                  {
                    "lat": 46.51124,
                    "lng": 16.23569
                  },
                  {
                    "lat": 46.511210000000005,
                    "lng": 16.2356
                  },
                  {
                    "lat": 46.51115,
                    "lng": 16.235400000000002
                  },
                  {
                    "lat": 46.511140000000005,
                    "lng": 16.23537
                  },
                  {
                    "lat": 46.511070000000004,
                    "lng": 16.23513
                  },
                  {
                    "lat": 46.511030000000005,
                    "lng": 16.23479
                  },
                  {
                    "lat": 46.51102,
                    "lng": 16.23466
                  },
                  {
                    "lat": 46.51099000000001,
                    "lng": 16.23438
                  },
                  {
                    "lat": 46.51099000000001,
                    "lng": 16.234250000000003
                  },
                  {
                    "lat": 46.51098,
                    "lng": 16.23402
                  },
                  {
                    "lat": 46.51098,
                    "lng": 16.233780000000003
                  },
                  {
                    "lat": 46.51098,
                    "lng": 16.23357
                  },
                  {
                    "lat": 46.51099000000001,
                    "lng": 16.23348
                  },
                  {
                    "lat": 46.511010000000006,
                    "lng": 16.23328
                  },
                  {
                    "lat": 46.51106,
                    "lng": 16.232860000000002
                  },
                  {
                    "lat": 46.51111,
                    "lng": 16.232590000000002
                  },
                  {
                    "lat": 46.511140000000005,
                    "lng": 16.23232
                  },
                  {
                    "lat": 46.511140000000005,
                    "lng": 16.232090000000003
                  },
                  {
                    "lat": 46.51115,
                    "lng": 16.231900000000003
                  },
                  {
                    "lat": 46.51113,
                    "lng": 16.231740000000002
                  },
                  {
                    "lat": 46.51113,
                    "lng": 16.23171
                  },
                  {
                    "lat": 46.511120000000005,
                    "lng": 16.231650000000002
                  },
                  {
                    "lat": 46.51111,
                    "lng": 16.231540000000003
                  },
                  {
                    "lat": 46.51111,
                    "lng": 16.23151
                  },
                  {
                    "lat": 46.51109,
                    "lng": 16.23141
                  },
                  {
                    "lat": 46.511070000000004,
                    "lng": 16.2313
                  },
                  {
                    "lat": 46.51102,
                    "lng": 16.23113
                  },
                  {
                    "lat": 46.5108,
                    "lng": 16.23057
                  },
                  {
                    "lat": 46.510670000000005,
                    "lng": 16.23034
                  },
                  {
                    "lat": 46.51059,
                    "lng": 16.23018
                  },
                  {
                    "lat": 46.51048,
                    "lng": 16.22997
                  },
                  {
                    "lat": 46.510470000000005,
                    "lng": 16.229960000000002
                  },
                  {
                    "lat": 46.510380000000005,
                    "lng": 16.229750000000003
                  },
                  {
                    "lat": 46.510310000000004,
                    "lng": 16.229580000000002
                  },
                  {
                    "lat": 46.510290000000005,
                    "lng": 16.22953
                  },
                  {
                    "lat": 46.510200000000005,
                    "lng": 16.229280000000003
                  },
                  {
                    "lat": 46.51015,
                    "lng": 16.22912
                  },
                  {
                    "lat": 46.510130000000004,
                    "lng": 16.22906
                  },
                  {
                    "lat": 46.51006,
                    "lng": 16.228820000000002
                  },
                  {
                    "lat": 46.510020000000004,
                    "lng": 16.22859
                  },
                  {
                    "lat": 46.50999,
                    "lng": 16.22837
                  },
                  {
                    "lat": 46.50997,
                    "lng": 16.22821
                  },
                  {
                    "lat": 46.50995,
                    "lng": 16.228
                  },
                  {
                    "lat": 46.50997,
                    "lng": 16.22767
                  },
                  {
                    "lat": 46.509980000000006,
                    "lng": 16.22745
                  },
                  {
                    "lat": 46.51001,
                    "lng": 16.227220000000003
                  },
                  {
                    "lat": 46.51003,
                    "lng": 16.22706
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.51138,
                    "lng": 16.236140000000002
                  },
                  {
                    "lat": 46.51129,
                    "lng": 16.23584
                  },
                  {
                    "lat": 46.51124,
                    "lng": 16.23569
                  },
                  {
                    "lat": 46.511210000000005,
                    "lng": 16.2356
                  },
                  {
                    "lat": 46.51115,
                    "lng": 16.235400000000002
                  },
                  {
                    "lat": 46.511140000000005,
                    "lng": 16.23537
                  },
                  {
                    "lat": 46.511070000000004,
                    "lng": 16.23513
                  },
                  {
                    "lat": 46.511030000000005,
                    "lng": 16.23479
                  },
                  {
                    "lat": 46.51102,
                    "lng": 16.23466
                  },
                  {
                    "lat": 46.51099000000001,
                    "lng": 16.23438
                  },
                  {
                    "lat": 46.51099000000001,
                    "lng": 16.234250000000003
                  },
                  {
                    "lat": 46.51098,
                    "lng": 16.23402
                  },
                  {
                    "lat": 46.51098,
                    "lng": 16.233780000000003
                  },
                  {
                    "lat": 46.51098,
                    "lng": 16.23357
                  },
                  {
                    "lat": 46.51099000000001,
                    "lng": 16.23348
                  },
                  {
                    "lat": 46.511010000000006,
                    "lng": 16.23328
                  },
                  {
                    "lat": 46.51106,
                    "lng": 16.232860000000002
                  },
                  {
                    "lat": 46.51111,
                    "lng": 16.232590000000002
                  },
                  {
                    "lat": 46.511140000000005,
                    "lng": 16.23232
                  },
                  {
                    "lat": 46.511140000000005,
                    "lng": 16.232090000000003
                  },
                  {
                    "lat": 46.51115,
                    "lng": 16.231900000000003
                  },
                  {
                    "lat": 46.51113,
                    "lng": 16.231740000000002
                  },
                  {
                    "lat": 46.51113,
                    "lng": 16.23171
                  },
                  {
                    "lat": 46.511120000000005,
                    "lng": 16.231650000000002
                  },
                  {
                    "lat": 46.51111,
                    "lng": 16.231540000000003
                  },
                  {
                    "lat": 46.51111,
                    "lng": 16.23151
                  },
                  {
                    "lat": 46.51109,
                    "lng": 16.23141
                  },
                  {
                    "lat": 46.511070000000004,
                    "lng": 16.2313
                  },
                  {
                    "lat": 46.51102,
                    "lng": 16.23113
                  },
                  {
                    "lat": 46.5108,
                    "lng": 16.23057
                  },
                  {
                    "lat": 46.510670000000005,
                    "lng": 16.23034
                  },
                  {
                    "lat": 46.51059,
                    "lng": 16.23018
                  },
                  {
                    "lat": 46.51048,
                    "lng": 16.22997
                  },
                  {
                    "lat": 46.510470000000005,
                    "lng": 16.229960000000002
                  },
                  {
                    "lat": 46.510380000000005,
                    "lng": 16.229750000000003
                  },
                  {
                    "lat": 46.510310000000004,
                    "lng": 16.229580000000002
                  },
                  {
                    "lat": 46.510290000000005,
                    "lng": 16.22953
                  },
                  {
                    "lat": 46.510200000000005,
                    "lng": 16.229280000000003
                  },
                  {
                    "lat": 46.51015,
                    "lng": 16.22912
                  },
                  {
                    "lat": 46.510130000000004,
                    "lng": 16.22906
                  },
                  {
                    "lat": 46.51006,
                    "lng": 16.228820000000002
                  },
                  {
                    "lat": 46.510020000000004,
                    "lng": 16.22859
                  },
                  {
                    "lat": 46.50999,
                    "lng": 16.22837
                  },
                  {
                    "lat": 46.50997,
                    "lng": 16.22821
                  },
                  {
                    "lat": 46.50995,
                    "lng": 16.228
                  },
                  {
                    "lat": 46.50997,
                    "lng": 16.22767
                  },
                  {
                    "lat": 46.509980000000006,
                    "lng": 16.22745
                  },
                  {
                    "lat": 46.51001,
                    "lng": 16.227220000000003
                  },
                  {
                    "lat": 46.51003,
                    "lng": 16.22706
                  }
                ],
                "instructions": "Continue onto <b>Stročja vas</b>",
                "maneuver": "",
                "start_point": {
                  "lat": 46.51137809999999,
                  "lng": 16.2361422
                },
                "end_point": {
                  "lat": 46.5100319,
                  "lng": 16.2270616
                }
              },
              {
                "distance": {
                  "text": "0.2 km",
                  "value": 193
                },
                "duration": {
                  "text": "1 min",
                  "value": 20
                },
                "end_location": {
                  "lat": 46.50842,
                  "lng": 16.2274016
                },
                "maneuver": "turn-left",
                "polyline": {
                  "points": "u~zzGcj`bBdBd@`@HB@B?F@F?BAD?FENIPOLOFGVSPOLIPILE"
                },
                "start_location": {
                  "lat": 46.5100319,
                  "lng": 16.2270616
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "u~zzGcj`bBdBd@`@HB@B?F@F?BAD?FENIPOLOFGVSPOLIPILE",
                "path": [
                  {
                    "lat": 46.51003,
                    "lng": 16.22706
                  },
                  {
                    "lat": 46.50952,
                    "lng": 16.22687
                  },
                  {
                    "lat": 46.509350000000005,
                    "lng": 16.22682
                  },
                  {
                    "lat": 46.509330000000006,
                    "lng": 16.22681
                  },
                  {
                    "lat": 46.509310000000006,
                    "lng": 16.22681
                  },
                  {
                    "lat": 46.50927,
                    "lng": 16.2268
                  },
                  {
                    "lat": 46.50923,
                    "lng": 16.2268
                  },
                  {
                    "lat": 46.50921,
                    "lng": 16.22681
                  },
                  {
                    "lat": 46.50918,
                    "lng": 16.22681
                  },
                  {
                    "lat": 46.50914,
                    "lng": 16.226840000000003
                  },
                  {
                    "lat": 46.509060000000005,
                    "lng": 16.22689
                  },
                  {
                    "lat": 46.508970000000005,
                    "lng": 16.22697
                  },
                  {
                    "lat": 46.508900000000004,
                    "lng": 16.227050000000002
                  },
                  {
                    "lat": 46.508860000000006,
                    "lng": 16.22709
                  },
                  {
                    "lat": 46.50874,
                    "lng": 16.22719
                  },
                  {
                    "lat": 46.50865,
                    "lng": 16.22727
                  },
                  {
                    "lat": 46.50858,
                    "lng": 16.227320000000002
                  },
                  {
                    "lat": 46.50849,
                    "lng": 16.22737
                  },
                  {
                    "lat": 46.50842,
                    "lng": 16.227400000000003
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.51003,
                    "lng": 16.22706
                  },
                  {
                    "lat": 46.50952,
                    "lng": 16.22687
                  },
                  {
                    "lat": 46.509350000000005,
                    "lng": 16.22682
                  },
                  {
                    "lat": 46.509330000000006,
                    "lng": 16.22681
                  },
                  {
                    "lat": 46.509310000000006,
                    "lng": 16.22681
                  },
                  {
                    "lat": 46.50927,
                    "lng": 16.2268
                  },
                  {
                    "lat": 46.50923,
                    "lng": 16.2268
                  },
                  {
                    "lat": 46.50921,
                    "lng": 16.22681
                  },
                  {
                    "lat": 46.50918,
                    "lng": 16.22681
                  },
                  {
                    "lat": 46.50914,
                    "lng": 16.226840000000003
                  },
                  {
                    "lat": 46.509060000000005,
                    "lng": 16.22689
                  },
                  {
                    "lat": 46.508970000000005,
                    "lng": 16.22697
                  },
                  {
                    "lat": 46.508900000000004,
                    "lng": 16.227050000000002
                  },
                  {
                    "lat": 46.508860000000006,
                    "lng": 16.22709
                  },
                  {
                    "lat": 46.50874,
                    "lng": 16.22719
                  },
                  {
                    "lat": 46.50865,
                    "lng": 16.22727
                  },
                  {
                    "lat": 46.50858,
                    "lng": 16.227320000000002
                  },
                  {
                    "lat": 46.50849,
                    "lng": 16.22737
                  },
                  {
                    "lat": 46.50842,
                    "lng": 16.227400000000003
                  }
                ],
                "instructions": "Turn <b>left</b> to stay on <b>Stročja vas</b>",
                "start_point": {
                  "lat": 46.5100319,
                  "lng": 16.2270616
                },
                "end_point": {
                  "lat": 46.50842,
                  "lng": 16.2274016
                }
              },
              {
                "distance": {
                  "text": "0.2 km",
                  "value": 166
                },
                "duration": {
                  "text": "1 min",
                  "value": 12
                },
                "end_location": {
                  "lat": 46.5069573,
                  "lng": 16.2277068
                },
                "maneuver": "straight",
                "polyline": {
                  "points": "stzzGgl`bBHEJEFAn@G`AEr@@RAF?HCJCHCFEZO"
                },
                "start_location": {
                  "lat": 46.50842,
                  "lng": 16.2274016
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "stzzGgl`bBHEJEFAn@G`AEr@@RAF?HCJCHCFEZO",
                "path": [
                  {
                    "lat": 46.50842,
                    "lng": 16.227400000000003
                  },
                  {
                    "lat": 46.508370000000006,
                    "lng": 16.227430000000002
                  },
                  {
                    "lat": 46.50831,
                    "lng": 16.22746
                  },
                  {
                    "lat": 46.50827,
                    "lng": 16.22747
                  },
                  {
                    "lat": 46.508030000000005,
                    "lng": 16.227510000000002
                  },
                  {
                    "lat": 46.50770000000001,
                    "lng": 16.22754
                  },
                  {
                    "lat": 46.50744,
                    "lng": 16.22753
                  },
                  {
                    "lat": 46.507340000000006,
                    "lng": 16.22754
                  },
                  {
                    "lat": 46.5073,
                    "lng": 16.22754
                  },
                  {
                    "lat": 46.507250000000006,
                    "lng": 16.22756
                  },
                  {
                    "lat": 46.50719,
                    "lng": 16.22758
                  },
                  {
                    "lat": 46.50714000000001,
                    "lng": 16.227600000000002
                  },
                  {
                    "lat": 46.5071,
                    "lng": 16.22763
                  },
                  {
                    "lat": 46.50696000000001,
                    "lng": 16.227710000000002
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.50842,
                    "lng": 16.227400000000003
                  },
                  {
                    "lat": 46.508370000000006,
                    "lng": 16.227430000000002
                  },
                  {
                    "lat": 46.50831,
                    "lng": 16.22746
                  },
                  {
                    "lat": 46.50827,
                    "lng": 16.22747
                  },
                  {
                    "lat": 46.508030000000005,
                    "lng": 16.227510000000002
                  },
                  {
                    "lat": 46.50770000000001,
                    "lng": 16.22754
                  },
                  {
                    "lat": 46.50744,
                    "lng": 16.22753
                  },
                  {
                    "lat": 46.507340000000006,
                    "lng": 16.22754
                  },
                  {
                    "lat": 46.5073,
                    "lng": 16.22754
                  },
                  {
                    "lat": 46.507250000000006,
                    "lng": 16.22756
                  },
                  {
                    "lat": 46.50719,
                    "lng": 16.22758
                  },
                  {
                    "lat": 46.50714000000001,
                    "lng": 16.227600000000002
                  },
                  {
                    "lat": 46.5071,
                    "lng": 16.22763
                  },
                  {
                    "lat": 46.50696000000001,
                    "lng": 16.227710000000002
                  }
                ],
                "instructions": "Continue straight onto <b>Nunska Graba</b>",
                "start_point": {
                  "lat": 46.50842,
                  "lng": 16.2274016
                },
                "end_point": {
                  "lat": 46.5069573,
                  "lng": 16.2277068
                }
              },
              {
                "distance": {
                  "text": "0.1 km",
                  "value": 120
                },
                "duration": {
                  "text": "1 min",
                  "value": 7
                },
                "end_location": {
                  "lat": 46.50596849999999,
                  "lng": 16.2283278
                },
                "maneuver": "straight",
                "polyline": {
                  "points": "okzzGen`bBn@g@JG\\QRKf@UNENING"
                },
                "start_location": {
                  "lat": 46.5069573,
                  "lng": 16.2277068
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "okzzGen`bBn@g@JG\\QRKf@UNENING",
                "path": [
                  {
                    "lat": 46.50696000000001,
                    "lng": 16.227710000000002
                  },
                  {
                    "lat": 46.50672,
                    "lng": 16.22791
                  },
                  {
                    "lat": 46.506660000000004,
                    "lng": 16.22795
                  },
                  {
                    "lat": 46.506510000000006,
                    "lng": 16.22804
                  },
                  {
                    "lat": 46.50641,
                    "lng": 16.2281
                  },
                  {
                    "lat": 46.50621,
                    "lng": 16.22821
                  },
                  {
                    "lat": 46.506130000000006,
                    "lng": 16.22824
                  },
                  {
                    "lat": 46.50605,
                    "lng": 16.22829
                  },
                  {
                    "lat": 46.505970000000005,
                    "lng": 16.22833
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.50696000000001,
                    "lng": 16.227710000000002
                  },
                  {
                    "lat": 46.50672,
                    "lng": 16.22791
                  },
                  {
                    "lat": 46.506660000000004,
                    "lng": 16.22795
                  },
                  {
                    "lat": 46.506510000000006,
                    "lng": 16.22804
                  },
                  {
                    "lat": 46.50641,
                    "lng": 16.2281
                  },
                  {
                    "lat": 46.50621,
                    "lng": 16.22821
                  },
                  {
                    "lat": 46.506130000000006,
                    "lng": 16.22824
                  },
                  {
                    "lat": 46.50605,
                    "lng": 16.22829
                  },
                  {
                    "lat": 46.505970000000005,
                    "lng": 16.22833
                  }
                ],
                "instructions": "Continue straight to stay on <b>Nunska Graba</b>",
                "start_point": {
                  "lat": 46.5069573,
                  "lng": 16.2277068
                },
                "end_point": {
                  "lat": 46.50596849999999,
                  "lng": 16.2283278
                }
              },
              {
                "distance": {
                  "text": "0.3 km",
                  "value": 334
                },
                "duration": {
                  "text": "1 min",
                  "value": 38
                },
                "end_location": {
                  "lat": 46.5031611,
                  "lng": 16.2286604
                },
                "maneuver": "turn-right",
                "polyline": {
                  "points": "iezzGar`bBHB@@@?@@@?B@B@B@VHNFLBFA@?@A@?@A@A@ABA@A@CBCBABCHK@C@ABC@C@C@A?C@C@A@C@A@A@?@A@AB?@A@?@AJCVGFAD?B@D@B@BBDBBDDDDBD@D@D@F@R@D?F?\\?^?^@REB?ZQd@STGFAF@D@B@DB"
                },
                "start_location": {
                  "lat": 46.50596849999999,
                  "lng": 16.2283278
                },
                "travel_mode": "DRIVING",
                "encoded_lat_lngs": "iezzGar`bBHB@@@?@@@?B@B@B@VHNFLBFA@?@A@?@A@A@ABA@A@CBCBABCHK@C@ABC@C@C@A?C@C@A@C@A@A@?@A@AB?@A@?@AJCVGFAD?B@D@B@BBDBBDDDDBD@D@D@F@R@D?F?\\?^?^@REB?ZQd@STGFAF@D@B@DB",
                "path": [
                  {
                    "lat": 46.505970000000005,
                    "lng": 16.22833
                  },
                  {
                    "lat": 46.50592,
                    "lng": 16.22831
                  },
                  {
                    "lat": 46.50591000000001,
                    "lng": 16.2283
                  },
                  {
                    "lat": 46.505900000000004,
                    "lng": 16.2283
                  },
                  {
                    "lat": 46.50589,
                    "lng": 16.22829
                  },
                  {
                    "lat": 46.505880000000005,
                    "lng": 16.22829
                  },
                  {
                    "lat": 46.505860000000006,
                    "lng": 16.22828
                  },
                  {
                    "lat": 46.505840000000006,
                    "lng": 16.228270000000002
                  },
                  {
                    "lat": 46.50582000000001,
                    "lng": 16.228260000000002
                  },
                  {
                    "lat": 46.505700000000004,
                    "lng": 16.22821
                  },
                  {
                    "lat": 46.50562,
                    "lng": 16.228170000000002
                  },
                  {
                    "lat": 46.50555000000001,
                    "lng": 16.228150000000003
                  },
                  {
                    "lat": 46.50551,
                    "lng": 16.228160000000003
                  },
                  {
                    "lat": 46.505500000000005,
                    "lng": 16.228160000000003
                  },
                  {
                    "lat": 46.50549,
                    "lng": 16.228170000000002
                  },
                  {
                    "lat": 46.505480000000006,
                    "lng": 16.228170000000002
                  },
                  {
                    "lat": 46.50547,
                    "lng": 16.228180000000002
                  },
                  {
                    "lat": 46.50546000000001,
                    "lng": 16.22819
                  },
                  {
                    "lat": 46.50545,
                    "lng": 16.2282
                  },
                  {
                    "lat": 46.505430000000004,
                    "lng": 16.22821
                  },
                  {
                    "lat": 46.50542,
                    "lng": 16.22822
                  },
                  {
                    "lat": 46.505410000000005,
                    "lng": 16.22824
                  },
                  {
                    "lat": 46.505390000000006,
                    "lng": 16.228260000000002
                  },
                  {
                    "lat": 46.505370000000006,
                    "lng": 16.228270000000002
                  },
                  {
                    "lat": 46.50535000000001,
                    "lng": 16.22829
                  },
                  {
                    "lat": 46.505300000000005,
                    "lng": 16.228350000000002
                  },
                  {
                    "lat": 46.50529,
                    "lng": 16.22837
                  },
                  {
                    "lat": 46.505280000000006,
                    "lng": 16.22838
                  },
                  {
                    "lat": 46.50526000000001,
                    "lng": 16.2284
                  },
                  {
                    "lat": 46.505250000000004,
                    "lng": 16.22842
                  },
                  {
                    "lat": 46.50524,
                    "lng": 16.228440000000003
                  },
                  {
                    "lat": 46.505230000000005,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.505230000000005,
                    "lng": 16.22847
                  },
                  {
                    "lat": 46.50522,
                    "lng": 16.22849
                  },
                  {
                    "lat": 46.505210000000005,
                    "lng": 16.2285
                  },
                  {
                    "lat": 46.5052,
                    "lng": 16.22852
                  },
                  {
                    "lat": 46.505190000000006,
                    "lng": 16.228530000000003
                  },
                  {
                    "lat": 46.50518,
                    "lng": 16.228540000000002
                  },
                  {
                    "lat": 46.50517000000001,
                    "lng": 16.228540000000002
                  },
                  {
                    "lat": 46.505160000000004,
                    "lng": 16.228550000000002
                  },
                  {
                    "lat": 46.50515,
                    "lng": 16.22856
                  },
                  {
                    "lat": 46.50513,
                    "lng": 16.22856
                  },
                  {
                    "lat": 46.505120000000005,
                    "lng": 16.22857
                  },
                  {
                    "lat": 46.50511,
                    "lng": 16.22857
                  },
                  {
                    "lat": 46.505100000000006,
                    "lng": 16.22858
                  },
                  {
                    "lat": 46.50504,
                    "lng": 16.2286
                  },
                  {
                    "lat": 46.504920000000006,
                    "lng": 16.228640000000002
                  },
                  {
                    "lat": 46.50488000000001,
                    "lng": 16.228650000000002
                  },
                  {
                    "lat": 46.504850000000005,
                    "lng": 16.228650000000002
                  },
                  {
                    "lat": 46.504830000000005,
                    "lng": 16.228640000000002
                  },
                  {
                    "lat": 46.5048,
                    "lng": 16.228630000000003
                  },
                  {
                    "lat": 46.504780000000004,
                    "lng": 16.228620000000003
                  },
                  {
                    "lat": 46.504760000000005,
                    "lng": 16.2286
                  },
                  {
                    "lat": 46.50473,
                    "lng": 16.22858
                  },
                  {
                    "lat": 46.50471,
                    "lng": 16.228550000000002
                  },
                  {
                    "lat": 46.50468,
                    "lng": 16.22852
                  },
                  {
                    "lat": 46.504650000000005,
                    "lng": 16.2285
                  },
                  {
                    "lat": 46.50462,
                    "lng": 16.22849
                  },
                  {
                    "lat": 46.50459,
                    "lng": 16.22848
                  },
                  {
                    "lat": 46.504560000000005,
                    "lng": 16.22847
                  },
                  {
                    "lat": 46.50452000000001,
                    "lng": 16.228460000000002
                  },
                  {
                    "lat": 46.50442,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.50439,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.50435,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.504200000000004,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.50404,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.50388,
                    "lng": 16.228440000000003
                  },
                  {
                    "lat": 46.503780000000006,
                    "lng": 16.22847
                  },
                  {
                    "lat": 46.50376000000001,
                    "lng": 16.22847
                  },
                  {
                    "lat": 46.503620000000005,
                    "lng": 16.22856
                  },
                  {
                    "lat": 46.50343,
                    "lng": 16.22866
                  },
                  {
                    "lat": 46.50332,
                    "lng": 16.2287
                  },
                  {
                    "lat": 46.503280000000004,
                    "lng": 16.228710000000003
                  },
                  {
                    "lat": 46.503240000000005,
                    "lng": 16.2287
                  },
                  {
                    "lat": 46.50321,
                    "lng": 16.22869
                  },
                  {
                    "lat": 46.503190000000004,
                    "lng": 16.22868
                  },
                  {
                    "lat": 46.50316,
                    "lng": 16.22866
                  }
                ],
                "lat_lngs": [
                  {
                    "lat": 46.505970000000005,
                    "lng": 16.22833
                  },
                  {
                    "lat": 46.50592,
                    "lng": 16.22831
                  },
                  {
                    "lat": 46.50591000000001,
                    "lng": 16.2283
                  },
                  {
                    "lat": 46.505900000000004,
                    "lng": 16.2283
                  },
                  {
                    "lat": 46.50589,
                    "lng": 16.22829
                  },
                  {
                    "lat": 46.505880000000005,
                    "lng": 16.22829
                  },
                  {
                    "lat": 46.505860000000006,
                    "lng": 16.22828
                  },
                  {
                    "lat": 46.505840000000006,
                    "lng": 16.228270000000002
                  },
                  {
                    "lat": 46.50582000000001,
                    "lng": 16.228260000000002
                  },
                  {
                    "lat": 46.505700000000004,
                    "lng": 16.22821
                  },
                  {
                    "lat": 46.50562,
                    "lng": 16.228170000000002
                  },
                  {
                    "lat": 46.50555000000001,
                    "lng": 16.228150000000003
                  },
                  {
                    "lat": 46.50551,
                    "lng": 16.228160000000003
                  },
                  {
                    "lat": 46.505500000000005,
                    "lng": 16.228160000000003
                  },
                  {
                    "lat": 46.50549,
                    "lng": 16.228170000000002
                  },
                  {
                    "lat": 46.505480000000006,
                    "lng": 16.228170000000002
                  },
                  {
                    "lat": 46.50547,
                    "lng": 16.228180000000002
                  },
                  {
                    "lat": 46.50546000000001,
                    "lng": 16.22819
                  },
                  {
                    "lat": 46.50545,
                    "lng": 16.2282
                  },
                  {
                    "lat": 46.505430000000004,
                    "lng": 16.22821
                  },
                  {
                    "lat": 46.50542,
                    "lng": 16.22822
                  },
                  {
                    "lat": 46.505410000000005,
                    "lng": 16.22824
                  },
                  {
                    "lat": 46.505390000000006,
                    "lng": 16.228260000000002
                  },
                  {
                    "lat": 46.505370000000006,
                    "lng": 16.228270000000002
                  },
                  {
                    "lat": 46.50535000000001,
                    "lng": 16.22829
                  },
                  {
                    "lat": 46.505300000000005,
                    "lng": 16.228350000000002
                  },
                  {
                    "lat": 46.50529,
                    "lng": 16.22837
                  },
                  {
                    "lat": 46.505280000000006,
                    "lng": 16.22838
                  },
                  {
                    "lat": 46.50526000000001,
                    "lng": 16.2284
                  },
                  {
                    "lat": 46.505250000000004,
                    "lng": 16.22842
                  },
                  {
                    "lat": 46.50524,
                    "lng": 16.228440000000003
                  },
                  {
                    "lat": 46.505230000000005,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.505230000000005,
                    "lng": 16.22847
                  },
                  {
                    "lat": 46.50522,
                    "lng": 16.22849
                  },
                  {
                    "lat": 46.505210000000005,
                    "lng": 16.2285
                  },
                  {
                    "lat": 46.5052,
                    "lng": 16.22852
                  },
                  {
                    "lat": 46.505190000000006,
                    "lng": 16.228530000000003
                  },
                  {
                    "lat": 46.50518,
                    "lng": 16.228540000000002
                  },
                  {
                    "lat": 46.50517000000001,
                    "lng": 16.228540000000002
                  },
                  {
                    "lat": 46.505160000000004,
                    "lng": 16.228550000000002
                  },
                  {
                    "lat": 46.50515,
                    "lng": 16.22856
                  },
                  {
                    "lat": 46.50513,
                    "lng": 16.22856
                  },
                  {
                    "lat": 46.505120000000005,
                    "lng": 16.22857
                  },
                  {
                    "lat": 46.50511,
                    "lng": 16.22857
                  },
                  {
                    "lat": 46.505100000000006,
                    "lng": 16.22858
                  },
                  {
                    "lat": 46.50504,
                    "lng": 16.2286
                  },
                  {
                    "lat": 46.504920000000006,
                    "lng": 16.228640000000002
                  },
                  {
                    "lat": 46.50488000000001,
                    "lng": 16.228650000000002
                  },
                  {
                    "lat": 46.504850000000005,
                    "lng": 16.228650000000002
                  },
                  {
                    "lat": 46.504830000000005,
                    "lng": 16.228640000000002
                  },
                  {
                    "lat": 46.5048,
                    "lng": 16.228630000000003
                  },
                  {
                    "lat": 46.504780000000004,
                    "lng": 16.228620000000003
                  },
                  {
                    "lat": 46.504760000000005,
                    "lng": 16.2286
                  },
                  {
                    "lat": 46.50473,
                    "lng": 16.22858
                  },
                  {
                    "lat": 46.50471,
                    "lng": 16.228550000000002
                  },
                  {
                    "lat": 46.50468,
                    "lng": 16.22852
                  },
                  {
                    "lat": 46.504650000000005,
                    "lng": 16.2285
                  },
                  {
                    "lat": 46.50462,
                    "lng": 16.22849
                  },
                  {
                    "lat": 46.50459,
                    "lng": 16.22848
                  },
                  {
                    "lat": 46.504560000000005,
                    "lng": 16.22847
                  },
                  {
                    "lat": 46.50452000000001,
                    "lng": 16.228460000000002
                  },
                  {
                    "lat": 46.50442,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.50439,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.50435,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.504200000000004,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.50404,
                    "lng": 16.228450000000002
                  },
                  {
                    "lat": 46.50388,
                    "lng": 16.228440000000003
                  },
                  {
                    "lat": 46.503780000000006,
                    "lng": 16.22847
                  },
                  {
                    "lat": 46.50376000000001,
                    "lng": 16.22847
                  },
                  {
                    "lat": 46.503620000000005,
                    "lng": 16.22856
                  },
                  {
                    "lat": 46.50343,
                    "lng": 16.22866
                  },
                  {
                    "lat": 46.50332,
                    "lng": 16.2287
                  },
                  {
                    "lat": 46.503280000000004,
                    "lng": 16.228710000000003
                  },
                  {
                    "lat": 46.503240000000005,
                    "lng": 16.2287
                  },
                  {
                    "lat": 46.50321,
                    "lng": 16.22869
                  },
                  {
                    "lat": 46.503190000000004,
                    "lng": 16.22868
                  },
                  {
                    "lat": 46.50316,
                    "lng": 16.22866
                  }
                ],
                "instructions": "Turn <b>right</b> to stay on <b>Nunska Graba</b><div style=\"font-size:0.9em\">Destination will be on the left</div>",
                "start_point": {
                  "lat": 46.50596849999999,
                  "lng": 16.2283278
                },
                "end_point": {
                  "lat": 46.5031611,
                  "lng": 16.2286604
                }
              }
            ],
            "traffic_speed_entry": [],
            "via_waypoint": [],
            "via_waypoints": []
          }
        ],
        "overview_polyline": "{p_|Go|jaBs@}He@wFa@gP~@KbA_@hB]p@WfG}DtDeCn@MfEShCOvBWbB_@rBq@hBc@dE]vB[b@QvLiJpBqB|CyFnE{L`AeDVmBjA{UTmCDMBC?E?KGGC?c@EMIOg@WcAIwCg@{EWoCAiBBoFSwEIuBFaCPoCDcF?_HW{CGaDeCmNGWA{JEkc@AyFA_DJc@V]f@UfCaAhAMVERFtAd@nDt@r@BbDu@n@AtARdANhAIfBMxB`@bCGvBIzAQtAcAlAoAhDcDxAyB|AsCrDaFfCqC`AgAZm@lCsGbBoD~AaEfB_EpAiCjD{GtAsC|A}DFChAdAfA`AzBzBZj@Rp@Ah@B`@JLT@PSXWh@QzB]Z?pCx@hYnItLnDr@XDNHHVGHa@CSBaB?uEGqJBgEHcAf@iFXeCRCLQD[GYOQbB{Lf@sCfDkInIqTbB}DZk@H?LMBWCMP}@zDiKpBkF~AuDlB_Dx@aAvAqA|A{@xBs@rAK|EJjB]bB}@lGaGf^e]lK{JdG}FzCsCfBiBLEpLkLdE_EzCqCBDHFREHYAOrDqDvYoXjF}EBFJFVIFc@AIxGoGz@s@~AwAtFmF`KkJvCwCfPmOvPcPzEiEPCd@q@j@iAnBuHhAgFxByHlAeFXoBFyAFmChBLXNnApAv@p@x@~AzAzCVTzAp@~Af@hDt@p@@t@Kx@WpIoE|IoEfi@eXfeAyh@bmBu`AzO}Hj@[`@_CbDyQj@eCdA}AzBgCzCuE|BaCd@}Ab@eCh@iB|@aAjBmBvCgGrHwPb@oAp@t@x@x@l@Tp@Cl@]nBgD`BkC`B}AXOj@Kv@AvAXhAt@pC~BbAd@l@DlAXpDlAxA\\dAB~GWnH_AhGw@vC?rCZxDv@vHfBpCn@xBVz@EdAUzAs@dDcBv@c@ZSj@o@l@sARu@r@mBx@aAv@]~@KnCK|C^dEC~Ng@zBQ`CYjB[nA]xAq@zA_AnB_CfCcD`BcA~@YZ@^Vh@xAVbAx@~Bv@~BxCxJHnA?zCTtDEpBi@xEGfFYxI@pBh@fGt@bGJhBG`Cg@|F@pBRlBhCvO`AnD~DlLtBbI`CfKTxBBvDC\\UtA}@lDMvA?j@PlApA`D`FvKxCzDzAbCtAlChBpE`@zAd@lDVjCh@rCl@xAbBrDt@vBjAzE`@nBNnD?xC]fF@xBFz@Lv@dA|Cx@tBl@|B^tC@vDIlAfCn@VB`@Q~@{@~@i@lAUpCEf@QtBqAzAq@\\Av@XX?FE^a@^e@z@Oh@\\f@FjA?r@C^QjA[NF",
        "summary": "Predanovci",
        "warnings": [],
        "waypoint_order": [],
        "overview_path": [
          {
            "lat": 46.69726000000001,
            "lng": 16.11736
          },
          {
            "lat": 46.697520000000004,
            "lng": 16.11895
          },
          {
            "lat": 46.69771,
            "lng": 16.12019
          },
          {
            "lat": 46.697880000000005,
            "lng": 16.122950000000003
          },
          {
            "lat": 46.69756,
            "lng": 16.12301
          },
          {
            "lat": 46.69722,
            "lng": 16.123170000000002
          },
          {
            "lat": 46.696690000000004,
            "lng": 16.12332
          },
          {
            "lat": 46.69644,
            "lng": 16.123440000000002
          },
          {
            "lat": 46.69512,
            "lng": 16.124390000000002
          },
          {
            "lat": 46.694210000000005,
            "lng": 16.12506
          },
          {
            "lat": 46.69397000000001,
            "lng": 16.125130000000002
          },
          {
            "lat": 46.69297,
            "lng": 16.125230000000002
          },
          {
            "lat": 46.692280000000004,
            "lng": 16.125310000000002
          },
          {
            "lat": 46.691680000000005,
            "lng": 16.12543
          },
          {
            "lat": 46.69118,
            "lng": 16.125590000000003
          },
          {
            "lat": 46.6906,
            "lng": 16.12584
          },
          {
            "lat": 46.690070000000006,
            "lng": 16.12602
          },
          {
            "lat": 46.689080000000004,
            "lng": 16.126170000000002
          },
          {
            "lat": 46.688480000000006,
            "lng": 16.12631
          },
          {
            "lat": 46.688300000000005,
            "lng": 16.1264
          },
          {
            "lat": 46.6861,
            "lng": 16.128210000000003
          },
          {
            "lat": 46.68553000000001,
            "lng": 16.128780000000003
          },
          {
            "lat": 46.684740000000005,
            "lng": 16.13003
          },
          {
            "lat": 46.6837,
            "lng": 16.132250000000003
          },
          {
            "lat": 46.683370000000004,
            "lng": 16.13308
          },
          {
            "lat": 46.68325,
            "lng": 16.13363
          },
          {
            "lat": 46.68287,
            "lng": 16.13729
          },
          {
            "lat": 46.68276,
            "lng": 16.138
          },
          {
            "lat": 46.68273000000001,
            "lng": 16.138070000000003
          },
          {
            "lat": 46.68271000000001,
            "lng": 16.138090000000002
          },
          {
            "lat": 46.68271000000001,
            "lng": 16.13812
          },
          {
            "lat": 46.68271000000001,
            "lng": 16.138180000000002
          },
          {
            "lat": 46.682750000000006,
            "lng": 16.13822
          },
          {
            "lat": 46.682770000000005,
            "lng": 16.13822
          },
          {
            "lat": 46.682950000000005,
            "lng": 16.138250000000003
          },
          {
            "lat": 46.683020000000006,
            "lng": 16.1383
          },
          {
            "lat": 46.6831,
            "lng": 16.1385
          },
          {
            "lat": 46.683220000000006,
            "lng": 16.138840000000002
          },
          {
            "lat": 46.68327000000001,
            "lng": 16.1396
          },
          {
            "lat": 46.68347000000001,
            "lng": 16.140700000000002
          },
          {
            "lat": 46.68359,
            "lng": 16.14142
          },
          {
            "lat": 46.683600000000006,
            "lng": 16.14195
          },
          {
            "lat": 46.683580000000006,
            "lng": 16.143150000000002
          },
          {
            "lat": 46.68368,
            "lng": 16.14423
          },
          {
            "lat": 46.683730000000004,
            "lng": 16.144820000000003
          },
          {
            "lat": 46.683690000000006,
            "lng": 16.145470000000003
          },
          {
            "lat": 46.683600000000006,
            "lng": 16.14619
          },
          {
            "lat": 46.68357,
            "lng": 16.14733
          },
          {
            "lat": 46.68357,
            "lng": 16.148770000000003
          },
          {
            "lat": 46.683690000000006,
            "lng": 16.14955
          },
          {
            "lat": 46.683730000000004,
            "lng": 16.150360000000003
          },
          {
            "lat": 46.684400000000004,
            "lng": 16.15283
          },
          {
            "lat": 46.68444,
            "lng": 16.15295
          },
          {
            "lat": 46.684450000000005,
            "lng": 16.15485
          },
          {
            "lat": 46.68448,
            "lng": 16.16067
          },
          {
            "lat": 46.684490000000004,
            "lng": 16.161920000000002
          },
          {
            "lat": 46.68450000000001,
            "lng": 16.16272
          },
          {
            "lat": 46.68444,
            "lng": 16.1629
          },
          {
            "lat": 46.68432000000001,
            "lng": 16.163050000000002
          },
          {
            "lat": 46.68412000000001,
            "lng": 16.16316
          },
          {
            "lat": 46.683440000000004,
            "lng": 16.163490000000003
          },
          {
            "lat": 46.68307,
            "lng": 16.16356
          },
          {
            "lat": 46.682950000000005,
            "lng": 16.163590000000003
          },
          {
            "lat": 46.68285,
            "lng": 16.16355
          },
          {
            "lat": 46.68242,
            "lng": 16.16336
          },
          {
            "lat": 46.681540000000005,
            "lng": 16.16309
          },
          {
            "lat": 46.68128,
            "lng": 16.16307
          },
          {
            "lat": 46.680460000000004,
            "lng": 16.16334
          },
          {
            "lat": 46.680220000000006,
            "lng": 16.16335
          },
          {
            "lat": 46.679790000000004,
            "lng": 16.16325
          },
          {
            "lat": 46.67944000000001,
            "lng": 16.16317
          },
          {
            "lat": 46.67907,
            "lng": 16.163220000000003
          },
          {
            "lat": 46.67855,
            "lng": 16.16329
          },
          {
            "lat": 46.67794000000001,
            "lng": 16.163120000000003
          },
          {
            "lat": 46.67728,
            "lng": 16.16316
          },
          {
            "lat": 46.676680000000005,
            "lng": 16.163210000000003
          },
          {
            "lat": 46.67622,
            "lng": 16.1633
          },
          {
            "lat": 46.675790000000006,
            "lng": 16.16364
          },
          {
            "lat": 46.6754,
            "lng": 16.16404
          },
          {
            "lat": 46.67455,
            "lng": 16.16486
          },
          {
            "lat": 46.6741,
            "lng": 16.165470000000003
          },
          {
            "lat": 46.67363,
            "lng": 16.166210000000003
          },
          {
            "lat": 46.67273,
            "lng": 16.167340000000003
          },
          {
            "lat": 46.672050000000006,
            "lng": 16.16807
          },
          {
            "lat": 46.67172,
            "lng": 16.16843
          },
          {
            "lat": 46.671580000000006,
            "lng": 16.168660000000003
          },
          {
            "lat": 46.67087,
            "lng": 16.17004
          },
          {
            "lat": 46.670370000000005,
            "lng": 16.170920000000002
          },
          {
            "lat": 46.66989,
            "lng": 16.17189
          },
          {
            "lat": 46.66937,
            "lng": 16.17285
          },
          {
            "lat": 46.668960000000006,
            "lng": 16.173540000000003
          },
          {
            "lat": 46.6681,
            "lng": 16.174960000000002
          },
          {
            "lat": 46.66767,
            "lng": 16.175700000000003
          },
          {
            "lat": 46.6672,
            "lng": 16.176650000000002
          },
          {
            "lat": 46.66716,
            "lng": 16.17667
          },
          {
            "lat": 46.666790000000006,
            "lng": 16.17632
          },
          {
            "lat": 46.666430000000005,
            "lng": 16.175990000000002
          },
          {
            "lat": 46.66581,
            "lng": 16.17537
          },
          {
            "lat": 46.665670000000006,
            "lng": 16.175150000000002
          },
          {
            "lat": 46.66557,
            "lng": 16.1749
          },
          {
            "lat": 46.665580000000006,
            "lng": 16.174690000000002
          },
          {
            "lat": 46.665560000000006,
            "lng": 16.17452
          },
          {
            "lat": 46.6655,
            "lng": 16.17445
          },
          {
            "lat": 46.66539,
            "lng": 16.17444
          },
          {
            "lat": 46.6653,
            "lng": 16.17454
          },
          {
            "lat": 46.66517,
            "lng": 16.174660000000003
          },
          {
            "lat": 46.66496,
            "lng": 16.174750000000003
          },
          {
            "lat": 46.66434,
            "lng": 16.1749
          },
          {
            "lat": 46.6642,
            "lng": 16.1749
          },
          {
            "lat": 46.663470000000004,
            "lng": 16.17461
          },
          {
            "lat": 46.65926,
            "lng": 16.17293
          },
          {
            "lat": 46.657070000000004,
            "lng": 16.172050000000002
          },
          {
            "lat": 46.65681000000001,
            "lng": 16.17192
          },
          {
            "lat": 46.656780000000005,
            "lng": 16.17184
          },
          {
            "lat": 46.65673,
            "lng": 16.17179
          },
          {
            "lat": 46.65661,
            "lng": 16.17183
          },
          {
            "lat": 46.656560000000006,
            "lng": 16.172
          },
          {
            "lat": 46.656580000000005,
            "lng": 16.1721
          },
          {
            "lat": 46.656560000000006,
            "lng": 16.17259
          },
          {
            "lat": 46.656560000000006,
            "lng": 16.17366
          },
          {
            "lat": 46.656600000000005,
            "lng": 16.175510000000003
          },
          {
            "lat": 46.656580000000005,
            "lng": 16.17651
          },
          {
            "lat": 46.656530000000004,
            "lng": 16.17685
          },
          {
            "lat": 46.656330000000004,
            "lng": 16.17802
          },
          {
            "lat": 46.656200000000005,
            "lng": 16.17869
          },
          {
            "lat": 46.6561,
            "lng": 16.178710000000002
          },
          {
            "lat": 46.65603,
            "lng": 16.178800000000003
          },
          {
            "lat": 46.656000000000006,
            "lng": 16.17894
          },
          {
            "lat": 46.656040000000004,
            "lng": 16.179070000000003
          },
          {
            "lat": 46.65612,
            "lng": 16.179160000000003
          },
          {
            "lat": 46.655620000000006,
            "lng": 16.18138
          },
          {
            "lat": 46.65542000000001,
            "lng": 16.18212
          },
          {
            "lat": 46.65458,
            "lng": 16.183780000000002
          },
          {
            "lat": 46.6529,
            "lng": 16.18723
          },
          {
            "lat": 46.65240000000001,
            "lng": 16.188180000000003
          },
          {
            "lat": 46.652260000000005,
            "lng": 16.1884
          },
          {
            "lat": 46.652210000000004,
            "lng": 16.1884
          },
          {
            "lat": 46.65214,
            "lng": 16.188470000000002
          },
          {
            "lat": 46.652120000000004,
            "lng": 16.18859
          },
          {
            "lat": 46.65214,
            "lng": 16.188660000000002
          },
          {
            "lat": 46.65205,
            "lng": 16.18897
          },
          {
            "lat": 46.65111,
            "lng": 16.19094
          },
          {
            "lat": 46.65054000000001,
            "lng": 16.192120000000003
          },
          {
            "lat": 46.65006,
            "lng": 16.19303
          },
          {
            "lat": 46.64951000000001,
            "lng": 16.193830000000002
          },
          {
            "lat": 46.64922000000001,
            "lng": 16.19416
          },
          {
            "lat": 46.64878,
            "lng": 16.194570000000002
          },
          {
            "lat": 46.64831,
            "lng": 16.19487
          },
          {
            "lat": 46.6477,
            "lng": 16.195130000000002
          },
          {
            "lat": 46.64728,
            "lng": 16.19519
          },
          {
            "lat": 46.646170000000005,
            "lng": 16.195130000000002
          },
          {
            "lat": 46.645630000000004,
            "lng": 16.19528
          },
          {
            "lat": 46.64513,
            "lng": 16.195590000000003
          },
          {
            "lat": 46.64378000000001,
            "lng": 16.19688
          },
          {
            "lat": 46.638780000000004,
            "lng": 16.201710000000002
          },
          {
            "lat": 46.636790000000005,
            "lng": 16.20361
          },
          {
            "lat": 46.63548,
            "lng": 16.204880000000003
          },
          {
            "lat": 46.6347,
            "lng": 16.20562
          },
          {
            "lat": 46.63418,
            "lng": 16.20615
          },
          {
            "lat": 46.63411000000001,
            "lng": 16.20618
          },
          {
            "lat": 46.63194000000001,
            "lng": 16.20832
          },
          {
            "lat": 46.630950000000006,
            "lng": 16.20928
          },
          {
            "lat": 46.63017000000001,
            "lng": 16.21001
          },
          {
            "lat": 46.63015,
            "lng": 16.20998
          },
          {
            "lat": 46.630100000000006,
            "lng": 16.20994
          },
          {
            "lat": 46.63,
            "lng": 16.209970000000002
          },
          {
            "lat": 46.62995,
            "lng": 16.2101
          },
          {
            "lat": 46.629960000000004,
            "lng": 16.21018
          },
          {
            "lat": 46.62906,
            "lng": 16.211070000000003
          },
          {
            "lat": 46.62478,
            "lng": 16.21515
          },
          {
            "lat": 46.6236,
            "lng": 16.216260000000002
          },
          {
            "lat": 46.623580000000004,
            "lng": 16.21622
          },
          {
            "lat": 46.623520000000006,
            "lng": 16.21618
          },
          {
            "lat": 46.623400000000004,
            "lng": 16.216230000000003
          },
          {
            "lat": 46.623360000000005,
            "lng": 16.21641
          },
          {
            "lat": 46.62337,
            "lng": 16.21646
          },
          {
            "lat": 46.62196,
            "lng": 16.21782
          },
          {
            "lat": 46.621660000000006,
            "lng": 16.21808
          },
          {
            "lat": 46.62118,
            "lng": 16.21852
          },
          {
            "lat": 46.61995,
            "lng": 16.219710000000003
          },
          {
            "lat": 46.61802,
            "lng": 16.22153
          },
          {
            "lat": 46.61726,
            "lng": 16.22229
          },
          {
            "lat": 46.61450000000001,
            "lng": 16.22492
          },
          {
            "lat": 46.61166,
            "lng": 16.22766
          },
          {
            "lat": 46.61056000000001,
            "lng": 16.22867
          },
          {
            "lat": 46.61047000000001,
            "lng": 16.22869
          },
          {
            "lat": 46.61028,
            "lng": 16.22894
          },
          {
            "lat": 46.610060000000004,
            "lng": 16.22931
          },
          {
            "lat": 46.609500000000004,
            "lng": 16.23086
          },
          {
            "lat": 46.60913,
            "lng": 16.232020000000002
          },
          {
            "lat": 46.608520000000006,
            "lng": 16.233590000000003
          },
          {
            "lat": 46.60813,
            "lng": 16.234740000000002
          },
          {
            "lat": 46.608000000000004,
            "lng": 16.235300000000002
          },
          {
            "lat": 46.607960000000006,
            "lng": 16.235750000000003
          },
          {
            "lat": 46.60792000000001,
            "lng": 16.23646
          },
          {
            "lat": 46.60739,
            "lng": 16.23639
          },
          {
            "lat": 46.607260000000004,
            "lng": 16.23631
          },
          {
            "lat": 46.606860000000005,
            "lng": 16.2359
          },
          {
            "lat": 46.60658,
            "lng": 16.23565
          },
          {
            "lat": 46.60629,
            "lng": 16.23517
          },
          {
            "lat": 46.605830000000005,
            "lng": 16.23439
          },
          {
            "lat": 46.60571,
            "lng": 16.234280000000002
          },
          {
            "lat": 46.605250000000005,
            "lng": 16.23403
          },
          {
            "lat": 46.60477,
            "lng": 16.23383
          },
          {
            "lat": 46.60392,
            "lng": 16.23356
          },
          {
            "lat": 46.60367,
            "lng": 16.23355
          },
          {
            "lat": 46.6034,
            "lng": 16.233610000000002
          },
          {
            "lat": 46.60311,
            "lng": 16.23373
          },
          {
            "lat": 46.601420000000005,
            "lng": 16.23477
          },
          {
            "lat": 46.59967,
            "lng": 16.23581
          },
          {
            "lat": 46.59291,
            "lng": 16.23984
          },
          {
            "lat": 46.58167,
            "lng": 16.24653
          },
          {
            "lat": 46.56405,
            "lng": 16.25704
          },
          {
            "lat": 46.561350000000004,
            "lng": 16.25863
          },
          {
            "lat": 46.561130000000006,
            "lng": 16.258770000000002
          },
          {
            "lat": 46.56096,
            "lng": 16.259410000000003
          },
          {
            "lat": 46.560140000000004,
            "lng": 16.262420000000002
          },
          {
            "lat": 46.559920000000005,
            "lng": 16.263090000000002
          },
          {
            "lat": 46.55957,
            "lng": 16.263560000000002
          },
          {
            "lat": 46.55895,
            "lng": 16.26424
          },
          {
            "lat": 46.558170000000004,
            "lng": 16.265310000000003
          },
          {
            "lat": 46.55754,
            "lng": 16.26596
          },
          {
            "lat": 46.55735000000001,
            "lng": 16.26643
          },
          {
            "lat": 46.557170000000006,
            "lng": 16.267100000000003
          },
          {
            "lat": 46.556960000000004,
            "lng": 16.26763
          },
          {
            "lat": 46.556650000000005,
            "lng": 16.267960000000002
          },
          {
            "lat": 46.556110000000004,
            "lng": 16.268510000000003
          },
          {
            "lat": 46.555350000000004,
            "lng": 16.269830000000002
          },
          {
            "lat": 46.553810000000006,
            "lng": 16.27267
          },
          {
            "lat": 46.553630000000005,
            "lng": 16.27307
          },
          {
            "lat": 46.553380000000004,
            "lng": 16.2728
          },
          {
            "lat": 46.553090000000005,
            "lng": 16.27251
          },
          {
            "lat": 46.55286,
            "lng": 16.2724
          },
          {
            "lat": 46.55261,
            "lng": 16.27242
          },
          {
            "lat": 46.55238000000001,
            "lng": 16.27257
          },
          {
            "lat": 46.551820000000006,
            "lng": 16.273410000000002
          },
          {
            "lat": 46.55133000000001,
            "lng": 16.27411
          },
          {
            "lat": 46.55084,
            "lng": 16.27458
          },
          {
            "lat": 46.55071,
            "lng": 16.27466
          },
          {
            "lat": 46.55049,
            "lng": 16.274720000000002
          },
          {
            "lat": 46.55021000000001,
            "lng": 16.27473
          },
          {
            "lat": 46.54977,
            "lng": 16.274600000000003
          },
          {
            "lat": 46.549400000000006,
            "lng": 16.274330000000003
          },
          {
            "lat": 46.54867,
            "lng": 16.273690000000002
          },
          {
            "lat": 46.54833000000001,
            "lng": 16.273500000000002
          },
          {
            "lat": 46.548100000000005,
            "lng": 16.27347
          },
          {
            "lat": 46.54771,
            "lng": 16.27334
          },
          {
            "lat": 46.546820000000004,
            "lng": 16.27295
          },
          {
            "lat": 46.54637,
            "lng": 16.2728
          },
          {
            "lat": 46.546020000000006,
            "lng": 16.27278
          },
          {
            "lat": 46.54458,
            "lng": 16.2729
          },
          {
            "lat": 46.543060000000004,
            "lng": 16.273220000000002
          },
          {
            "lat": 46.54173,
            "lng": 16.273500000000002
          },
          {
            "lat": 46.54097,
            "lng": 16.273500000000002
          },
          {
            "lat": 46.54023,
            "lng": 16.27336
          },
          {
            "lat": 46.539300000000004,
            "lng": 16.27308
          },
          {
            "lat": 46.53774000000001,
            "lng": 16.272560000000002
          },
          {
            "lat": 46.53701,
            "lng": 16.27232
          },
          {
            "lat": 46.5364,
            "lng": 16.2722
          },
          {
            "lat": 46.536100000000005,
            "lng": 16.27223
          },
          {
            "lat": 46.53575000000001,
            "lng": 16.27234
          },
          {
            "lat": 46.53529,
            "lng": 16.2726
          },
          {
            "lat": 46.53446,
            "lng": 16.273100000000003
          },
          {
            "lat": 46.534180000000006,
            "lng": 16.27328
          },
          {
            "lat": 46.534040000000005,
            "lng": 16.273380000000003
          },
          {
            "lat": 46.533820000000006,
            "lng": 16.27362
          },
          {
            "lat": 46.533590000000004,
            "lng": 16.274040000000003
          },
          {
            "lat": 46.53349,
            "lng": 16.27431
          },
          {
            "lat": 46.53323,
            "lng": 16.27486
          },
          {
            "lat": 46.53294,
            "lng": 16.275190000000002
          },
          {
            "lat": 46.53266000000001,
            "lng": 16.27534
          },
          {
            "lat": 46.532340000000005,
            "lng": 16.2754
          },
          {
            "lat": 46.531620000000004,
            "lng": 16.275460000000002
          },
          {
            "lat": 46.53083,
            "lng": 16.2753
          },
          {
            "lat": 46.52984000000001,
            "lng": 16.27532
          },
          {
            "lat": 46.527280000000005,
            "lng": 16.27552
          },
          {
            "lat": 46.52666000000001,
            "lng": 16.27561
          },
          {
            "lat": 46.52601000000001,
            "lng": 16.275740000000003
          },
          {
            "lat": 46.525470000000006,
            "lng": 16.27588
          },
          {
            "lat": 46.52507000000001,
            "lng": 16.276030000000002
          },
          {
            "lat": 46.524620000000006,
            "lng": 16.27628
          },
          {
            "lat": 46.52416,
            "lng": 16.276600000000002
          },
          {
            "lat": 46.5236,
            "lng": 16.277240000000003
          },
          {
            "lat": 46.522920000000006,
            "lng": 16.27806
          },
          {
            "lat": 46.52243000000001,
            "lng": 16.2784
          },
          {
            "lat": 46.522110000000005,
            "lng": 16.27853
          },
          {
            "lat": 46.52197,
            "lng": 16.27852
          },
          {
            "lat": 46.52181,
            "lng": 16.2784
          },
          {
            "lat": 46.52160000000001,
            "lng": 16.27795
          },
          {
            "lat": 46.521480000000004,
            "lng": 16.277610000000003
          },
          {
            "lat": 46.521190000000004,
            "lng": 16.276970000000002
          },
          {
            "lat": 46.52091,
            "lng": 16.27633
          },
          {
            "lat": 46.520140000000005,
            "lng": 16.274440000000002
          },
          {
            "lat": 46.52009,
            "lng": 16.274040000000003
          },
          {
            "lat": 46.52009,
            "lng": 16.27326
          },
          {
            "lat": 46.519980000000004,
            "lng": 16.272350000000003
          },
          {
            "lat": 46.520010000000006,
            "lng": 16.27178
          },
          {
            "lat": 46.52022,
            "lng": 16.270690000000002
          },
          {
            "lat": 46.52026,
            "lng": 16.26953
          },
          {
            "lat": 46.520390000000006,
            "lng": 16.2678
          },
          {
            "lat": 46.52038,
            "lng": 16.26723
          },
          {
            "lat": 46.52017000000001,
            "lng": 16.26591
          },
          {
            "lat": 46.51990000000001,
            "lng": 16.26461
          },
          {
            "lat": 46.51984,
            "lng": 16.26408
          },
          {
            "lat": 46.51988,
            "lng": 16.26343
          },
          {
            "lat": 46.52008000000001,
            "lng": 16.26216
          },
          {
            "lat": 46.520070000000004,
            "lng": 16.26159
          },
          {
            "lat": 46.51997,
            "lng": 16.26104
          },
          {
            "lat": 46.51928,
            "lng": 16.25836
          },
          {
            "lat": 46.518950000000004,
            "lng": 16.25748
          },
          {
            "lat": 46.517990000000005,
            "lng": 16.25533
          },
          {
            "lat": 46.5174,
            "lng": 16.25371
          },
          {
            "lat": 46.51675,
            "lng": 16.25175
          },
          {
            "lat": 46.51664,
            "lng": 16.251140000000003
          },
          {
            "lat": 46.51662,
            "lng": 16.250220000000002
          },
          {
            "lat": 46.51664,
            "lng": 16.25007
          },
          {
            "lat": 46.51675,
            "lng": 16.249640000000003
          },
          {
            "lat": 46.51706,
            "lng": 16.24877
          },
          {
            "lat": 46.51713,
            "lng": 16.248330000000003
          },
          {
            "lat": 46.51713,
            "lng": 16.24811
          },
          {
            "lat": 46.51704,
            "lng": 16.24772
          },
          {
            "lat": 46.516630000000006,
            "lng": 16.24691
          },
          {
            "lat": 46.5155,
            "lng": 16.244870000000002
          },
          {
            "lat": 46.51473000000001,
            "lng": 16.243930000000002
          },
          {
            "lat": 46.51427,
            "lng": 16.243270000000003
          },
          {
            "lat": 46.51384,
            "lng": 16.24256
          },
          {
            "lat": 46.513310000000004,
            "lng": 16.24151
          },
          {
            "lat": 46.51314000000001,
            "lng": 16.24105
          },
          {
            "lat": 46.512950000000004,
            "lng": 16.240180000000002
          },
          {
            "lat": 46.51283,
            "lng": 16.23948
          },
          {
            "lat": 46.512620000000005,
            "lng": 16.23874
          },
          {
            "lat": 46.51239,
            "lng": 16.238290000000003
          },
          {
            "lat": 46.51189,
            "lng": 16.23739
          },
          {
            "lat": 46.51162,
            "lng": 16.236790000000003
          },
          {
            "lat": 46.51124,
            "lng": 16.23569
          },
          {
            "lat": 46.511070000000004,
            "lng": 16.23513
          },
          {
            "lat": 46.51099000000001,
            "lng": 16.234250000000003
          },
          {
            "lat": 46.51099000000001,
            "lng": 16.23348
          },
          {
            "lat": 46.511140000000005,
            "lng": 16.23232
          },
          {
            "lat": 46.51113,
            "lng": 16.23171
          },
          {
            "lat": 46.51109,
            "lng": 16.23141
          },
          {
            "lat": 46.51102,
            "lng": 16.23113
          },
          {
            "lat": 46.510670000000005,
            "lng": 16.23034
          },
          {
            "lat": 46.510380000000005,
            "lng": 16.229750000000003
          },
          {
            "lat": 46.51015,
            "lng": 16.22912
          },
          {
            "lat": 46.50999,
            "lng": 16.22837
          },
          {
            "lat": 46.509980000000006,
            "lng": 16.22745
          },
          {
            "lat": 46.51003,
            "lng": 16.22706
          },
          {
            "lat": 46.509350000000005,
            "lng": 16.22682
          },
          {
            "lat": 46.50923,
            "lng": 16.2268
          },
          {
            "lat": 46.509060000000005,
            "lng": 16.22689
          },
          {
            "lat": 46.50874,
            "lng": 16.22719
          },
          {
            "lat": 46.50842,
            "lng": 16.227400000000003
          },
          {
            "lat": 46.508030000000005,
            "lng": 16.227510000000002
          },
          {
            "lat": 46.5073,
            "lng": 16.22754
          },
          {
            "lat": 46.5071,
            "lng": 16.22763
          },
          {
            "lat": 46.506510000000006,
            "lng": 16.22804
          },
          {
            "lat": 46.50605,
            "lng": 16.22829
          },
          {
            "lat": 46.505900000000004,
            "lng": 16.2283
          },
          {
            "lat": 46.50562,
            "lng": 16.228170000000002
          },
          {
            "lat": 46.50549,
            "lng": 16.228170000000002
          },
          {
            "lat": 46.50545,
            "lng": 16.2282
          },
          {
            "lat": 46.50529,
            "lng": 16.22837
          },
          {
            "lat": 46.50513,
            "lng": 16.22856
          },
          {
            "lat": 46.504830000000005,
            "lng": 16.228640000000002
          },
          {
            "lat": 46.50462,
            "lng": 16.22849
          },
          {
            "lat": 46.50442,
            "lng": 16.228450000000002
          },
          {
            "lat": 46.50404,
            "lng": 16.228450000000002
          },
          {
            "lat": 46.503780000000006,
            "lng": 16.22847
          },
          {
            "lat": 46.503620000000005,
            "lng": 16.22856
          },
          {
            "lat": 46.503240000000005,
            "lng": 16.2287
          },
          {
            "lat": 46.50316,
            "lng": 16.22866
          }
        ]
      }
    ],
    "status": "OK",
    "request": {
      "destination": {
        "location": {
          "lat": 46.50307594,
          "lng": 16.22888167
        }
      },
      "origin": {
        "location": {
          "lat": 46.69407594,
          "lng": 16.11388167
        }
      },
      "travelMode": "DRIVING"
    }
  },
  "status": "OK"
}
